var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _g, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 579,
    height: 560,
    viewBox: "0 0 579 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00391 387.276V121.46L44.5315 96.3092L77.195 115.175V180.395L93.5208 170.962V145.823L109.859 136.39V40.7132L158.848 12.4262L180.624 24.9955V54.3677L202.399 41.7984L224.175 54.3677V108.843L245.939 121.388V69.1432L267.715 56.5739L294.94 72.2915V135.138L322.154 119.432V18.8659L354.817 0L392.919 22.0023V103.596L409.245 113.029V146.062L431.02 158.631V45.6264L458.234 29.9088L490.898 48.7628V75.6068L507.223 85.0278V157.546L528.999 170.115V121.054L561.663 102.2L578 111.621V387.276H1.00391Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 239.724L193.539 237.052V233.021L198.166 235.693V239.724Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 254.595L193.539 251.923V247.893L198.166 250.564V254.595Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 232.294L193.539 229.623V225.592L198.166 228.251V232.294Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 224.339L193.539 221.667V217.637L198.166 220.308V224.339Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 247.165L193.539 244.494V240.463L198.166 243.134V247.165Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 194.599L193.539 191.927V187.896L198.166 190.556V194.599Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 187.157L193.539 184.486V180.455L198.166 183.126V187.157Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 202.026L193.539 199.355V195.324L198.166 197.996V202.026Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 216.897L193.539 214.226V210.195L198.166 212.867V216.897Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 209.47L193.539 206.798V202.768L198.166 205.439V209.47Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 276.907L193.539 274.236V270.205L198.166 272.876V276.907Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 314.604L193.539 311.933V307.902L198.166 310.574V314.604Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 299.22L193.539 296.548V292.518L198.166 295.189V299.22Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 307.173L193.539 304.501V300.471L198.166 303.142V307.173Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 329.474L193.539 326.802V322.771L198.166 325.443V329.474Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 322.044L193.539 319.373V315.342L198.166 318.013V322.044Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 269.476L193.539 266.804V262.762L198.166 265.433V269.476Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 291.776L193.539 289.105V285.074L198.166 287.746V291.776Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 262.036L193.539 259.365V255.334L198.166 258.005V262.036Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 179.716L193.539 177.056V173.014L198.166 175.685V179.716Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 284.349L193.539 281.677V277.646L198.166 280.318V284.349Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 87.8427L193.539 85.1714V81.1406L198.166 83.8119V87.8427Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 80.4013L193.539 77.73V73.6992L198.166 76.3705V80.4013Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 72.9696L193.539 70.2983V66.2676L198.166 68.9389V72.9696Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 331.37L183.965 328.699V324.668L188.58 327.339V331.37Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 323.94L183.965 321.269V317.238L188.58 319.91V323.94Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 338.811L183.965 336.14V332.109L188.58 334.781V338.811Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 346.239L183.965 343.568V339.537L188.58 342.208V346.239Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 336.917L193.539 334.246V330.215L198.166 332.886V336.917Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 110.155L193.539 107.484V103.453L198.166 106.112V110.155Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 148.911L193.539 146.24V142.209L198.166 144.88V148.911Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 140.958L193.539 138.287V134.256L198.166 136.927V140.958Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 157.413L193.539 154.742V150.711L198.166 153.382V157.413Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 132.454L193.539 129.783V125.752L198.166 128.423V132.454Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 164.845L193.539 162.173V158.143L198.166 160.814V164.845Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 172.286L193.539 169.615V165.584L198.166 168.255V172.286Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 95.2704L193.539 92.6111V88.5684L198.166 91.2396V95.2704Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 102.714L193.539 100.042V96.0117L198.166 98.683V102.714Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 125.026L193.539 122.355V118.324L198.166 120.984V125.026Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 117.583L193.539 114.912V110.881L198.166 113.552V117.583Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 92.8268L113.031 90.1675V86.1367L117.646 88.7961V92.8268Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 228.419L113.031 225.759V221.717L117.646 224.388V228.419Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 220.989L113.031 218.318V214.287L117.646 216.958V220.989Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 213.546L113.031 210.886V206.844L117.646 209.515V213.546Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 235.858L113.031 233.187V229.156L117.646 231.828V235.858Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 243.302L113.031 240.63V236.6L117.646 239.259V243.302Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 167.872L113.031 165.201V161.17L117.646 163.829V167.872Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 183.806L113.031 181.134V177.104L117.646 179.775V183.806Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 206.118L113.031 203.447V199.416L117.646 202.087V206.118Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 176.364L113.031 173.705V169.674L117.646 172.333V176.364Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 191.247L113.031 188.576V184.545L117.646 187.204V191.247Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 251.243L113.031 248.584V244.541L117.646 247.212V251.243Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 198.677L113.031 196.005V191.975L117.646 194.646V198.677Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 310.739L113.031 308.068V304.037L117.646 306.708V310.739Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 303.298L113.031 300.638V296.596L117.646 299.267V303.298Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 326.124L113.031 323.465V319.422L117.646 322.093V326.124Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 295.868L113.031 293.197V289.166L117.646 291.837V295.868Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 318.181L113.031 315.509V311.479L117.646 314.138V318.181Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 273.556L113.031 270.884V266.854L117.646 269.525V273.556Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 288.427L113.031 285.767V281.725L117.646 284.396V288.427Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 266.126L113.031 263.455V259.424L117.646 262.083V266.126Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 258.684L113.031 256.013V251.982L117.646 254.654V258.684Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 280.997L113.031 278.326V274.295L117.646 276.966V280.997Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 100.268L113.031 97.5972V93.5664L117.646 96.2377V100.268Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 55.6552L113.031 52.9839V48.9531L117.646 51.6244V55.6552Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 160.433L113.031 157.761V153.73L117.646 156.402V160.433Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 63.0868L113.031 60.4155V56.3848L117.646 59.056V63.0868Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 77.956L113.031 75.2966V71.2539L117.646 73.9252V77.956Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 70.5263L113.031 67.855V63.8242L117.646 66.4955V70.5263Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 137.977L113.031 135.318V131.275L117.646 133.947V137.977Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 130.546L113.031 127.875V123.844L117.646 126.515V130.546Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 152.847L113.031 150.187V146.145L117.646 148.816V152.847Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 145.417L113.031 142.746V138.715L117.646 141.386V145.417Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 85.3974L113.031 82.7261V78.6953L117.646 81.3666V85.3974Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 122.581L113.031 119.91V115.879L117.646 118.55V122.581Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 344.356L193.539 341.685V337.654L198.166 340.314V344.356Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 316.499L183.965 313.828V309.797L188.58 312.468V316.499Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 107.71L113.031 105.039V101.008L117.646 103.667V107.71Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 115.14L113.031 112.468V108.438L117.646 111.109V115.14Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 70.1571L353.316 67.4858V63.4551L357.943 66.1264V70.1571Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 174.862L353.316 172.191V168.16L357.943 170.82V174.862Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 189.733L353.316 187.062V183.031L357.943 185.703V189.733Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 212.034L353.316 209.375V205.332L357.943 208.003V212.034Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 197.161L353.316 194.49V190.459L357.943 193.13V197.161Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 204.602L353.316 201.931V197.9L357.943 200.572V204.602Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 182.29L353.316 179.619V175.588L357.943 178.259V182.29Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 129.64L353.316 126.968V122.938L357.943 125.609V129.64Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 137.083L353.316 134.412V130.381L357.943 133.052V137.083Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 144.511L353.316 141.851V137.809L357.943 140.48V144.511Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 152.55L353.316 149.878V145.848L357.943 148.519V152.55Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 159.977L353.316 157.318V153.275L357.943 155.947V159.977Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 167.421L353.316 164.75V160.719L357.943 163.39V167.421Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 264.612L353.316 261.941V257.91L357.943 260.581V264.612Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 272.04L353.316 269.369V265.338L357.943 268.009V272.04Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 279.483L353.316 276.812V272.781L357.943 275.453V279.483Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 286.913L353.316 284.254V280.211L357.943 282.882V286.913Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 257.171L353.316 254.5V250.469L357.943 253.14V257.171Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 242.3L353.316 239.628V235.598L357.943 238.269V242.3Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 234.858L353.316 232.199V228.156L357.943 230.828V234.858Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 249.739L353.316 247.068V243.037L357.943 245.696V249.739Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 227.429L353.316 224.757V220.727L357.943 223.398V227.429Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 219.474L353.316 216.802V212.771L357.943 215.443V219.474Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 294.352L353.316 291.681V287.65L357.943 290.322V294.352Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 341.388L343.727 338.716V334.686L348.354 337.345V341.388Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 122.212L353.316 119.541V115.51L357.943 118.169V122.212Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 333.946L343.727 331.275V327.244L348.354 329.915V333.946Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 311.634L343.727 308.974V304.932L348.354 307.603V311.634Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 319.075L343.727 316.404V312.373L348.354 315.044V319.075Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 326.503L343.727 323.843V319.801L348.354 322.472V326.503Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 47.8446L353.316 45.1734V41.1426L357.943 43.8139V47.8446Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 99.8993L353.316 97.228V93.1973L357.943 95.8686V99.8993Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 92.4579L353.316 89.7986V85.7559L357.943 88.4271V92.4579Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 114.77L353.316 112.099V108.068L357.943 110.74V114.77Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 107.339L353.316 104.667V100.637L357.943 103.296V107.339Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 85.0282L353.316 82.3569V78.3262L357.943 80.9975V85.0282Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 62.7157L353.316 60.0444V56.0137L357.943 58.685V62.7157Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 77.5868L353.316 74.9155V70.8848L357.943 73.556V77.5868Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 55.286L353.316 52.6148V48.584L357.943 51.2433V55.286Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 333.565L113.031 330.894V326.863L117.646 329.535V333.565Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 189.052L183.965 186.38V182.35L188.58 185.021V189.052Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 196.483L183.965 193.824V189.781L188.58 192.453V196.483Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 302.308L353.316 299.636V295.605L357.943 298.277V302.308Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 211.364L183.965 208.693V204.662L188.58 207.321V211.364Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 218.796L183.965 216.125V212.094L188.58 214.765V218.796Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 226.749L183.965 224.078V220.047L188.58 222.718V226.749Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 166.739L183.965 164.068V160.037L188.58 162.708V166.739Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 159.311L183.965 156.64V152.609L188.58 155.269V159.311Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 151.87L183.965 149.199V145.168L188.58 147.839V151.87Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 174.183L183.965 171.511V167.48L188.58 170.152V174.183Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 181.61L183.965 178.939V174.908L188.58 177.579V181.61Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 286.245L183.965 283.574V279.531L188.58 282.203V286.245Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 234.179L183.965 231.519V227.477L188.58 230.148V234.179Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 293.675L183.965 291.003V286.973L188.58 289.644V293.675Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 271.362L183.965 268.691V264.66L188.58 267.331V271.362Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 301.63L183.965 298.959V294.928L188.58 297.599V301.63Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 278.802L183.965 276.13V272.1L188.58 274.771V278.802Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 241.62L183.965 238.949V234.918L188.58 237.589V241.62Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 263.933L183.965 261.261V257.23L188.58 259.902V263.933Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 249.061L183.965 246.39V242.359L188.58 245.031V249.061Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 256.489L183.965 253.818V249.787L188.58 252.458V256.489Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 203.923L183.965 201.251V197.221L188.58 199.892V203.923Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 346.921L353.316 344.249V340.219L357.943 342.89V346.921Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 339.491L353.316 336.82V332.789L357.943 335.46V339.491Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 309.058L183.965 306.398V302.355L188.58 305.027V309.058Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 143.366L183.965 140.695V136.664L188.58 139.335V143.366Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 317.179L353.316 314.507V310.477L357.943 313.148V317.179Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 324.62L353.316 321.949V317.918L357.943 320.577V324.62Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 332.05L353.316 329.378V325.348L357.943 328.019V332.05Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 309.737L353.316 307.078V303.035L357.943 305.706V309.737Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 112.04L183.965 109.381V105.338L188.58 108.009V112.04Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 119.479L183.965 116.808V112.777L188.58 115.449V119.479Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 126.909L183.965 124.25V120.219L188.58 122.878V126.909Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 135.413L183.965 132.742V128.711L188.58 131.382V135.413Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 104.608L183.965 101.937V97.9062L188.58 100.578V104.608Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 74.8663L183.965 72.195V68.1523L188.58 70.8236V74.8663Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 82.2958L183.965 79.6245V75.5938L188.58 78.265V82.2958Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 67.4267L183.965 64.7554V60.7246L188.58 63.3959V67.4267Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 97.1669L183.965 94.4956V90.4648L188.58 93.1361V97.1669Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M188.58 89.7392L183.965 87.0679V83.0371L188.58 85.7084V89.7392Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 332.358L24.4102 329.687V325.656L29.0253 328.328V332.358Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 341.005L113.031 338.334V334.303L117.646 336.962V341.005Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 296.559L14.8281 293.888V289.857L19.4552 292.529V296.559Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 311.944L14.8281 309.273V305.242L19.4552 307.913V311.944Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 289.118L14.8281 286.459V282.416L19.4552 285.087V289.118Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 319.384L14.8281 316.712V312.682L19.4552 315.353V319.384Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 274.247L14.8281 271.576V267.545L19.4552 270.216V274.247Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 251.934L14.8281 249.275V245.244L19.4552 247.903V251.934Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 259.378L14.8281 256.707V252.676L19.4552 255.347V259.378Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 266.817L14.8281 264.146V260.115L19.4552 262.775V266.817Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 326.815L14.8281 324.156V320.125L19.4552 322.784V326.815Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 341.696L14.8281 339.025V334.994L19.4552 337.653V341.696Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 349.128L14.8281 346.457V342.426L19.4552 345.097V349.128Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 334.257L14.8281 331.585V327.555L19.4552 330.226V334.257Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 244.505L14.8281 241.833V237.803L19.4552 240.474V244.505Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 281.69L14.8281 279.019V274.988L19.4552 277.66V281.69Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 237.065L14.8281 234.406V230.363L19.4552 233.035V237.065Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 147.063L14.8281 144.392V140.361L19.4552 143.033V147.063Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 154.493L14.8281 151.822V147.791L19.4552 150.462V154.493Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 139.599L14.8281 136.927V132.896L19.4552 135.568V139.599Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 206.809L14.8281 204.138V200.107L19.4552 202.779V206.809Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 162.184L14.8281 159.525V155.482L19.4552 158.154V162.184Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 214.239L14.8281 211.568V207.537L19.4552 210.208V214.239Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 229.11L14.8281 226.451V222.408L19.4552 225.079V229.11Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 221.681L14.8281 219.009V214.979L19.4552 217.65V221.681Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 199.368L14.8281 196.697V192.666L19.4552 195.337V199.368Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 169.626L14.8281 166.955V162.924L19.4552 165.595V169.626Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 177.056L14.8281 174.396V170.354L19.4552 173.025V177.056Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 184.497L14.8281 181.826V177.795L19.4552 180.466V184.497Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 191.938L14.8281 189.267V185.236L19.4552 187.896V191.938Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 287.221L24.4102 284.562V280.531L29.0253 283.191V287.221Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 324.931L24.4102 322.259V318.229L29.0253 320.888V324.931Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 304.204L343.727 301.533V297.502L348.354 300.173V304.204Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 347.231L24.4102 344.572V340.529L29.0253 343.201V347.231Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 309.534L24.4102 306.863V302.832L29.0253 305.503V309.534Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 302.104L24.4102 299.433V295.402L29.0253 298.062V302.104Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 317.489L24.4102 314.818V310.787L29.0253 313.458V317.489Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 294.665L24.4102 291.994V287.963L29.0253 290.634V294.665Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 339.802L24.4102 337.13V333.1L29.0253 335.771V339.802Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 279.792L24.4102 277.121V273.09L29.0253 275.761V279.792Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 167.729L24.4102 165.058V161.027L29.0253 163.699V167.729Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 160.038L24.4102 157.367V153.336L29.0253 156.007V160.038Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 182.602L24.4102 179.931V175.9L29.0253 178.572V182.602Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 190.042L24.4102 187.371V183.34L29.0253 186.011V190.042Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 145.132L24.4102 142.472V138.43L29.0253 141.101V145.132Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 197.472L24.4102 194.8V190.77L29.0253 193.441V197.472Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 152.609L24.4102 149.937V145.895L29.0253 148.566V152.609Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 175.171L24.4102 172.5V168.469L29.0253 171.128V175.171Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 250.052L24.4102 247.38V243.35L29.0253 246.009V250.052Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 257.479L24.4102 254.808V250.777L29.0253 253.449V257.479Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 264.921L24.4102 262.25V258.219L29.0253 260.89V264.921Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 242.608L24.4102 239.937V235.906L29.0253 238.578V242.608Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 272.352L24.4102 269.693V265.65L29.0253 268.322V272.352Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 234.655L24.4102 231.984V227.953L29.0253 230.624V234.655Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 212.343L24.4102 209.683V205.641L29.0253 208.312V212.343Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 219.784L24.4102 217.113V213.082L29.0253 215.753V219.784Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 227.227L24.4102 224.556V220.525L29.0253 223.185V227.227Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0253 204.915L24.4102 202.244V198.213L29.0253 200.884V204.915Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 303.989L14.8281 301.33V297.287L19.4552 299.958V303.989Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 226.534L122.617 223.863V219.832L127.232 222.491V226.534Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 219.093L122.617 216.421V212.391L127.232 215.062V219.093Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 233.964L122.617 231.292V227.262L127.232 229.933V233.964Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 241.405L122.617 238.734V234.703L127.232 237.374V241.405Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 165.977L122.617 163.306V159.275L127.232 161.947V165.977Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 204.222L122.617 201.55V197.52L127.232 200.191V204.222Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 181.911L122.617 179.24V175.209L127.232 177.88V181.911Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 248.833L122.617 246.174V242.131L127.232 244.802V248.833Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 173.407L122.617 170.748V166.705L127.232 169.376V173.407Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 189.35L122.617 186.679V182.648L127.232 185.32V189.35Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 196.78L122.617 194.121V190.078L127.232 192.749V196.78Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 211.651L122.617 208.992V204.961L127.232 207.62V211.651Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 301.401L122.617 298.742V294.711L127.232 297.37V301.401Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 293.972L122.617 291.3V287.27L127.232 289.941V293.972Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 308.843L122.617 306.171V302.141L127.232 304.812V308.843Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 323.714L122.617 321.054V317.012L127.232 319.683V323.714Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 316.284L122.617 313.613V309.582L127.232 312.253V316.284Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 264.229L122.617 261.558V257.527L127.232 260.199V264.229Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 256.788L122.617 254.117V250.086L127.232 252.757V256.788Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 271.659L122.617 268.988V264.957L127.232 267.628V271.659Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 286.53L122.617 283.871V279.828L127.232 282.499V286.53Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 279.1L122.617 276.429V272.398L127.232 275.07V279.1Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 68.6298L122.617 65.9585V61.9277L127.232 64.599V68.6298Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 331.667L122.617 328.996V324.965L127.232 327.636V331.667Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M117.646 348.434L113.031 345.763V341.732L117.646 344.404V348.434Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 76.0612L122.617 73.4019V69.3711L127.232 72.0304V76.0612Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 158.391L122.617 155.72V151.689L127.232 154.361V158.391Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 136.081L122.617 133.421V129.391L127.232 132.05V136.081Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 128.114L122.617 125.455V121.412L127.232 124.083V128.114Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 143.522L122.617 140.851V136.82L127.232 139.492V143.522Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 120.684L122.617 118.013V113.982L127.232 116.654V120.684Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 150.964L122.617 148.292V144.262L127.232 146.921V150.964Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 90.9423L122.617 88.271V84.2402L127.232 86.8996V90.9423Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 83.5009L122.617 80.8296V76.7988L127.232 79.4701V83.5009Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 98.3739L122.617 95.7027V91.6719L127.232 94.3432V98.3739Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 105.813L122.617 103.142V99.1113L127.232 101.783V105.813Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 113.243L122.617 110.584V106.541L127.232 109.212V113.243Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 61.1884L122.617 58.5171V54.4863L127.232 57.1576V61.1884Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 253.831L5.23828 251.172V247.129L9.86532 249.8V253.831Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 208.706L5.23828 206.035V202.004L9.86532 204.663V208.706Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 268.702L5.23828 266.043V262L9.86532 264.671V268.702Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 276.143L5.23828 273.472V269.441L9.86532 272.113V276.143Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 283.585L5.23828 280.914V276.883L9.86532 279.542V283.585Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 246.403L5.23828 243.732V239.701L9.86532 242.372V246.403Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 216.136L5.23828 213.464V209.434L9.86532 212.105V216.136Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 238.96L5.23828 236.289V232.258L9.86532 234.929V238.96Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 223.577L5.23828 220.906V216.875L9.86532 219.546V223.577Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 231.53L5.23828 228.859V224.828L9.86532 227.487V231.53Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 261.272L5.23828 258.601V254.57L9.86532 257.242V261.272Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 336.153L5.23828 333.482V329.451L9.86532 332.122V336.153Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 291.015L5.23828 288.343V284.312L9.86532 286.984V291.015Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 328.71L5.23828 326.039V322.008L9.86532 324.679V328.71Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 343.581L5.23828 340.922V336.879L9.86532 339.55V343.581Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 298.456L5.23828 295.785V291.754L9.86532 294.425V298.456Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 306.409L5.23828 303.738V299.707L9.86532 302.366V306.409Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 339.11L122.617 336.439V332.408L127.232 335.08V339.11Z",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 321.28L5.23828 318.609V314.578L9.86532 317.249V321.28Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 313.841L5.23828 311.169V307.139L9.86532 309.81V313.841Z",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 201.265L5.23828 198.593V194.562L9.86532 197.234V201.265Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 346.54L122.617 343.869V339.838L127.232 342.509V346.54Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 178.952L5.23828 176.293V172.25L9.86532 174.921V178.952Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 171.522L5.23828 168.851V164.82L9.86532 167.48V171.522Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 164.081L5.23828 161.41V157.379L9.86532 160.05V164.081Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 186.393L5.23828 183.722V179.691L9.86532 182.363V186.393Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 193.823L5.23828 191.164V187.121L9.86532 189.792V193.823Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 134.052L5.23828 131.38V127.35L9.86532 130.021V134.052Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 156.651L5.23828 153.98V149.949L9.86532 152.609V156.651Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 141.516L5.23828 138.845V134.814L9.86532 137.486V141.516Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86532 148.96L5.23828 146.289V142.258L9.86532 144.917V148.96Z",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 304.801L549.746 307.46V303.429L554.361 300.758V304.801Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 91.1942L434.668 88.523V84.4922L439.295 87.1635V91.1942Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 98.6337L434.668 95.9624V91.9316L439.295 94.6029V98.6337Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 83.7626L434.668 81.0913V77.0605L439.295 79.7318V83.7626Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 106.063L434.668 103.392V99.3613L439.295 102.033V106.063Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 113.507L434.668 110.835V106.805L439.295 109.476V113.507Z",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 120.946L434.668 118.275V114.244L439.295 116.903V120.946Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 331.406L568.914 334.077V330.046L573.541 327.375V331.406Z",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 346.277L568.914 348.948V344.917L573.541 342.246V346.277Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 338.847L568.914 341.518V337.476L573.541 334.816V338.847Z",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 68.8815L434.668 66.2222V62.1914L439.295 64.8508V68.8815Z",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 76.3212L434.668 73.6499V69.6191L439.295 72.2904V76.3212Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 180.431L434.668 177.759V173.729L439.295 176.4V180.431Z",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 128.376L434.668 125.705V121.674L439.295 124.345V128.376Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 187.872L434.668 185.201V181.17L439.295 183.829V187.872Z",
    fill: "white"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 195.302L434.668 192.63V188.6L439.295 191.271V195.302Z",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 165.559L434.668 162.888V158.857L439.295 161.529V165.559Z",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 172.989L434.668 170.33V166.287L439.295 168.958V172.989Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 135.819L434.668 133.148V129.117L439.295 131.777V135.819Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 143.247L434.668 140.576V136.545L439.295 139.216V143.247Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 158.118L434.668 155.447V151.416L439.295 154.087V158.118Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 150.688L434.668 148.017V143.986L439.295 146.658V150.688Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 323.976L568.914 326.636V322.605L573.541 319.934V323.976Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 218.83L568.914 221.501V217.47L573.541 214.799V218.83Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 203.959L568.914 206.63V202.599L573.541 199.928V203.959Z",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 211.402L568.914 214.061V210.031L573.541 207.359V211.402Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 203.257L434.668 200.585V196.555L439.295 199.226V203.257Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 226.785L568.914 229.456V225.425L573.541 222.754V226.785Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 189.089L568.914 191.761V187.718L573.541 185.059V189.089Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 174.218L568.914 176.89V172.847L573.541 170.188V174.218Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 196.517L568.914 199.188V195.158L573.541 192.486V196.517Z",
    fill: "white"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 181.646L568.914 184.317V180.287L573.541 177.615V181.646Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 241.656L568.914 244.327V240.296L573.541 237.625V241.656Z",
    fill: "white"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 234.214L568.914 236.886V232.855L573.541 230.184V234.214Z",
    fill: "white"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 286.269L568.914 288.94V284.91L573.541 282.238V286.269Z",
    fill: "white"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 166.777L568.914 169.448V165.417L573.541 162.746V166.777Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 301.664L568.914 304.335V300.304L573.541 297.633V301.664Z",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 309.105L568.914 311.765V307.734L573.541 305.062V309.105Z",
    fill: "white"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 249.097L568.914 251.768V247.726L573.541 245.066V249.097Z",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 316.535L568.914 319.206V315.175L573.541 312.504V316.535Z",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 256.527L568.914 259.198V255.167L573.541 252.496V256.527Z",
    fill: "white"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 263.968L568.914 266.64V262.609L573.541 259.938V263.968Z",
    fill: "white"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 271.396L568.914 274.067V270.037L573.541 267.365V271.396Z",
    fill: "white"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 278.839L568.914 281.511V277.48L573.541 274.809V278.839Z",
    fill: "white"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 293.709L568.914 296.38V292.349L573.541 289.678V293.709Z",
    fill: "white"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 141.35L444.258 138.691V134.648L448.885 137.32V141.35Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 133.921L444.258 131.25V127.219L448.885 129.89V133.921Z",
    fill: "white"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 148.794L444.258 146.123V142.092L448.885 144.763V148.794Z",
    fill: "white"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 156.222L444.258 153.562V149.52L448.885 152.191V156.222Z",
    fill: "white"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 163.663L444.258 160.992V156.961L448.885 159.632V163.663Z",
    fill: "white"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 96.7372L444.258 94.0659V90.0352L448.885 92.7064V96.7372Z",
    fill: "white"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 210.698L434.668 208.027V203.996L439.295 206.667V210.698Z",
    fill: "white"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 126.481L444.258 123.81V119.779L448.885 122.451V126.481Z",
    fill: "white"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 171.106L444.258 168.435V164.404L448.885 167.064V171.106Z",
    fill: "white"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 119.05L444.258 116.378V112.348L448.885 115.019V119.05Z",
    fill: "white"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 111.608L444.258 108.937V104.906L448.885 107.578V111.608Z",
    fill: "white"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 231.112L444.258 228.441V224.41L448.885 227.07V231.112Z",
    fill: "white"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 216.231L444.258 213.572V209.529L448.885 212.201V216.231Z",
    fill: "white"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 223.673L444.258 221.001V216.971L448.885 219.642V223.673Z",
    fill: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 89.2978L444.258 86.6384V82.5957L448.885 85.267V89.2978Z",
    fill: "white"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 238.544L444.258 235.873V231.842L448.885 234.513V238.544Z",
    fill: "white"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 245.985L444.258 243.314V239.283L448.885 241.943V245.985Z",
    fill: "white"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 185.975L444.258 183.304V179.273L448.885 181.945V185.975Z",
    fill: "white"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 178.534L444.258 175.863V171.832L448.885 174.503V178.534Z",
    fill: "white"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 193.405L444.258 190.734V186.703L448.885 189.374V193.405Z",
    fill: "white"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 208.8L444.258 206.128V202.098L448.885 204.769V208.8Z",
    fill: "white"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 200.847L444.258 198.175V194.145L448.885 196.816V200.847Z",
    fill: "white"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 104.181L444.258 101.509V97.4668L448.885 100.138V104.181Z",
    fill: "white"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 285.575L434.668 282.904V278.873L439.295 281.544V285.575Z",
    fill: "white"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 81.8681L444.258 79.1968V75.166L448.885 77.8373V81.8681Z",
    fill: "white"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 270.183L434.668 267.511V263.48L439.295 266.152V270.183Z",
    fill: "white"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 247.87L434.668 245.21V241.18L439.295 243.839V247.87Z",
    fill: "white"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 278.136L434.668 275.464V271.434L439.295 274.105V278.136Z",
    fill: "white"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 262.751L434.668 260.08V256.049L439.295 258.708V262.751Z",
    fill: "white"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 225.569L434.668 222.898V218.867L439.295 221.538V225.569Z",
    fill: "white"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 218.126L434.668 215.455V211.424L439.295 214.095V218.126Z",
    fill: "white"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 232.997L434.668 230.338V226.295L439.295 228.966V232.997Z",
    fill: "white"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 240.438L434.668 237.767V233.736L439.295 236.408V240.438Z",
    fill: "white"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 255.309L434.668 252.638V248.607L439.295 251.279V255.309Z",
    fill: "white"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 345.059L434.668 342.388V338.357L439.295 341.029V345.059Z",
    fill: "white"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 337.632L434.668 334.96V330.93L439.295 333.589V337.632Z",
    fill: "white"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 74.4247L444.258 71.7534V67.7227L448.885 70.3939V74.4247Z",
    fill: "white"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 330.188L434.668 327.517V323.486L439.295 326.158V330.188Z",
    fill: "white"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 300.448L434.668 297.777V293.746L439.295 296.417V300.448Z",
    fill: "white"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 293.007L434.668 290.335V286.305L439.295 288.976V293.007Z",
    fill: "white"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 307.876L434.668 305.217V301.174L439.295 303.845V307.876Z",
    fill: "white"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 315.319L434.668 312.648V308.617L439.295 311.288V315.319Z",
    fill: "white"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 322.761L434.668 320.089V316.059L439.295 318.718V322.761Z",
    fill: "white"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 289.917L549.746 292.589V288.558L554.361 285.887V289.917Z",
    fill: "white"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 282.488L549.746 285.159V281.128L554.361 278.457V282.488Z",
    fill: "white"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 275.046L549.746 277.718V273.687L554.361 271.016V275.046Z",
    fill: "white"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 297.359L549.746 300.03V295.999L554.361 293.328V297.359Z",
    fill: "white"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 312.742L549.746 315.413V311.382L554.361 308.711V312.742Z",
    fill: "white"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 237.863L549.746 240.534V236.503L554.361 233.832V237.863Z",
    fill: "white"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 320.183L549.746 322.854V318.824L554.361 316.152V320.183Z",
    fill: "white"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 267.617L549.746 270.288V266.245L554.361 263.586V267.617Z",
    fill: "white"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 245.304L549.746 247.976V243.945L554.361 241.273V245.304Z",
    fill: "white"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 252.734L549.746 255.405V251.374L554.361 248.703V252.734Z",
    fill: "white"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 260.175L549.746 262.847V258.816L554.361 256.145V260.175Z",
    fill: "white"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 296.763L343.727 294.091V290.061L348.354 292.732V296.763Z",
    fill: "white"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 327.627L549.746 330.286V326.255L554.361 323.584V327.627Z",
    fill: "white"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 253.413L444.258 250.742V246.711L448.885 249.382V253.413Z",
    fill: "white"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 335.054L549.746 337.725V333.695L554.361 331.023V335.054Z",
    fill: "white"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 342.496L549.746 345.167V341.124L554.361 338.465V342.496Z",
    fill: "white"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 229.92L549.746 232.579V228.548L554.361 225.877V229.92Z",
    fill: "white"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 222.48L549.746 225.151V221.121L554.361 218.449V222.48Z",
    fill: "white"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 140.087L549.746 142.759V138.716L554.361 136.057V140.087Z",
    fill: "white"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 132.646L549.746 135.317V131.287L554.361 128.615V132.646Z",
    fill: "white"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 192.738L549.746 195.397V191.366L554.361 188.707V192.738Z",
    fill: "white"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 200.167L549.746 202.839V198.808L554.361 196.137V200.167Z",
    fill: "white"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 185.296L549.746 187.968V183.937L554.361 181.266V185.296Z",
    fill: "white"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 207.609L549.746 210.28V206.237L554.361 203.578V207.609Z",
    fill: "white"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 215.039L549.746 217.71V213.679L554.361 211.008V215.039Z",
    fill: "white"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 170.425L549.746 173.097V169.066L554.361 166.395V170.425Z",
    fill: "white"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 154.959L549.746 157.63V153.599L554.361 150.928V154.959Z",
    fill: "white"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 162.984L549.746 165.655V161.624L554.361 158.953V162.984Z",
    fill: "white"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 147.517L549.746 150.188V146.158L554.361 143.486V147.517Z",
    fill: "white"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M554.361 177.867L549.746 180.526V176.496L554.361 173.824V177.867Z",
    fill: "white"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 239.759L559.324 242.431V238.4L563.951 235.729V239.759Z",
    fill: "white"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 322.08L559.324 324.751V320.72L563.951 318.049V322.08Z",
    fill: "white"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 336.951L559.324 339.622V335.591L563.951 332.92V336.951Z",
    fill: "white"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 344.38L559.324 347.052V343.021L563.951 340.35V344.38Z",
    fill: "white"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 314.638L559.324 317.309V313.279L563.951 310.607V314.638Z",
    fill: "white"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 291.814L559.324 294.485V290.454L563.951 287.783V291.814Z",
    fill: "white"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 299.255L559.324 301.927V297.884L563.951 295.225V299.255Z",
    fill: "white"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 307.209L559.324 309.868V305.837L563.951 303.166V307.209Z",
    fill: "white"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 136.439L568.914 139.11V135.079L573.541 132.408V136.439Z",
    fill: "white"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 128.996L568.914 131.667V127.636L573.541 124.965V128.996Z",
    fill: "white"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 143.879L568.914 146.538V142.507L573.541 139.836V143.879Z",
    fill: "white"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 151.906L568.914 154.577V150.546L573.541 147.875V151.906Z",
    fill: "white"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 121.568L568.914 124.239V120.196L573.541 117.537V121.568Z",
    fill: "white"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 284.384L559.324 287.056V283.013L563.951 280.354V284.384Z",
    fill: "white"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 329.509L559.324 332.181V328.15L563.951 325.479V329.509Z",
    fill: "white"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 172.322L559.324 174.993V170.95L563.951 168.291V172.322Z",
    fill: "white"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 164.88L559.324 167.552V163.521L563.951 160.85V164.88Z",
    fill: "white"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 179.751L559.324 182.423V178.392L563.951 175.721V179.751Z",
    fill: "white"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 187.193L559.324 189.864V185.833L563.951 183.162V187.193Z",
    fill: "white"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 157.451L559.324 160.122V156.079L563.951 153.42V157.451Z",
    fill: "white"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 194.633L559.324 197.292V193.261L563.951 190.59V194.633Z",
    fill: "white"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 276.943L559.324 279.614V275.583L563.951 272.912V276.943Z",
    fill: "white"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 149.414L559.324 152.085V148.054L563.951 145.383V149.414Z",
    fill: "white"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 127.113L559.324 129.772V125.742L563.951 123.07V127.113Z",
    fill: "white"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 141.982L559.324 144.641V140.611L563.951 137.951V141.982Z",
    fill: "white"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 134.542L559.324 137.214V133.183L563.951 130.512V134.542Z",
    fill: "white"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 247.201L559.324 249.872V245.841L563.951 243.17V247.201Z",
    fill: "white"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M573.541 159.345L568.914 162.005V157.974L573.541 155.303V159.345Z",
    fill: "white"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 254.63L559.324 257.302V253.271L563.951 250.6V254.63Z",
    fill: "white"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 262.072L559.324 264.743V260.712L563.951 258.041V262.072Z",
    fill: "white"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 202.064L559.324 204.735V200.704L563.951 198.033V202.064Z",
    fill: "white"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 269.513L559.324 272.173V268.142L563.951 265.471V269.513Z",
    fill: "white"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 209.505L559.324 212.165V208.134L563.951 205.475V209.505Z",
    fill: "white"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 232.33L559.324 235.001V230.958L563.951 228.287V232.33Z",
    fill: "white"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 216.933L559.324 219.604V215.574L563.951 212.902V216.933Z",
    fill: "white"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M563.951 224.376L559.324 227.048V223.005L563.951 220.346V224.376Z",
    fill: "white"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 178.642L334.152 175.97V171.939L338.767 174.611V178.642Z",
    fill: "white"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 186.083L334.152 183.412V179.381L338.767 182.052V186.083Z",
    fill: "white"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 193.513L334.152 190.853V186.811L338.767 189.482V193.513Z",
    fill: "white"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 208.395L334.152 205.724V201.693L338.767 204.353V208.395Z",
    fill: "white"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 200.954L334.152 198.283V194.252L338.767 196.923V200.954Z",
    fill: "white"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 148.899L334.152 146.228V142.197L338.767 144.869V148.899Z",
    fill: "white"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 216.337L334.152 213.677V209.635L338.767 212.306V216.337Z",
    fill: "white"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 141.46L334.152 138.801V134.758L338.767 137.429V141.46Z",
    fill: "white"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 163.772L334.152 161.101V157.07L338.767 159.742V163.772Z",
    fill: "white"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 156.341L334.152 153.669V149.639L338.767 152.298V156.341Z",
    fill: "white"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 171.212L334.152 168.541V164.51L338.767 167.169V171.212Z",
    fill: "white"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 223.778L334.152 221.107V217.076L338.767 219.747V223.778Z",
    fill: "white"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 275.835L334.152 273.164V269.133L338.767 271.804V275.835Z",
    fill: "white"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 268.391L334.152 265.732V261.689L338.767 264.361V268.391Z",
    fill: "white"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 283.274L334.152 280.603V276.572L338.767 279.232V283.274Z",
    fill: "white"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 133.433L334.152 130.761V126.73L338.767 129.402V133.433Z",
    fill: "white"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 260.962L334.152 258.291V254.26L338.767 256.931V260.962Z",
    fill: "white"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 291.218L334.152 288.558V284.516L338.767 287.187V291.218Z",
    fill: "white"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 238.649L334.152 235.978V231.947L338.767 234.619V238.649Z",
    fill: "white"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 231.222L334.152 228.55V224.52L338.767 227.179V231.222Z",
    fill: "white"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 246.091L334.152 243.419V239.389L338.767 242.048V246.091Z",
    fill: "white"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 253.522L334.152 250.851V246.82L338.767 249.492V253.522Z",
    fill: "white"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 330.298L324.562 327.626V323.596L329.178 326.267V330.298Z",
    fill: "white"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 345.167L324.562 342.508V338.465L329.178 341.136V345.167Z",
    fill: "white"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 36.7546L334.152 34.0952V30.0645L338.767 32.7238V36.7546Z",
    fill: "white"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 337.737L324.562 335.066V331.035L329.178 333.706V337.737Z",
    fill: "white"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 44.1962L334.152 41.5249V37.4941L338.767 40.1654V44.1962Z",
    fill: "white"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 307.985L324.562 305.326V301.283L329.178 303.955V307.985Z",
    fill: "white"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 315.425L324.562 312.753V308.723L329.178 311.394V315.425Z",
    fill: "white"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 125.991L334.152 123.332V119.289L338.767 121.96V125.991Z",
    fill: "white"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 298.659L334.152 295.988V291.957L338.767 294.628V298.659Z",
    fill: "white"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 322.866L324.562 320.195V316.164L329.178 318.823V322.866Z",
    fill: "white"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 51.6356L334.152 48.9644V44.9336L338.767 47.6049V51.6356Z",
    fill: "white"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 88.8212L334.152 86.1499V82.1191L338.767 84.7785V88.8212Z",
    fill: "white"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 96.2489L334.152 93.5776V89.5469L338.767 92.2182V96.2489Z",
    fill: "white"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 118.561L334.152 115.89V111.859L338.767 114.531V118.561Z",
    fill: "white"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 111.12L334.152 108.449V104.418L338.767 107.089V111.12Z",
    fill: "white"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 103.69L334.152 101.019V96.9883L338.767 99.6476V103.69Z",
    fill: "white"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 66.5087L334.152 63.8374V59.8066L338.767 62.4779V66.5087Z",
    fill: "white"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 81.3778L334.152 78.7066V74.6758L338.767 77.3471V81.3778Z",
    fill: "white"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 59.0673L334.152 56.396V52.3652L338.767 55.0365V59.0673Z",
    fill: "white"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 73.9364L334.152 71.2651V67.2344L338.767 69.9057V73.9364Z",
    fill: "white"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 343.272L334.152 340.613V336.57L338.767 339.242V343.272Z",
    fill: "white"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 306.1L334.152 303.429V299.398L338.767 302.058V306.1Z",
    fill: "white"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 184.186L343.727 181.515V177.484L348.354 180.156V184.186Z",
    fill: "white"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 176.747L343.727 174.088V170.045L348.354 172.716V176.747Z",
    fill: "white"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 260.856L444.258 258.185V254.154L448.885 256.826V260.856Z",
    fill: "white"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 199.059L343.727 196.388V192.357L348.354 195.029V199.059Z",
    fill: "white"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 169.315L343.727 166.644V162.613L348.354 165.285V169.315Z",
    fill: "white"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 147.003L343.727 144.332V140.301L348.354 142.972V147.003Z",
    fill: "white"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 154.446L343.727 151.775V147.744L348.354 150.403V154.446Z",
    fill: "white"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 161.874L343.727 159.203V155.172L348.354 157.843V161.874Z",
    fill: "white"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 213.929L343.727 211.257V207.227L348.354 209.898V213.929Z",
    fill: "white"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 206.499L343.727 203.828V199.797L348.354 202.468V206.499Z",
    fill: "white"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 259.065L343.727 256.394V252.363L348.354 255.035V259.065Z",
    fill: "white"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 273.936L343.727 271.265V267.234L348.354 269.906V273.936Z",
    fill: "white"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 266.509L343.727 263.837V259.807L348.354 262.466V266.509Z",
    fill: "white"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 281.378L343.727 278.707V274.676L348.354 277.335V281.378Z",
    fill: "white"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 288.809L343.727 286.15V282.107L348.354 284.779V288.809Z",
    fill: "white"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 229.325L343.727 226.654V222.623L348.354 225.282V229.325Z",
    fill: "white"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 236.753L343.727 234.082V230.051L348.354 232.722V236.753Z",
    fill: "white"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 221.884L343.727 219.212V215.182L348.354 217.853V221.884Z",
    fill: "white"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 251.624L343.727 248.965V244.922L348.354 247.593V251.624Z",
    fill: "white"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 244.196L343.727 241.525V237.494L348.354 240.165V244.196Z",
    fill: "white"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 191.628L343.727 188.957V184.926L348.354 187.585V191.628Z",
    fill: "white"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 300.554L324.562 297.882V293.852L329.178 296.523V300.554Z",
    fill: "white"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 49.7411L343.727 47.0698V43.0391L348.354 45.7103V49.7411Z",
    fill: "white"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 42.2997L343.727 39.6284V35.5977L348.354 38.2689V42.2997Z",
    fill: "white"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 313.528L334.152 310.857V306.826L338.767 309.497V313.528Z",
    fill: "white"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 320.972L334.152 318.3V314.27L338.767 316.941V320.972Z",
    fill: "white"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 328.401L334.152 325.742V321.699L338.767 324.37V328.401Z",
    fill: "white"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M338.767 335.841L334.152 333.169V329.139L338.767 331.81V335.841Z",
    fill: "white"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 94.3524L343.727 91.6812V87.6504L348.354 90.3217V94.3524Z",
    fill: "white"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 101.796L343.727 99.1245V95.0938L348.354 97.765V101.796Z",
    fill: "white"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 109.224L343.727 106.564V102.521L348.354 105.193V109.224Z",
    fill: "white"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 131.536L343.727 128.865V124.834L348.354 127.505V131.536Z",
    fill: "white"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 124.096L343.727 121.437V117.406L348.354 120.066V124.096Z",
    fill: "white"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 116.665L343.727 113.994V109.963L348.354 112.634V116.665Z",
    fill: "white"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 86.9228L343.727 84.2515V80.2207L348.354 82.892V86.9228Z",
    fill: "white"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 64.6122L343.727 61.9409V57.9102L348.354 60.5814V64.6122Z",
    fill: "white"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 72.0538L343.727 69.3825V65.3398L348.354 68.0111V72.0538Z",
    fill: "white"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 57.1708L343.727 54.4995V50.4688L348.354 53.14V57.1708Z",
    fill: "white"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 79.4833L343.727 76.812V72.7812L348.354 75.4525V79.4833Z",
    fill: "white"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M348.354 138.977L343.727 136.306V132.275L348.354 134.935V138.977Z",
    fill: "white"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 176.638L453.848 173.966V169.936L458.475 172.607V176.638Z",
    fill: "white"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 184.081L453.848 181.41V177.379L458.475 180.05V184.081Z",
    fill: "white"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 191.509L453.848 188.849V184.807L458.475 187.478V191.509Z",
    fill: "white"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 198.95L453.848 196.279V192.248L458.475 194.919V198.95Z",
    fill: "white"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 206.393L453.848 203.722V199.691L458.475 202.351V206.393Z",
    fill: "white"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 139.456L453.848 136.796V132.766L458.475 135.425V139.456Z",
    fill: "white"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 146.897L453.848 144.226V140.195L458.475 142.867V146.897Z",
    fill: "white"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 214.347L453.848 211.675V207.645L458.475 210.304V214.347Z",
    fill: "white"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 169.21L453.848 166.539V162.508L458.475 165.179V169.21Z",
    fill: "white"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 154.337L453.848 151.666V147.635L458.475 150.294V154.337Z",
    fill: "white"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 293.112L324.562 290.441V286.41L329.178 289.081V293.112Z",
    fill: "white"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 273.831L453.848 271.16V267.129L458.475 269.8V273.831Z",
    fill: "white"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 221.774L453.848 219.103V215.072L458.475 217.744V221.774Z",
    fill: "white"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 266.387L453.848 263.728V259.697L458.475 262.357V266.387Z",
    fill: "white"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 289.226L453.848 286.554V282.512L458.475 285.183V289.226Z",
    fill: "white"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 281.272L453.848 278.601V274.57L458.475 277.23V281.272Z",
    fill: "white"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 258.96L453.848 256.289V252.258L458.475 254.929V258.96Z",
    fill: "white"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 132.024L453.848 129.353V125.322L458.475 127.994V132.024Z",
    fill: "white"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 236.647L453.848 233.976V229.945L458.475 232.617V236.647Z",
    fill: "white"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 229.218L453.848 226.546V222.516L458.475 225.187V229.218Z",
    fill: "white"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 244.087L453.848 241.416V237.385L458.475 240.056V244.087Z",
    fill: "white"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 251.518L453.848 248.859V244.816L458.475 247.488V251.518Z",
    fill: "white"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 328.294L444.258 325.623V321.592L448.885 324.263V328.294Z",
    fill: "white"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 124.585L453.848 121.926V117.883L458.475 120.554V124.585Z",
    fill: "white"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 313.423L444.258 310.751V306.721L448.885 309.392V313.423Z",
    fill: "white"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 305.993L444.258 303.322V299.291L448.885 301.95V305.993Z",
    fill: "white"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 296.655L453.848 293.984V289.953L458.475 292.624V296.655Z",
    fill: "white"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 320.862L444.258 318.191V314.16L448.885 316.819V320.862Z",
    fill: "white"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 275.725L444.258 273.054V269.023L448.885 271.695V275.725Z",
    fill: "white"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 335.735L444.258 333.064V329.033L448.885 331.704V335.735Z",
    fill: "white"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 268.284L444.258 265.625V261.582L448.885 264.253V268.284Z",
    fill: "white"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 291.11L444.258 288.451V284.408L448.885 287.08V291.11Z",
    fill: "white"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 283.681L444.258 281.009V276.979L448.885 279.65V283.681Z",
    fill: "white"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 298.55L444.258 295.878V291.848L448.885 294.519V298.55Z",
    fill: "white"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 94.8427L453.848 92.1714V88.1406L458.475 90.8119V94.8427Z",
    fill: "white"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 343.163L444.258 340.504V336.461L448.885 339.132V343.163Z",
    fill: "white"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 102.284L453.848 99.6128V95.582L458.475 98.2533V102.284Z",
    fill: "white"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 109.712L453.848 107.041V103.01L458.475 105.681V109.712Z",
    fill: "white"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 117.155L453.848 114.484V110.453L458.475 113.124V117.155Z",
    fill: "white"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 87.4011L453.848 84.7417V80.7109L458.475 83.3703V87.4011Z",
    fill: "white"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 79.9716L453.848 77.3003V73.2695L458.475 75.9408V79.9716Z",
    fill: "white"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 61.5477L434.668 58.8765V54.8457L439.295 57.517V61.5477Z",
    fill: "white"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M448.885 67.081L444.258 64.4216V60.3789L448.885 63.0502V67.081Z",
    fill: "white"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 72.6239L453.848 69.9526V65.9219L458.475 68.5932V72.6239Z",
    fill: "white"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 161.768L453.848 159.097V155.066L458.475 157.738V161.768Z",
    fill: "white"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 187.979L324.562 185.308V181.277L329.178 183.949V187.979Z",
    fill: "white"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 173.096L324.562 170.437V166.406L329.178 169.066V173.096Z",
    fill: "white"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 180.538L324.562 177.867V173.836L329.178 176.507V180.538Z",
    fill: "white"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 202.85L324.562 200.179V196.148L329.178 198.82V202.85Z",
    fill: "white"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 135.925L324.562 133.253V129.223L329.178 131.882V135.925Z",
    fill: "white"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 195.409L324.562 192.738V188.707L329.178 191.378V195.409Z",
    fill: "white"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 143.354L324.562 140.683V136.652L329.178 139.324V143.354Z",
    fill: "white"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 165.667L324.562 162.996V158.965L329.178 161.636V165.667Z",
    fill: "white"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 150.796L324.562 148.125V144.094L329.178 146.765V150.796Z",
    fill: "white"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 158.225L324.562 155.566V151.523L329.178 154.195V158.225Z",
    fill: "white"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 304.097L453.848 301.425V297.395L458.475 300.054V304.097Z",
    fill: "white"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 270.288L324.562 267.617V263.586L329.178 266.257V270.288Z",
    fill: "white"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 255.417L324.562 252.746V248.715L329.178 251.386V255.417Z",
    fill: "white"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 262.86L324.562 260.189V256.158L329.178 258.818V262.86Z",
    fill: "white"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 277.729L324.562 275.058V271.027L329.178 273.699V277.729Z",
    fill: "white"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 285.684L324.562 283.013V278.982L329.178 281.654V285.684Z",
    fill: "white"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 225.675L324.562 223.003V218.973L329.178 221.644V225.675Z",
    fill: "white"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 233.104L324.562 230.445V226.402L329.178 229.074V233.104Z",
    fill: "white"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 218.235L324.562 215.576V211.533L329.178 214.204V218.235Z",
    fill: "white"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 247.975L324.562 245.316V241.285L329.178 243.945V247.975Z",
    fill: "white"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 240.548L324.562 237.876V233.846L329.178 236.517V240.548Z",
    fill: "white"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 210.804L324.562 208.132V204.102L329.178 206.761V210.804Z",
    fill: "white"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 127.888L324.562 125.216V121.186L329.178 123.857V127.888Z",
    fill: "white"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 348.71L453.848 346.039V342.008L458.475 344.679V348.71Z",
    fill: "white"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 46.0927L324.562 43.4214V39.3906L329.178 42.0619V46.0927Z",
    fill: "white"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 38.6493L324.562 35.99V31.9473L329.178 34.6185V38.6493Z",
    fill: "white"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 31.2216L324.562 28.5503V24.5195L329.178 27.1908V31.2216Z",
    fill: "white"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 311.526L453.848 308.855V304.824L458.475 307.496V311.526Z",
    fill: "white"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 318.968L453.848 316.296V312.266L458.475 314.937V318.968Z",
    fill: "white"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 326.397L453.848 323.738V319.695L458.475 322.367V326.397Z",
    fill: "white"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 333.839L453.848 331.167V327.137L458.475 329.808V333.839Z",
    fill: "white"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M458.475 341.268L453.848 338.609V334.566L458.475 337.238V341.268Z",
    fill: "white"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 105.575L324.562 102.916V98.8848L329.178 101.544V105.575Z",
    fill: "white"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 90.704L324.562 88.0327V84.002L329.178 86.6732V90.704Z",
    fill: "white"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 98.1454L324.562 95.4741V91.4434L329.178 94.1146V98.1454Z",
    fill: "white"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 113.017L324.562 110.345V106.314L329.178 108.986V113.017Z",
    fill: "white"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 120.458L324.562 117.787V113.756L329.178 116.415V120.458Z",
    fill: "white"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 60.9618L324.562 58.2905V54.2598L329.178 56.931V60.9618Z",
    fill: "white"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 53.5323L324.562 50.8611V46.8184L329.178 49.4896V53.5323Z",
    fill: "white"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 68.4032L324.562 65.7319V61.7012L329.178 64.3724V68.4032Z",
    fill: "white"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 75.8329L324.562 73.1616V69.1309L329.178 71.8021V75.8329Z",
    fill: "white"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M329.178 83.2743L324.562 80.603V76.5723L329.178 79.2435V83.2743Z",
    fill: "white"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 105.457L157.18 108.128V104.097L161.795 101.426V105.457Z",
    fill: "#E6E6E6"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 98.0151L157.18 100.686V96.6557L161.795 93.9844V98.0151Z",
    fill: "#E6E6E6"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 112.896L157.18 115.556V111.525L161.795 108.854V112.896Z",
    fill: "#E6E6E6"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 121.091L157.18 123.763V119.732L161.795 117.061V121.091Z",
    fill: "#E6E6E6"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 128.531L157.18 131.202V127.171L161.795 124.5V128.531Z",
    fill: "#E6E6E6"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 75.3335L157.18 78.0048V73.974L161.795 71.3027V75.3335Z",
    fill: "#E6E6E6"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 218.365L157.18 221.036V216.993L161.795 214.334V218.365Z",
    fill: "#E6E6E6"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 60.4605L157.18 63.1317V59.101L161.795 56.4297V60.4605Z",
    fill: "#E6E6E6"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 67.9038L157.18 70.5632V66.5324L161.795 63.873V67.9038Z",
    fill: "#E6E6E6"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 135.972L157.18 138.632V134.601L161.795 131.93V135.972Z",
    fill: "#E6E6E6"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 82.773L157.18 85.4442V81.4015L161.795 78.7422V82.773Z",
    fill: "#E6E6E6"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 210.923L157.18 213.595V209.564L161.795 206.893V210.923Z",
    fill: "#E6E6E6"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 231.339L147.59 234.011V229.98L152.217 227.309V231.339Z",
    fill: "#E6E6E6"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 181.183L157.18 183.854V179.812L161.795 177.152V181.183Z",
    fill: "#E6E6E6"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 188.611L157.18 191.282V187.251L161.795 184.58V188.611Z",
    fill: "#E6E6E6"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 203.494L157.18 206.153V202.122L161.795 199.451V203.494Z",
    fill: "#E6E6E6"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 143.404L157.18 146.075V142.044L161.795 139.373V143.404Z",
    fill: "#E6E6E6"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 53.0329L157.18 55.6923V51.6615L161.795 48.9902V53.0329Z",
    fill: "#E6E6E6"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 150.843L157.18 153.503V149.472L161.795 146.801V150.843Z",
    fill: "#E6E6E6"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 158.273L157.18 160.944V156.913L161.795 154.242V158.273Z",
    fill: "#E6E6E6"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 166.31L157.18 168.981V164.939L161.795 162.279V166.31Z",
    fill: "#E6E6E6"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 173.742L157.18 176.413V172.382L161.795 169.711V173.742Z",
    fill: "#E6E6E6"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 90.5134L157.18 93.1728V89.142L161.795 86.4707V90.5134Z",
    fill: "#E6E6E6"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 276.478L147.59 279.149V275.107L152.217 272.447V276.478Z",
    fill: "#E6E6E6"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 283.908L147.59 286.579V282.548L152.217 279.877V283.908Z",
    fill: "#E6E6E6"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 291.347L147.59 294.018V289.976L152.217 287.316V291.347Z",
    fill: "#E6E6E6"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 269.035L147.59 271.706V267.675L152.217 265.004V269.035Z",
    fill: "#E6E6E6"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 298.779L147.59 301.45V297.419L152.217 294.748V298.779Z",
    fill: "#E6E6E6"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 238.781L147.59 241.44V237.41L152.217 234.738V238.781Z",
    fill: "#E6E6E6"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 306.22L147.59 308.891V304.861L152.217 302.189V306.22Z",
    fill: "#E6E6E6"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 246.736L147.59 249.395V245.365L152.217 242.693V246.736Z",
    fill: "#E6E6E6"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 254.166L147.59 256.837V252.806L152.217 250.135V254.166Z",
    fill: "#E6E6E6"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 261.607L147.59 264.266V260.236L152.217 257.564V261.607Z",
    fill: "#E6E6E6"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 329.044L147.59 331.716V327.685L152.217 325.014V329.044Z",
    fill: "#E6E6E6"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 313.66L147.59 316.319V312.288L152.217 309.617V313.66Z",
    fill: "#E6E6E6"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 343.916L147.59 346.587V342.556L152.217 339.885V343.916Z",
    fill: "#E6E6E6"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 45.5913L157.18 48.2626V44.2318L161.795 41.5605V45.5913Z",
    fill: "#E6E6E6"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 321.615L147.59 324.274V320.244L152.217 317.572V321.615Z",
    fill: "#E6E6E6"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 336.486L147.59 339.145V335.114L152.217 332.455V336.486Z",
    fill: "#E6E6E6"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 196.054L157.18 198.726V194.695L161.795 192.023V196.054Z",
    fill: "#E6E6E6"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 92.48L166.77 95.1393V91.1086L171.385 88.4492V92.48Z",
    fill: "#E6E6E6"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 99.9097L166.77 102.581V98.5502L171.385 95.8789V99.9097Z",
    fill: "#E6E6E6"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 107.353L166.77 110.024V105.982L171.385 103.322V107.353Z",
    fill: "#E6E6E6"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 130.429L166.77 133.1V129.07L171.385 126.398V130.429Z",
    fill: "#E6E6E6"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 115.556L166.77 118.228V114.185L171.385 111.514V115.556Z",
    fill: "#E6E6E6"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 54.9175L166.77 57.5888V53.558L171.385 50.8867V54.9175Z",
    fill: "#E6E6E6"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 69.7986L166.77 72.4579V68.4271L171.385 65.7559V69.7986Z",
    fill: "#E6E6E6"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 62.3569L166.77 65.0282V60.9974L171.385 58.3262V62.3569Z",
    fill: "#E6E6E6"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 77.23L166.77 79.9013V75.8705L171.385 73.1992V77.23Z",
    fill: "#E6E6E6"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 84.9683L166.77 87.6396V83.6088L171.385 80.9375V84.9683Z",
    fill: "#E6E6E6"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 122.986L166.77 125.657V121.626L171.385 118.955V122.986Z",
    fill: "#E6E6E6"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 190.507L166.77 193.179V189.148L171.385 186.477V190.507Z",
    fill: "#E6E6E6"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 175.636L166.77 178.308V174.277L171.385 171.605V175.636Z",
    fill: "#E6E6E6"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 183.078L166.77 185.749V181.706L171.385 179.047V183.078Z",
    fill: "#E6E6E6"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 197.949L166.77 200.62V196.577L171.385 193.918V197.949Z",
    fill: "#E6E6E6"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 137.857L166.77 140.528V136.497L171.385 133.826V137.857Z",
    fill: "#E6E6E6"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 205.378L166.77 208.05V204.019L171.385 201.348V205.378Z",
    fill: "#E6E6E6"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 152.74L166.77 155.399V151.369L171.385 148.697V152.74Z",
    fill: "#E6E6E6"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 145.298L166.77 147.97V143.939L171.385 141.268V145.298Z",
    fill: "#E6E6E6"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 168.207L166.77 170.866V166.835L171.385 164.164V168.207Z",
    fill: "#E6E6E6"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 160.767L166.77 163.438V159.408L171.385 156.736V160.767Z",
    fill: "#E6E6E6"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 278.373L157.18 281.032V277.001L161.795 274.33V278.373Z",
    fill: "#E6E6E6"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 270.933L157.18 273.604V269.574L161.795 266.902V270.933Z",
    fill: "#E6E6E6"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 263.504L157.18 266.163V262.132L161.795 259.461V263.504Z",
    fill: "#E6E6E6"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 285.804L157.18 288.475V284.445L161.795 281.773V285.804Z",
    fill: "#E6E6E6"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 300.673L157.18 303.345V299.314L161.795 296.643V300.673Z",
    fill: "#E6E6E6"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 293.246L157.18 295.917V291.874L161.795 289.215V293.246Z",
    fill: "#E6E6E6"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 233.236L157.18 235.907V231.864L161.795 229.205V233.236Z",
    fill: "#E6E6E6"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 256.06L157.18 258.731V254.701L161.795 252.029V256.06Z",
    fill: "#E6E6E6"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 241.191L157.18 243.862V239.82L161.795 237.16V241.191Z",
    fill: "#E6E6E6"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 248.621L157.18 251.292V247.261L161.795 244.59V248.621Z",
    fill: "#E6E6E6"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 330.941L157.18 333.612V329.569L161.795 326.91V330.941Z",
    fill: "#E6E6E6"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 345.812L157.18 348.483V344.453L161.795 341.781V345.812Z",
    fill: "#E6E6E6"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 40.0444L166.77 42.7157V38.6849L171.385 36.0137V40.0444Z",
    fill: "#E6E6E6"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 225.794L157.18 228.466V224.435L161.795 221.764V225.794Z",
    fill: "#E6E6E6"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 323.5L157.18 326.171V322.14L161.795 319.469V323.5Z",
    fill: "#E6E6E6"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 338.371L157.18 341.042V337.011L161.795 334.34V338.371Z",
    fill: "#E6E6E6"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 308.115L157.18 310.786V306.743L161.795 304.084V308.115Z",
    fill: "#E6E6E6"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M161.795 316.07L157.18 318.741V314.698L161.795 312.039V316.07Z",
    fill: "#E6E6E6"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 47.4859L166.77 50.1571V46.1264L171.385 43.4551V47.4859Z",
    fill: "#E6E6E6"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 342.019L138 344.69V340.66L142.627 337.988V342.019Z",
    fill: "#E6E6E6"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 123.976L138 126.647V122.617L142.627 119.945V123.976Z",
    fill: "#E6E6E6"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 132.181L138 134.852V130.81L142.627 128.15V132.181Z",
    fill: "#E6E6E6"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 139.609L138 142.28V138.249L142.627 135.578V139.609Z",
    fill: "#E6E6E6"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 147.052L138 149.724V145.693L142.627 143.021V147.052Z",
    fill: "#E6E6E6"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 116.535L138 119.206V115.175L142.627 112.504V116.535Z",
    fill: "#E6E6E6"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 93.853L138 96.5243V92.4935L142.627 89.8223V93.853Z",
    fill: "#E6E6E6"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 109.105L138 111.776V107.734L142.627 105.074V109.105Z",
    fill: "#E6E6E6"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 154.494L138 157.153V153.122L142.627 150.451V154.494Z",
    fill: "#E6E6E6"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 86.4233L138 89.0827V85.0519L142.627 82.3926V86.4233Z",
    fill: "#E6E6E6"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 101.591L138 104.263V100.232L142.627 97.5605V101.591Z",
    fill: "#E6E6E6"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 78.9819L138 81.6532V77.6224L142.627 74.9512V78.9819Z",
    fill: "#E6E6E6"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 161.921L138 164.593V160.562L142.627 157.891V161.921Z",
    fill: "#E6E6E6"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 207.132L138 209.804V205.773L142.627 203.102V207.132Z",
    fill: "#E6E6E6"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 229.445L138 232.116V228.085L142.627 225.414V229.445Z",
    fill: "#E6E6E6"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 199.703L138 202.374V198.331L142.627 195.672V199.703Z",
    fill: "#E6E6E6"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 222.015L138 224.675V220.644L142.627 217.973V222.015Z",
    fill: "#E6E6E6"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 214.572L138 217.243V213.212L142.627 210.541V214.572Z",
    fill: "#E6E6E6"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 192.259L138 194.931V190.9L142.627 188.229V192.259Z",
    fill: "#E6E6E6"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 169.365L138 172.024V167.994L142.627 165.322V169.365Z",
    fill: "#E6E6E6"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 177.39L138 180.061V176.031L142.627 173.359V177.39Z",
    fill: "#E6E6E6"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 184.832L138 187.503V183.46L142.627 180.801V184.832Z",
    fill: "#E6E6E6"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 71.5525L138 74.2118V70.1811L142.627 67.5098V71.5525Z",
    fill: "#E6E6E6"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 277.384L286.105 280.056V276.025L290.732 273.354V277.384Z",
    fill: "#E6E6E6"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 285.337L286.105 288.009V283.978L290.732 281.307V285.337Z",
    fill: "#E6E6E6"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 269.955L286.105 272.626V268.583L290.732 265.924V269.955Z",
    fill: "#E6E6E6"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 292.779L286.105 295.45V291.407L290.732 288.748V292.779Z",
    fill: "#E6E6E6"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 300.209L286.105 302.88V298.849L290.732 296.178V300.209Z",
    fill: "#E6E6E6"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 262.513L286.105 265.184V261.154L290.732 258.482V262.513Z",
    fill: "#E6E6E6"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 240.213L286.105 242.872V238.841L290.732 236.17V240.213Z",
    fill: "#E6E6E6"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 247.642L286.105 250.313V246.283L290.732 243.611V247.642Z",
    fill: "#E6E6E6"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 315.092L286.105 317.751V313.72L290.732 311.049V315.092Z",
    fill: "#E6E6E6"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 255.084L286.105 257.743V253.712L290.732 251.053V255.084Z",
    fill: "#E6E6E6"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 236.884L138 239.544V235.513L142.627 232.854V236.884Z",
    fill: "#E6E6E6"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 223.898L147.59 226.569V222.538L152.217 219.867V223.898Z",
    fill: "#E6E6E6"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 56.6694L138 59.3407V55.31L142.627 52.6387V56.6694Z",
    fill: "#E6E6E6"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 64.1108L138 66.7821V62.7514L142.627 60.0801V64.1108Z",
    fill: "#E6E6E6"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 329.962L286.105 332.622V328.591L290.732 325.932V329.962Z",
    fill: "#E6E6E6"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 322.521L286.105 325.192V321.162L290.732 318.49V322.521Z",
    fill: "#E6E6E6"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 337.392L286.105 340.063V336.033L290.732 333.361V337.392Z",
    fill: "#E6E6E6"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 344.834L286.105 347.505V343.474L290.732 340.803V344.834Z",
    fill: "#E6E6E6"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 118.431L147.59 121.102V117.072L152.217 114.4V118.431Z",
    fill: "#E6E6E6"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 111.001L147.59 113.661V109.63L152.217 106.971V111.001Z",
    fill: "#E6E6E6"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 134.078L147.59 136.737V132.706L152.217 130.047V134.078Z",
    fill: "#E6E6E6"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 126.634L147.59 129.306V125.275L152.217 122.604V126.634Z",
    fill: "#E6E6E6"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 141.507L147.59 144.179V140.148L152.217 137.477V141.507Z",
    fill: "#E6E6E6"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 103.56L147.59 106.231V102.201L152.217 99.5293V103.56Z",
    fill: "#E6E6E6"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 73.4351L147.59 76.1064V72.0756L152.217 69.4043V73.4351Z",
    fill: "#E6E6E6"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 80.8784L147.59 83.5497V79.5189L152.217 76.8477V80.8784Z",
    fill: "#E6E6E6"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 96.0483L147.59 98.7196V94.6889L152.217 92.0176V96.0483Z",
    fill: "#E6E6E6"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 88.32L147.59 90.9794V86.9486L152.217 84.2773V88.32Z",
    fill: "#E6E6E6"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 179.285L147.59 181.956V177.925L152.217 175.254V179.285Z",
    fill: "#E6E6E6"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 148.947L147.59 151.618V147.575L152.217 144.916V148.947Z",
    fill: "#E6E6E6"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 194.158L147.59 196.829V192.798L152.217 190.127V194.158Z",
    fill: "#E6E6E6"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 209.029L147.59 211.7V207.669L152.217 204.998V209.029Z",
    fill: "#E6E6E6"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 186.728L147.59 189.388V185.357L152.217 182.686V186.728Z",
    fill: "#E6E6E6"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 216.47L147.59 219.141V215.099L152.217 212.439V216.47Z",
    fill: "#E6E6E6"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 201.597L147.59 204.268V200.226L152.217 197.566V201.597Z",
    fill: "#E6E6E6"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 163.82L147.59 166.491V162.46L152.217 159.789V163.82Z",
    fill: "#E6E6E6"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 244.314L138 246.985V242.954L142.627 240.283V244.314Z",
    fill: "#E6E6E6"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 232.771L286.105 235.442V231.412L290.732 228.74V232.771Z",
    fill: "#E6E6E6"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 66.0073L147.59 68.6786V64.6359L152.217 61.9766V66.0073Z",
    fill: "#E6E6E6"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 156.378L147.59 159.05V155.019L152.217 152.348V156.378Z",
    fill: "#E6E6E6"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 296.894L138 299.554V295.523L142.627 292.852V296.894Z",
    fill: "#E6E6E6"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 289.453L138 292.124V288.093L142.627 285.422V289.453Z",
    fill: "#E6E6E6"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 311.763L138 314.434V310.392L142.627 307.732V311.763Z",
    fill: "#E6E6E6"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 304.324L138 306.995V302.964L142.627 300.293V304.324Z",
    fill: "#E6E6E6"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 319.195L138 321.866V317.835L142.627 315.164V319.195Z",
    fill: "#E6E6E6"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 282.011L138 284.683V280.652L142.627 277.98V282.011Z",
    fill: "#E6E6E6"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 252.269L138 254.94V250.91L142.627 248.238V252.269Z",
    fill: "#E6E6E6"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 58.5659L147.59 61.2372V57.2064L152.217 54.5352V58.5659Z",
    fill: "#E6E6E6"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 274.582L138 277.253V273.222L142.627 270.551V274.582Z",
    fill: "#E6E6E6"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 267.14L138 269.811V265.781L142.627 263.109V267.14Z",
    fill: "#E6E6E6"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 259.71L138 262.382V258.339L142.627 255.68V259.71Z",
    fill: "#E6E6E6"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 51.1362L147.59 53.8075V49.7648L152.217 47.1055V51.1362Z",
    fill: "#E6E6E6"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 334.591L138 337.263V333.22L142.627 330.561V334.591Z",
    fill: "#E6E6E6"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 212.82L166.77 215.491V211.46L171.385 208.789V212.82Z",
    fill: "#E6E6E6"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 327.148L138 329.819V325.788L142.627 323.117V327.148Z",
    fill: "#E6E6E6"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 171.845L147.59 174.516V170.486L152.217 167.814V171.845Z",
    fill: "#E6E6E6"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 213.464L57.6484 216.136V212.105L62.2755 209.434V213.464Z",
    fill: "#E6E6E6"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 220.906L57.6484 223.577V219.546L62.2755 216.875V220.906Z",
    fill: "#E6E6E6"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 228.859L57.6484 231.53V227.487L62.2755 224.828V228.859Z",
    fill: "#E6E6E6"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 236.289L57.6484 238.96V234.929L62.2755 232.258V236.289Z",
    fill: "#E6E6E6"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 243.732L57.6484 246.403V242.372L62.2755 239.701V243.732Z",
    fill: "#E6E6E6"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 251.172L57.6484 253.831V249.8L62.2755 247.129V251.172Z",
    fill: "#E6E6E6"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 176.293L57.6484 178.952V174.921L62.2755 172.25V176.293Z",
    fill: "#E6E6E6"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 183.722L57.6484 186.393V182.363L62.2755 179.691V183.722Z",
    fill: "#E6E6E6"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 191.164L57.6484 193.823V189.792L62.2755 187.121V191.164Z",
    fill: "#E6E6E6"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 198.593L57.6484 201.265V197.234L62.2755 194.562V198.593Z",
    fill: "#E6E6E6"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 206.035L57.6484 208.706V204.663L62.2755 202.004V206.035Z",
    fill: "#E6E6E6"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 266.043L57.6484 268.702V264.671L62.2755 262V266.043Z",
    fill: "#E6E6E6"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 258.601L57.6484 261.272V257.242L62.2755 254.57V258.601Z",
    fill: "#E6E6E6"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 311.169L57.6484 313.841V309.81L62.2755 307.139V311.169Z",
    fill: "#E6E6E6"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 303.738L57.6484 306.409V302.366L62.2755 299.707V303.738Z",
    fill: "#E6E6E6"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 326.039L57.6484 328.71V324.679L62.2755 322.008V326.039Z",
    fill: "#E6E6E6"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 318.609L57.6484 321.28V317.249L62.2755 314.578V318.609Z",
    fill: "#E6E6E6"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 295.785L57.6484 298.456V294.425L62.2755 291.754V295.785Z",
    fill: "#E6E6E6"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 168.851L57.6484 171.522V167.48L62.2755 164.82V168.851Z",
    fill: "#E6E6E6"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 273.472L57.6484 276.143V272.113L62.2755 269.441V273.472Z",
    fill: "#E6E6E6"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 280.914L57.6484 283.585V279.542L62.2755 276.883V280.914Z",
    fill: "#E6E6E6"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 288.343L57.6484 291.015V286.984L62.2755 284.312V288.343Z",
    fill: "#E6E6E6"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 346.457L48.0586 349.128V345.097L52.6856 342.426V346.457Z",
    fill: "#E6E6E6"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 333.482L57.6484 336.153V332.122L62.2755 329.451V333.482Z",
    fill: "#E6E6E6"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 301.33L48.0586 303.989V299.958L52.6856 297.287V301.33Z",
    fill: "#E6E6E6"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 220.261L166.77 222.921V218.89L171.385 216.219V220.261Z",
    fill: "#E6E6E6"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 309.273L48.0586 311.944V307.913L52.6856 305.242V309.273Z",
    fill: "#E6E6E6"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 331.585L48.0586 334.257V330.226L52.6856 327.555V331.585Z",
    fill: "#E6E6E6"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 316.712L48.0586 319.384V315.353L52.6856 312.682V316.712Z",
    fill: "#E6E6E6"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 324.156L48.0586 326.815V322.784L52.6856 320.125V324.156Z",
    fill: "#E6E6E6"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 138.083L57.6484 140.755V136.724L62.2755 134.053V138.083Z",
    fill: "#E6E6E6"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 131.38L57.6484 134.052V130.021L62.2755 127.35V131.38Z",
    fill: "#E6E6E6"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 161.41L57.6484 164.081V160.05L62.2755 157.379V161.41Z",
    fill: "#E6E6E6"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 153.98L57.6484 156.651V152.609L62.2755 149.949V153.98Z",
    fill: "#E6E6E6"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 145.525L57.6484 148.196V144.153L62.2755 141.494V145.525Z",
    fill: "#E6E6E6"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 339.025L48.0586 341.696V337.653L52.6856 334.994V339.025Z",
    fill: "#E6E6E6"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 253.056L67.2383 255.727V251.697L71.8653 249.025V253.056Z",
    fill: "#E6E6E6"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 260.498L67.2383 263.169V259.138L71.8653 256.467V260.498Z",
    fill: "#E6E6E6"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 267.939L67.2383 270.599V266.568L71.8653 263.896V267.939Z",
    fill: "#E6E6E6"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 282.81L67.2383 285.469V281.439L71.8653 278.779V282.81Z",
    fill: "#E6E6E6"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 275.369L67.2383 278.04V274.009L71.8653 271.338V275.369Z",
    fill: "#E6E6E6"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 238.185L67.2383 240.856V236.826L71.8653 234.154V238.185Z",
    fill: "#E6E6E6"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 223.314L67.2383 225.985V221.954L71.8653 219.283V223.314Z",
    fill: "#E6E6E6"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 245.626L67.2383 248.298V244.255L71.8653 241.596V245.626Z",
    fill: "#E6E6E6"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 230.756L67.2383 233.415V229.384L71.8653 226.713V230.756Z",
    fill: "#E6E6E6"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 290.24L67.2383 292.911V288.88L71.8653 286.209V290.24Z",
    fill: "#E6E6E6"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 342.818L67.2383 345.477V341.447L71.8653 338.775V342.818Z",
    fill: "#E6E6E6"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 215.361L67.2383 218.032V214.001L71.8653 211.33V215.361Z",
    fill: "#E6E6E6"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 335.376L67.2383 338.048V334.017L71.8653 331.346V335.376Z",
    fill: "#E6E6E6"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 313.064L67.2383 315.735V311.705L71.8653 309.033V313.064Z",
    fill: "#E6E6E6"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 327.935L67.2383 330.606V326.576L71.8653 323.904V327.935Z",
    fill: "#E6E6E6"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 305.635L67.2383 308.294V304.263L71.8653 301.592V305.635Z",
    fill: "#E6E6E6"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 298.195L67.2383 300.866V296.835L71.8653 294.164V298.195Z",
    fill: "#E6E6E6"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 320.507L67.2383 323.179V319.136L71.8653 316.477V320.507Z",
    fill: "#E6E6E6"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 125.837L67.2383 128.509V124.478L71.8653 121.807V125.837Z",
    fill: "#E6E6E6"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2755 340.922L57.6484 343.581V339.55L62.2755 336.879V340.922Z",
    fill: "#E6E6E6"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 207.931L67.2383 210.591V206.56L71.8653 203.889V207.931Z",
    fill: "#E6E6E6"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 178.175L67.2383 180.847V176.816L71.8653 174.145V178.175Z",
    fill: "#E6E6E6"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 185.619L67.2383 188.29V184.259L71.8653 181.588V185.619Z",
    fill: "#E6E6E6"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 193.048L67.2383 195.72V191.689L71.8653 189.018V193.048Z",
    fill: "#E6E6E6"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 170.748L67.2383 173.419V169.376L71.8653 166.717V170.748Z",
    fill: "#E6E6E6"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 200.488L67.2383 203.159V199.128L71.8653 196.457V200.488Z",
    fill: "#E6E6E6"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 155.876L67.2383 158.536V154.505L71.8653 151.846V155.876Z",
    fill: "#E6E6E6"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 163.306L67.2383 165.977V161.947L71.8653 159.275V163.306Z",
    fill: "#E6E6E6"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 148.435L67.2383 151.106V147.076L71.8653 144.404V148.435Z",
    fill: "#E6E6E6"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 139.98L67.2383 142.651V138.62L71.8653 135.949V139.98Z",
    fill: "#E6E6E6"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8653 132.539L67.2383 135.21V131.179L71.8653 128.508V132.539Z",
    fill: "#E6E6E6"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 187.371L38.4844 190.042V186.011L43.0995 183.34V187.371Z",
    fill: "#E6E6E6"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 149.174L38.4844 151.833V147.802L43.0995 145.131V149.174Z",
    fill: "#E6E6E6"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 156.603L38.4844 159.274V155.244L43.0995 152.572V156.603Z",
    fill: "#E6E6E6"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 172.5L38.4844 175.171V171.128L43.0995 168.469V172.5Z",
    fill: "#E6E6E6"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 179.931L38.4844 182.602V178.572L43.0995 175.9V179.931Z",
    fill: "#E6E6E6"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 165.058L38.4844 167.729V163.699L43.0995 161.027V165.058Z",
    fill: "#E6E6E6"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 269.693L38.4844 272.352V268.322L43.0995 265.65V269.693Z",
    fill: "#E6E6E6"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 142.472L38.4844 145.132V141.101L43.0995 138.43V142.472Z",
    fill: "#E6E6E6"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 239.937L38.4844 242.608V238.578L43.0995 235.906V239.937Z",
    fill: "#E6E6E6"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 247.38L38.4844 250.052V246.009L43.0995 243.35V247.38Z",
    fill: "#E6E6E6"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 254.808L38.4844 257.479V253.449L43.0995 250.777V254.808Z",
    fill: "#E6E6E6"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 231.984L38.4844 234.655V230.624L43.0995 227.953V231.984Z",
    fill: "#E6E6E6"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 262.25L38.4844 264.921V260.89L43.0995 258.219V262.25Z",
    fill: "#E6E6E6"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 202.244L38.4844 204.915V200.884L43.0995 198.213V202.244Z",
    fill: "#E6E6E6"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 194.8L38.4844 197.472V193.441L43.0995 190.77V194.8Z",
    fill: "#E6E6E6"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 209.683L38.4844 212.343V208.312L43.0995 205.641V209.683Z",
    fill: "#E6E6E6"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 224.556L38.4844 227.227V223.185L43.0995 220.525V224.556Z",
    fill: "#E6E6E6"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 217.113L38.4844 219.784V215.753L43.0995 213.082V217.113Z",
    fill: "#E6E6E6"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 265.386L166.77 268.058V264.027L171.385 261.355V265.386Z",
    fill: "#E6E6E6"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 272.83L166.77 275.501V271.458L171.385 268.799V272.83Z",
    fill: "#E6E6E6"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 287.699L166.77 290.37V286.339L171.385 283.668V287.699Z",
    fill: "#E6E6E6"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 280.269L166.77 282.929V278.898L171.385 276.227V280.269Z",
    fill: "#E6E6E6"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 295.142L166.77 297.802V293.771L171.385 291.1V295.142Z",
    fill: "#E6E6E6"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 235.646L166.77 238.317V234.287L171.385 231.615V235.646Z",
    fill: "#E6E6E6"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 227.691L166.77 230.362V226.331L171.385 223.66V227.691Z",
    fill: "#E6E6E6"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 243.086L166.77 245.745V241.714L171.385 239.043V243.086Z",
    fill: "#E6E6E6"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 250.517L166.77 253.188V249.158L171.385 246.486V250.517Z",
    fill: "#E6E6E6"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 257.959L166.77 260.63V256.587L171.385 253.928V257.959Z",
    fill: "#E6E6E6"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 293.888L48.0586 296.559V292.529L52.6856 289.857V293.888Z",
    fill: "#E6E6E6"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 340.267L166.77 342.938V338.908L171.385 336.236V340.267Z",
    fill: "#E6E6E6"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 302.57L166.77 305.241V301.21L171.385 298.539V302.57Z",
    fill: "#E6E6E6"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 310.523L166.77 313.194V309.163L171.385 306.492V310.523Z",
    fill: "#E6E6E6"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 317.967L166.77 320.626V316.595L171.385 313.924V317.967Z",
    fill: "#E6E6E6"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 325.396L166.77 328.067V324.037L171.385 321.365V325.396Z",
    fill: "#E6E6E6"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M171.385 332.835L166.77 335.507V331.464L171.385 328.805V332.835Z",
    fill: "#E6E6E6"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 181.826L48.0586 184.497V180.466L52.6856 177.795V181.826Z",
    fill: "#E6E6E6"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 189.267L48.0586 191.938V187.896L52.6856 185.236V189.267Z",
    fill: "#E6E6E6"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 204.138L48.0586 206.809V202.779L52.6856 200.107V204.138Z",
    fill: "#E6E6E6"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 174.396L48.0586 177.056V173.025L52.6856 170.354V174.396Z",
    fill: "#E6E6E6"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 196.697L48.0586 199.368V195.337L52.6856 192.666V196.697Z",
    fill: "#E6E6E6"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 143.628L48.0586 146.3V142.269L52.6856 139.598V143.628Z",
    fill: "#E6E6E6"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 211.568L48.0586 214.239V210.208L52.6856 207.537V211.568Z",
    fill: "#E6E6E6"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 151.058L48.0586 153.729V149.699L52.6856 147.027V151.058Z",
    fill: "#E6E6E6"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 166.955L48.0586 169.626V165.595L52.6856 162.924V166.955Z",
    fill: "#E6E6E6"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 159.525L48.0586 162.184V158.154L52.6856 155.482V159.525Z",
    fill: "#E6E6E6"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 241.833L48.0586 244.505V240.474L52.6856 237.803V241.833Z",
    fill: "#E6E6E6"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 264.146L48.0586 266.817V262.775L52.6856 260.115V264.146Z",
    fill: "#E6E6E6"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 271.576L48.0586 274.247V270.216L52.6856 267.545V271.576Z",
    fill: "#E6E6E6"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 256.707L48.0586 259.378V255.347L52.6856 252.676V256.707Z",
    fill: "#E6E6E6"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 279.019L48.0586 281.69V277.66L52.6856 274.988V279.019Z",
    fill: "#E6E6E6"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 286.459L48.0586 289.118V285.087L52.6856 282.416V286.459Z",
    fill: "#E6E6E6"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 219.009L48.0586 221.681V217.65L52.6856 214.979V219.009Z",
    fill: "#E6E6E6"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 249.275L48.0586 251.934V247.903L52.6856 245.244V249.275Z",
    fill: "#E6E6E6"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 226.451L48.0586 229.11V225.079L52.6856 222.408V226.451Z",
    fill: "#E6E6E6"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 234.406L48.0586 237.065V233.035L52.6856 230.363V234.406Z",
    fill: "#E6E6E6"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6856 136.927L48.0586 139.599V135.568L52.6856 132.896V136.927Z",
    fill: "#E6E6E6"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 329.687L38.4844 332.358V328.328L43.0995 325.656V329.687Z",
    fill: "#E6E6E6"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 322.259L38.4844 324.931V320.888L43.0995 318.229V322.259Z",
    fill: "#E6E6E6"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 277.121L38.4844 279.792V275.761L43.0995 273.09V277.121Z",
    fill: "#E6E6E6"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 314.818L38.4844 317.489V313.458L43.0995 310.787V314.818Z",
    fill: "#E6E6E6"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 344.572L38.4844 347.231V343.201L43.0995 340.529V344.572Z",
    fill: "#E6E6E6"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 337.13L38.4844 339.802V335.771L43.0995 333.1V337.13Z",
    fill: "#E6E6E6"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 284.562L38.4844 287.221V283.191L43.0995 280.531V284.562Z",
    fill: "#E6E6E6"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 291.994L38.4844 294.665V290.634L43.0995 287.963V291.994Z",
    fill: "#E6E6E6"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 306.863L38.4844 309.534V305.503L43.0995 302.832V306.863Z",
    fill: "#E6E6E6"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0995 299.433L38.4844 302.104V298.062L43.0995 295.402V299.433Z",
    fill: "#E6E6E6"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 307.65L286.105 310.321V306.29L290.732 303.619V307.65Z",
    fill: "#E6E6E6"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 346.039L469.039 348.71V344.679L473.666 342.008V346.039Z",
    fill: "#E6E6E6"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 71.7534L478.625 74.4247V70.3939L483.252 67.7227V71.7534Z",
    fill: "#E6E6E6"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 308.855L469.039 311.526V307.496L473.666 304.824V308.855Z",
    fill: "#E6E6E6"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 79.1968L478.625 81.8681V77.8373L483.252 75.166V79.1968Z",
    fill: "#E6E6E6"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 316.296L469.039 318.968V314.937L473.666 312.266V316.296Z",
    fill: "#E6E6E6"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 301.425L469.039 304.097V300.054L473.666 297.395V301.425Z",
    fill: "#E6E6E6"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 331.167L469.039 333.839V329.808L473.666 327.137V331.167Z",
    fill: "#E6E6E6"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 338.609L469.039 341.268V337.238L473.666 334.566V338.609Z",
    fill: "#E6E6E6"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 323.738L469.039 326.397V322.367L473.666 319.695V323.738Z",
    fill: "#E6E6E6"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 138.691L478.625 141.35V137.32L483.252 134.648V138.691Z",
    fill: "#E6E6E6"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 131.25L478.625 133.921V129.89L483.252 127.219V131.25Z",
    fill: "#E6E6E6"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 146.123L478.625 148.794V144.763L483.252 142.092V146.123Z",
    fill: "#E6E6E6"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 123.81L478.625 126.481V122.451L483.252 119.779V123.81Z",
    fill: "#E6E6E6"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 153.562L478.625 156.222V152.191L483.252 149.52V153.562Z",
    fill: "#E6E6E6"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 116.378L478.625 119.05V115.019L483.252 112.348V116.378Z",
    fill: "#E6E6E6"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 94.0659L478.625 96.7372V92.7064L483.252 90.0352V94.0659Z",
    fill: "#E6E6E6"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 86.6384L478.625 89.2978V85.267L483.252 82.5957V86.6384Z",
    fill: "#E6E6E6"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 101.509L478.625 104.181V100.138L483.252 97.4668V101.509Z",
    fill: "#E6E6E6"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 108.937L478.625 111.608V107.578L483.252 104.906V108.937Z",
    fill: "#E6E6E6"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 173.966L469.039 176.638V172.607L473.666 169.936V173.966Z",
    fill: "#E6E6E6"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 181.41L469.039 184.081V180.05L473.666 177.379V181.41Z",
    fill: "#E6E6E6"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 188.849L469.039 191.509V187.478L473.666 184.807V188.849Z",
    fill: "#E6E6E6"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 160.992L478.625 163.663V159.632L483.252 156.961V160.992Z",
    fill: "#E6E6E6"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 196.279L469.039 198.95V194.919L473.666 192.248V196.279Z",
    fill: "#E6E6E6"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 293.984L469.039 296.655V292.624L473.666 289.953V293.984Z",
    fill: "#E6E6E6"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 211.675L469.039 214.347V210.304L473.666 207.645V211.675Z",
    fill: "#E6E6E6"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 166.539L469.039 169.21V165.179L473.666 162.508V166.539Z",
    fill: "#E6E6E6"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 144.226L469.039 146.897V142.867L473.666 140.195V144.226Z",
    fill: "#E6E6E6"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 151.666L469.039 154.337V150.294L473.666 147.635V151.666Z",
    fill: "#E6E6E6"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 159.097L469.039 161.768V157.738L473.666 155.066V159.097Z",
    fill: "#E6E6E6"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 203.722L469.039 206.393V202.351L473.666 199.691V203.722Z",
    fill: "#E6E6E6"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 271.16L469.039 273.831V269.8L473.666 267.129V271.16Z",
    fill: "#E6E6E6"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 263.728L469.039 266.387V262.357L473.666 259.697V263.728Z",
    fill: "#E6E6E6"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 278.601L469.039 281.272V277.23L473.666 274.57V278.601Z",
    fill: "#E6E6E6"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 219.103L469.039 221.774V217.744L473.666 215.072V219.103Z",
    fill: "#E6E6E6"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 256.289L469.039 258.96V254.929L473.666 252.258V256.289Z",
    fill: "#E6E6E6"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 286.554L469.039 289.226V285.183L473.666 282.512V286.554Z",
    fill: "#E6E6E6"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 233.976L469.039 236.647V232.617L473.666 229.945V233.976Z",
    fill: "#E6E6E6"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 226.546L469.039 229.218V225.187L473.666 222.516V226.546Z",
    fill: "#E6E6E6"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 248.859L469.039 251.518V247.488L473.666 244.816V248.859Z",
    fill: "#E6E6E6"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 241.416L469.039 244.087V240.056L473.666 237.385V241.416Z",
    fill: "#E6E6E6"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 140.755L364.402 143.427V139.396L369.029 136.725V140.755Z",
    fill: "#E6E6E6"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 58.9605L364.402 61.6317V57.601L369.029 54.9297V58.9605Z",
    fill: "#E6E6E6"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 51.529L364.402 54.1884V50.1576L369.029 47.4863V51.529Z",
    fill: "#E6E6E6"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 66.4001L364.402 69.0714V65.0287L369.029 62.3574V66.4001Z",
    fill: "#E6E6E6"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 81.271L364.402 83.9423V79.8996L369.029 77.2402V81.271Z",
    fill: "#E6E6E6"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 73.8296L364.402 76.5009V72.4701L369.029 69.7988V73.8296Z",
    fill: "#E6E6E6"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 44.0874L364.402 46.7587V42.7279L369.029 40.0566V44.0874Z",
    fill: "#E6E6E6"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 340.504L478.625 343.163V339.132L483.252 336.461V340.504Z",
    fill: "#E6E6E6"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 333.064L478.625 335.735V331.704L483.252 329.033V333.064Z",
    fill: "#E6E6E6"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 133.326L364.402 135.997V131.954L369.029 129.295V133.326Z",
    fill: "#E6E6E6"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 136.796L469.039 139.456V135.425L473.666 132.766V136.796Z",
    fill: "#E6E6E6"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 156.222L364.402 158.893V154.863L369.029 152.191V156.222Z",
    fill: "#E6E6E6"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 168.435L478.625 171.106V167.064L483.252 164.404V168.435Z",
    fill: "#E6E6E6"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 88.7007L364.402 91.372V87.3412L369.029 84.6699V88.7007Z",
    fill: "#E6E6E6"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 148.792L364.402 151.464V147.421L369.029 144.762V148.792Z",
    fill: "#E6E6E6"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 118.455L364.402 121.114V117.083L369.029 114.424V118.455Z",
    fill: "#E6E6E6"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 103.584L364.402 106.243V102.212L369.029 99.541V103.584Z",
    fill: "#E6E6E6"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 96.1421L364.402 98.8134V94.7826L369.029 92.1113V96.1421Z",
    fill: "#E6E6E6"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 111.013L364.402 113.684V109.654L369.029 106.982V111.013Z",
    fill: "#E6E6E6"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 125.884L364.402 128.556V124.525L369.029 121.854V125.884Z",
    fill: "#E6E6E6"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 206.128L478.625 208.8V204.769L483.252 202.098V206.128Z",
    fill: "#E6E6E6"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 221.001L478.625 223.673V219.642L483.252 216.971V221.001Z",
    fill: "#E6E6E6"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 213.572L478.625 216.231V212.201L483.252 209.529V213.572Z",
    fill: "#E6E6E6"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 228.441L478.625 231.112V227.07L483.252 224.41V228.441Z",
    fill: "#E6E6E6"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 235.873L478.625 238.544V234.513L483.252 231.842V235.873Z",
    fill: "#E6E6E6"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 198.175L478.625 200.847V196.816L483.252 194.145V198.175Z",
    fill: "#E6E6E6"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 175.863L478.625 178.534V174.503L483.252 171.832V175.863Z",
    fill: "#E6E6E6"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 183.304L478.625 185.975V181.945L483.252 179.273V183.304Z",
    fill: "#E6E6E6"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 190.734L478.625 193.405V189.374L483.252 186.703V190.734Z",
    fill: "#E6E6E6"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 243.314L478.625 245.985V241.943L483.252 239.283V243.314Z",
    fill: "#E6E6E6"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 318.191L478.625 320.862V316.819L483.252 314.16V318.191Z",
    fill: "#E6E6E6"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 295.878L478.625 298.55V294.519L483.252 291.848V295.878Z",
    fill: "#E6E6E6"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 303.322L478.625 305.993V301.95L483.252 299.291V303.322Z",
    fill: "#E6E6E6"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 288.451L478.625 291.11V287.08L483.252 284.408V288.451Z",
    fill: "#E6E6E6"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 325.623L478.625 328.294V324.263L483.252 321.592V325.623Z",
    fill: "#E6E6E6"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 310.751L478.625 313.423V309.392L483.252 306.721V310.751Z",
    fill: "#E6E6E6"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 273.054L478.625 275.725V271.695L483.252 269.023V273.054Z",
    fill: "#E6E6E6"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 281.009L478.625 283.681V279.65L483.252 276.979V281.009Z",
    fill: "#E6E6E6"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 265.625L478.625 268.284V264.253L483.252 261.582V265.625Z",
    fill: "#E6E6E6"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 258.185L478.625 260.856V256.826L483.252 254.154V258.185Z",
    fill: "#E6E6E6"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 250.742L478.625 253.413V249.382L483.252 246.711V250.742Z",
    fill: "#E6E6E6"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 293.841L539.445 291.169V287.139L544.06 289.81V293.841Z",
    fill: "#E6E6E6"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 318.561L529.859 315.89V311.859L534.486 314.519V318.561Z",
    fill: "#E6E6E6"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 288.294L529.859 285.623V281.592L534.486 284.263V288.294Z",
    fill: "#E6E6E6"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 311.122L529.859 308.451V304.42L534.486 307.091V311.122Z",
    fill: "#E6E6E6"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 303.167L529.859 300.496V296.465L534.486 299.136V303.167Z",
    fill: "#E6E6E6"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 236.241L529.859 233.57V229.539L534.486 232.21V236.241Z",
    fill: "#E6E6E6"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 243.684L529.859 241.013V236.982L534.486 239.642V243.684Z",
    fill: "#E6E6E6"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 251.112L529.859 248.441V244.41L534.486 247.081V251.112Z",
    fill: "#E6E6E6"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 265.983L529.859 263.312V259.281L534.486 261.953V265.983Z",
    fill: "#E6E6E6"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 258.554L529.859 255.882V251.852L534.486 254.523V258.554Z",
    fill: "#E6E6E6"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 273.425L529.859 270.753V266.723L534.486 269.394V273.425Z",
    fill: "#E6E6E6"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 295.726L529.859 293.066V289.023L534.486 291.695V295.726Z",
    fill: "#E6E6E6"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 325.991L529.859 323.32V319.289L534.486 321.96V325.991Z",
    fill: "#E6E6E6"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 340.862L529.859 338.191V334.16L534.486 336.831V340.862Z",
    fill: "#E6E6E6"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 333.434L529.859 330.763V326.732L534.486 329.404V333.434Z",
    fill: "#E6E6E6"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 348.304L529.859 345.632V341.602L534.486 344.273V348.304Z",
    fill: "#E6E6E6"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 280.854L529.859 278.195V274.152L534.486 276.824V280.854Z",
    fill: "#E6E6E6"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 138.452L529.859 135.793V131.75L534.486 134.421V138.452Z",
    fill: "#E6E6E6"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 145.895L529.859 143.224V139.193L534.486 141.865V145.895Z",
    fill: "#E6E6E6"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 131.024L529.859 128.353V124.322L534.486 126.994V131.024Z",
    fill: "#E6E6E6"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 176.233L529.859 173.562V169.531L534.486 172.203V176.233Z",
    fill: "#E6E6E6"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 205.976L529.859 203.316V199.273L534.486 201.945V205.976Z",
    fill: "#E6E6E6"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 198.544L529.859 195.873V191.842L534.486 194.513V198.544Z",
    fill: "#E6E6E6"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 220.844L529.859 218.185V214.154L534.486 216.814V220.844Z",
    fill: "#E6E6E6"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 191.104L529.859 188.433V184.402L534.486 187.074V191.104Z",
    fill: "#E6E6E6"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 213.417L529.859 210.746V206.715L534.486 209.386V213.417Z",
    fill: "#E6E6E6"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 161.362L529.859 158.691V154.66L534.486 157.331V161.362Z",
    fill: "#E6E6E6"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 168.804L529.859 166.132V162.102L534.486 164.761V168.804Z",
    fill: "#E6E6E6"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 153.337L529.859 150.666V146.635L534.486 149.294V153.337Z",
    fill: "#E6E6E6"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 228.288L529.859 225.617V221.586L534.486 224.257V228.288Z",
    fill: "#E6E6E6"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M534.486 183.675L529.859 181.003V176.973L534.486 179.632V183.675Z",
    fill: "#E6E6E6"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 211.52L539.445 208.849V204.818L544.06 207.49V211.52Z",
    fill: "#E6E6E6"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 338.966L539.445 336.306V332.264L544.06 334.935V338.966Z",
    fill: "#E6E6E6"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 331.536L539.445 328.865V324.834L544.06 327.505V331.536Z",
    fill: "#E6E6E6"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 346.409L539.445 343.738V339.707L544.06 342.378V346.409Z",
    fill: "#E6E6E6"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 324.097L539.445 321.425V317.395L544.06 320.066V324.097Z",
    fill: "#E6E6E6"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 316.665L539.445 313.994V309.963L544.06 312.622V316.665Z",
    fill: "#E6E6E6"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 163.664L364.402 166.335V162.304L369.029 159.633V163.664Z",
    fill: "#E6E6E6"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 301.27L539.445 298.599V294.568L544.06 297.24V301.27Z",
    fill: "#E6E6E6"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 308.712L539.445 306.041V302.01L544.06 304.681V308.712Z",
    fill: "#E6E6E6"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 121.926L469.039 124.585V120.554L473.666 117.883V121.926Z",
    fill: "#E6E6E6"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 107.041L469.039 109.712V105.681L473.666 103.01V107.041Z",
    fill: "#E6E6E6"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 114.484L469.039 117.155V113.124L473.666 110.453V114.484Z",
    fill: "#E6E6E6"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 286.399L539.445 283.728V279.697L544.06 282.369V286.399Z",
    fill: "#E6E6E6"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 92.1714L469.039 94.8427V90.8119L473.666 88.1406V92.1714Z",
    fill: "#E6E6E6"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 99.6128L469.039 102.284V98.2533L473.666 95.582V99.6128Z",
    fill: "#E6E6E6"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 84.7417L469.039 87.4011V83.3703L473.666 80.7109V84.7417Z",
    fill: "#E6E6E6"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 77.3003L469.039 79.9716V75.9408L473.666 73.2695V77.3003Z",
    fill: "#E6E6E6"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M483.252 64.4216L478.625 67.081V63.0502L483.252 60.3789V64.4216Z",
    fill: "#E6E6E6"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 69.9526L469.039 72.6239V68.5932L473.666 65.9219V69.9526Z",
    fill: "#E6E6E6"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 264.087L539.445 261.427V257.385L544.06 260.056V264.087Z",
    fill: "#E6E6E6"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 158.87L539.445 156.199V152.168L544.06 154.839V158.87Z",
    fill: "#E6E6E6"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 166.907L539.445 164.236V160.205L544.06 162.876V166.907Z",
    fill: "#E6E6E6"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 174.337L539.445 171.666V167.635L544.06 170.306V174.337Z",
    fill: "#E6E6E6"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 189.208L539.445 186.549V182.506L544.06 185.177V189.208Z",
    fill: "#E6E6E6"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 181.778L539.445 179.107V175.076L544.06 177.747V181.778Z",
    fill: "#E6E6E6"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 196.649L539.445 193.978V189.947L544.06 192.619V196.649Z",
    fill: "#E6E6E6"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 136.557L539.445 133.898V129.867L544.06 132.527V136.557Z",
    fill: "#E6E6E6"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 151.44L539.445 148.769V144.738L544.06 147.398V151.44Z",
    fill: "#E6E6E6"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 143.999L539.445 141.328V137.297L544.06 139.968V143.999Z",
    fill: "#E6E6E6"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 233.831L539.445 231.16V227.129L544.06 229.8V233.831Z",
    fill: "#E6E6E6"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 241.786L539.445 239.115V235.084L544.06 237.755V241.786Z",
    fill: "#E6E6E6"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 256.659L539.445 253.988V249.957L544.06 252.628V256.659Z",
    fill: "#E6E6E6"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 249.216L539.445 246.544V242.514L544.06 245.185V249.216Z",
    fill: "#E6E6E6"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 204.079L539.445 201.419V197.389L544.06 200.048V204.079Z",
    fill: "#E6E6E6"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 271.528L539.445 268.857V264.826L544.06 267.497V271.528Z",
    fill: "#E6E6E6"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M473.666 129.353L469.039 132.024V127.994L473.666 125.322V129.353Z",
    fill: "#E6E6E6"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 218.962L539.445 216.291V212.26L544.06 214.919V218.962Z",
    fill: "#E6E6E6"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 226.391L539.445 223.72V219.689L544.06 222.361V226.391Z",
    fill: "#E6E6E6"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06 278.972L539.445 276.3V272.27L544.06 274.929V278.972Z",
    fill: "#E6E6E6"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 180.205L286.105 182.864V178.833L290.732 176.174V180.205Z",
    fill: "#E6E6E6"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 309.773L383.57 312.444V308.413L388.197 305.742V309.773Z",
    fill: "#E6E6E6"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 88.5583L276.516 91.2296V87.1869L281.143 84.5156V88.5583Z",
    fill: "#E6E6E6"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 332.085L383.57 334.757V330.726L388.197 328.055V332.085Z",
    fill: "#E6E6E6"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 317.215L383.57 319.874V315.843L388.197 313.172V317.215Z",
    fill: "#E6E6E6"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 324.644L383.57 327.315V323.285L388.197 320.613V324.644Z",
    fill: "#E6E6E6"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 339.515L383.57 342.186V338.156L388.197 335.484V339.515Z",
    fill: "#E6E6E6"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 103.941L276.516 106.612V102.581L281.143 99.9102V103.941Z",
    fill: "#E6E6E6"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 96.5114L276.516 99.1708V95.14L281.143 92.4688V96.5114Z",
    fill: "#E6E6E6"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 155.996L276.516 158.667V154.636L281.143 151.965V155.996Z",
    fill: "#E6E6E6"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 163.437L276.516 166.097V162.066L281.143 159.395V163.437Z",
    fill: "#E6E6E6"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 148.566L276.516 151.225V147.195L281.143 144.523V148.566Z",
    fill: "#E6E6E6"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 178.308L276.516 180.979V176.937L281.143 174.277V178.308Z",
    fill: "#E6E6E6"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 111.384L276.516 114.056V110.013L281.143 107.354V111.384Z",
    fill: "#E6E6E6"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 171.105L364.402 173.765V169.734L369.029 167.062V171.105Z",
    fill: "#E6E6E6"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 118.812L276.516 121.483V117.453L281.143 114.781V118.812Z",
    fill: "#E6E6E6"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 126.253L276.516 128.925V124.894L281.143 122.223V126.253Z",
    fill: "#E6E6E6"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 133.683L276.516 136.354V132.324L281.143 129.652V133.683Z",
    fill: "#E6E6E6"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 141.125L276.516 143.796V139.765L281.143 137.094V141.125Z",
    fill: "#E6E6E6"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 220.023L383.57 222.694V218.663L388.197 215.992V220.023Z",
    fill: "#E6E6E6"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 189.757L383.57 192.429V188.398L388.197 185.727V189.757Z",
    fill: "#E6E6E6"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 197.197L383.57 199.868V195.837L388.197 193.166V197.197Z",
    fill: "#E6E6E6"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 204.628L383.57 207.3V203.269L388.197 200.598V204.628Z",
    fill: "#E6E6E6"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 212.582L383.57 215.253V211.222L388.197 208.551V212.582Z",
    fill: "#E6E6E6"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 145.144L383.57 147.815V143.785L388.197 141.113V145.144Z",
    fill: "#E6E6E6"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 182.328L383.57 184.999V180.968L388.197 178.297V182.328Z",
    fill: "#E6E6E6"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 160.015L383.57 162.686V158.656L388.197 155.984V160.015Z",
    fill: "#E6E6E6"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 302.343L383.57 305.003V300.972L388.197 298.301V302.343Z",
    fill: "#E6E6E6"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 167.457L383.57 170.116V166.085L388.197 163.414V167.457Z",
    fill: "#E6E6E6"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 174.884L383.57 177.556V173.525L388.197 170.854V174.884Z",
    fill: "#E6E6E6"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 152.572L383.57 155.243V151.212L388.197 148.541V152.572Z",
    fill: "#E6E6E6"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 279.507L383.57 282.179V278.148L388.197 275.477V279.507Z",
    fill: "#E6E6E6"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 272.078L383.57 274.749V270.718L388.197 268.047V272.078Z",
    fill: "#E6E6E6"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 294.902L383.57 297.573V293.542L388.197 290.871V294.902Z",
    fill: "#E6E6E6"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 287.46L383.57 290.132V286.101L388.197 283.43V287.46Z",
    fill: "#E6E6E6"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 264.634L383.57 267.306V263.275L388.197 260.604V264.634Z",
    fill: "#E6E6E6"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 242.335L383.57 244.995V240.964L388.197 238.305V242.335Z",
    fill: "#E6E6E6"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 257.207L383.57 259.878V255.835L388.197 253.176V257.207Z",
    fill: "#E6E6E6"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 234.894L383.57 237.565V233.535L388.197 230.863V234.894Z",
    fill: "#E6E6E6"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 227.465L383.57 230.124V226.093L388.197 223.422V227.465Z",
    fill: "#E6E6E6"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 249.765L383.57 252.436V248.406L388.197 245.734V249.765Z",
    fill: "#E6E6E6"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 185.738L276.516 188.409V184.378L281.143 181.707V185.738Z",
    fill: "#E6E6E6"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 113.279L286.105 115.938V111.908L290.732 109.236V113.279Z",
    fill: "#E6E6E6"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 143.021L286.105 145.692V141.65L290.732 138.99V143.021Z",
    fill: "#E6E6E6"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 120.709L286.105 123.38V119.349L290.732 116.678V120.709Z",
    fill: "#E6E6E6"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 135.58L286.105 138.251V134.22L290.732 131.549V135.58Z",
    fill: "#E6E6E6"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 128.15L286.105 130.809V126.779L290.732 124.107V128.15Z",
    fill: "#E6E6E6"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 105.837L286.105 108.509V104.478L290.732 101.807V105.837Z",
    fill: "#E6E6E6"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 83.0132L286.105 85.6845V81.6537L290.732 78.9824V83.0132Z",
    fill: "#E6E6E6"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 90.9663L286.105 93.6376V89.6068L290.732 86.9355V90.9663Z",
    fill: "#E6E6E6"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 98.396L286.105 101.067V97.0365L290.732 94.3652V98.396Z",
    fill: "#E6E6E6"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 187.634L286.105 190.306V186.275L290.732 183.604V187.634Z",
    fill: "#E6E6E6"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 150.451L286.105 153.122V149.091L290.732 146.42V150.451Z",
    fill: "#E6E6E6"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 202.503L286.105 205.175V201.144L290.732 198.473V202.503Z",
    fill: "#E6E6E6"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 210.459L286.105 213.13V209.099L290.732 206.428V210.459Z",
    fill: "#E6E6E6"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 217.9L286.105 220.571V216.54L290.732 213.869V217.9Z",
    fill: "#E6E6E6"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 195.076L286.105 197.747V193.704L290.732 191.045V195.076Z",
    fill: "#E6E6E6"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 225.33L286.105 228.001V223.97L290.732 221.299V225.33Z",
    fill: "#E6E6E6"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 165.334L286.105 167.993V163.962L290.732 161.291V165.334Z",
    fill: "#E6E6E6"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 157.892L286.105 160.563V156.533L290.732 153.861V157.892Z",
    fill: "#E6E6E6"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M290.732 172.763L286.105 175.434V171.404L290.732 168.732V172.763Z",
    fill: "#E6E6E6"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 335.498L276.516 338.169V334.138L281.143 331.467V335.498Z",
    fill: "#E6E6E6"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 245.746L276.516 248.417V244.386L281.143 241.715V245.746Z",
    fill: "#E6E6E6"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 238.316L276.516 240.987V236.945L281.143 234.285V238.316Z",
    fill: "#E6E6E6"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 260.617L276.516 263.288V259.257L281.143 256.586V260.617Z",
    fill: "#E6E6E6"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 230.875L276.516 233.546V229.515L281.143 226.844V230.875Z",
    fill: "#E6E6E6"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 253.187L276.516 255.858V251.816L281.143 249.156V253.187Z",
    fill: "#E6E6E6"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 200.621L276.516 203.28V199.249L281.143 196.578V200.621Z",
    fill: "#E6E6E6"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 208.05L276.516 210.722V206.691L281.143 204.02V208.05Z",
    fill: "#E6E6E6"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 268.058L276.516 270.729V266.699L281.143 264.027V268.058Z",
    fill: "#E6E6E6"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 216.003L276.516 218.675V214.644L281.143 211.973V216.003Z",
    fill: "#E6E6E6"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 223.445L276.516 226.104V222.074L281.143 219.402V223.445Z",
    fill: "#E6E6E6"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 193.179L276.516 195.85V191.82L281.143 189.148V193.179Z",
    fill: "#E6E6E6"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 320.624L276.516 323.296V319.265L281.143 316.594V320.624Z",
    fill: "#E6E6E6"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 328.066L276.516 330.737V326.706L281.143 324.035V328.066Z",
    fill: "#E6E6E6"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 275.5L276.516 278.159V274.128L281.143 271.457V275.5Z",
    fill: "#E6E6E6"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 342.937L276.516 345.608V341.578L281.143 338.906V342.937Z",
    fill: "#E6E6E6"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 313.197L276.516 315.856V311.826L281.143 309.154V313.197Z",
    fill: "#E6E6E6"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 290.884L276.516 293.556V289.525L281.143 286.854V290.884Z",
    fill: "#E6E6E6"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 305.753L276.516 308.425V304.394L281.143 301.723V305.753Z",
    fill: "#E6E6E6"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 282.929L276.516 285.6V281.57L281.143 278.898V282.929Z",
    fill: "#E6E6E6"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 298.324L276.516 300.983V296.953L281.143 294.281V298.324Z",
    fill: "#E6E6E6"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M281.143 170.867L276.516 173.538V169.507L281.143 166.836V170.867Z",
    fill: "#E6E6E6"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 68.2847L373.992 70.956V66.9252L378.607 64.2539V68.2847Z",
    fill: "#E6E6E6"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 38.5425L373.992 41.2138V37.183L378.607 34.5117V38.5425Z",
    fill: "#E6E6E6"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 45.9839L373.992 48.6552V44.6125L378.607 41.9531V45.9839Z",
    fill: "#E6E6E6"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 60.855L373.992 63.5263V59.4955L378.607 56.8242V60.855Z",
    fill: "#E6E6E6"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 53.4136L373.992 56.0849V52.0541L378.607 49.3828V53.4136Z",
    fill: "#E6E6E6"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 335.734L364.402 338.405V334.362L369.029 331.703V335.734Z",
    fill: "#E6E6E6"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 343.166L364.402 345.837V341.806L369.029 339.135V343.166Z",
    fill: "#E6E6E6"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 112.908L373.992 115.579V111.548L378.607 108.877V112.908Z",
    fill: "#E6E6E6"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 127.781L373.992 130.452V126.421L378.607 123.75V127.781Z",
    fill: "#E6E6E6"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 120.351L373.992 123.011V118.98L378.607 116.309V120.351Z",
    fill: "#E6E6E6"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 143.248L373.992 145.919V141.888L378.607 139.217V143.248Z",
    fill: "#E6E6E6"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 135.22L373.992 137.88V133.849L378.607 131.178V135.22Z",
    fill: "#E6E6E6"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 90.5972L373.992 93.2685V89.2377L378.607 86.5664V90.5972Z",
    fill: "#E6E6E6"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 83.1675L373.992 85.8388V81.7961L378.607 79.1367V83.1675Z",
    fill: "#E6E6E6"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 75.7261L373.992 78.3974V74.3666L378.607 71.6953V75.7261Z",
    fill: "#E6E6E6"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 98.0386L373.992 100.71V96.6672L378.607 94.0078V98.0386Z",
    fill: "#E6E6E6"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 105.468L373.992 108.14V104.109L378.607 101.438V105.468Z",
    fill: "#E6E6E6"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 231.101L364.402 233.772V229.742L369.029 227.07V231.101Z",
    fill: "#E6E6E6"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 208.277L364.402 210.948V206.917L369.029 204.246V208.277Z",
    fill: "#E6E6E6"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 245.984L364.402 248.643V244.613L369.029 241.941V245.984Z",
    fill: "#E6E6E6"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 215.718L364.402 218.39V214.359L369.029 211.688V215.718Z",
    fill: "#E6E6E6"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 150.689L373.992 153.349V149.318L378.607 146.646V150.689Z",
    fill: "#E6E6E6"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 238.542L364.402 241.214V237.183L369.029 234.512V238.542Z",
    fill: "#E6E6E6"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 223.671L364.402 226.343V222.3L369.029 219.641V223.671Z",
    fill: "#E6E6E6"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 178.535L364.402 181.206V177.175L369.029 174.504V178.535Z",
    fill: "#E6E6E6"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 200.847L364.402 203.518V199.488L369.029 196.816V200.847Z",
    fill: "#E6E6E6"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 185.976L364.402 188.636V184.605L369.029 181.934V185.976Z",
    fill: "#E6E6E6"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 193.406L364.402 196.077V192.046L369.029 189.375V193.406Z",
    fill: "#E6E6E6"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 290.597L364.402 293.268V289.238L369.029 286.566V290.597Z",
    fill: "#E6E6E6"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 298.552L364.402 301.224V297.193L369.029 294.521V298.552Z",
    fill: "#E6E6E6"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 328.292L364.402 330.964V326.933L369.029 324.262V328.292Z",
    fill: "#E6E6E6"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 253.414L364.402 256.085V252.054L369.029 249.383V253.414Z",
    fill: "#E6E6E6"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 313.421L364.402 316.093V312.062L369.029 309.391V313.421Z",
    fill: "#E6E6E6"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 320.865L364.402 323.524V319.494L369.029 316.822V320.865Z",
    fill: "#E6E6E6"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 305.98L364.402 308.651V304.621L369.029 301.949V305.98Z",
    fill: "#E6E6E6"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 283.156L364.402 285.827V281.796L369.029 279.125V283.156Z",
    fill: "#E6E6E6"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 260.855L364.402 263.515V259.484L369.029 256.812V260.855Z",
    fill: "#E6E6E6"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 268.285L364.402 270.956V266.925L369.029 264.254V268.285Z",
    fill: "#E6E6E6"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M369.029 275.726L364.402 278.397V274.355L369.029 271.695V275.726Z",
    fill: "#E6E6E6"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 187.859L373.992 190.53V186.499L378.607 183.828V187.859Z",
    fill: "#E6E6E6"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 33.0095L383.57 35.6688V31.6381L388.197 28.9668V33.0095Z",
    fill: "#E6E6E6"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 40.439L383.57 43.1103V39.0795L388.197 36.4082V40.439Z",
    fill: "#E6E6E6"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 47.8806L383.57 50.5519V46.5092L388.197 43.8379V47.8806Z",
    fill: "#E6E6E6"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 55.3081L383.57 57.9794V53.9486L388.197 51.2773V55.3081Z",
    fill: "#E6E6E6"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 330.189L373.992 332.86V328.829L378.607 326.158V330.189Z",
    fill: "#E6E6E6"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 337.619L373.992 340.29V336.259L378.607 333.588V337.619Z",
    fill: "#E6E6E6"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 345.06L373.992 347.731V343.701L378.607 341.029V345.06Z",
    fill: "#E6E6E6"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 107.365L383.57 110.036V106.005L388.197 103.334V107.365Z",
    fill: "#E6E6E6"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 99.9331L383.57 102.592V98.5617L388.197 95.9023V99.9331Z",
    fill: "#E6E6E6"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 114.806L383.57 117.477V113.435L388.197 110.775V114.806Z",
    fill: "#E6E6E6"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 322.748L373.992 325.419V321.388L378.607 318.717V322.748Z",
    fill: "#E6E6E6"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 129.677L383.57 132.349V128.318L388.197 125.646V129.677Z",
    fill: "#E6E6E6"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 122.234L383.57 124.905V120.874L388.197 118.203V122.234Z",
    fill: "#E6E6E6"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 62.7515L383.57 65.4227V61.3801L388.197 58.7207V62.7515Z",
    fill: "#E6E6E6"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 70.1812L383.57 72.8524V68.8217L388.197 66.1504V70.1812Z",
    fill: "#E6E6E6"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 77.6206L383.57 80.2919V76.2611L388.197 73.5898V77.6206Z",
    fill: "#E6E6E6"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 85.0523L383.57 87.7235V83.6928L388.197 81.0215V85.0523Z",
    fill: "#E6E6E6"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 92.4937L383.57 95.1649V91.1342L388.197 88.4629V92.4937Z",
    fill: "#E6E6E6"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 180.431L373.992 183.102V179.072L378.607 176.4V180.431Z",
    fill: "#E6E6E6"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 202.744L373.992 205.415V201.372L378.607 198.701V202.744Z",
    fill: "#E6E6E6"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 232.998L373.992 235.669V231.638L378.607 228.967V232.998Z",
    fill: "#E6E6E6"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 218.126L373.992 220.798V216.767L378.607 214.096V218.126Z",
    fill: "#E6E6E6"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 195.302L373.992 197.974V193.943L378.607 191.271V195.302Z",
    fill: "#E6E6E6"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 225.568L373.992 228.227V224.196L378.607 221.537V225.568Z",
    fill: "#E6E6E6"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 210.171L373.992 212.843V208.812L378.607 206.141V210.171Z",
    fill: "#E6E6E6"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 165.56L373.992 168.231V164.189L378.607 161.529V165.56Z",
    fill: "#E6E6E6"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 137.703L383.57 140.374V136.343L388.197 133.672V137.703Z",
    fill: "#E6E6E6"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 172.99L373.992 175.661V171.63L378.607 168.959V172.99Z",
    fill: "#E6E6E6"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 158.119L373.992 160.79V156.759L378.607 154.088V158.119Z",
    fill: "#E6E6E6"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 277.621L373.992 280.28V276.249L378.607 273.578V277.621Z",
    fill: "#E6E6E6"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 315.318L373.992 317.989V313.958L378.607 311.287V315.318Z",
    fill: "#E6E6E6"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 285.052L373.992 287.724V283.693L378.607 281.021V285.052Z",
    fill: "#E6E6E6"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 293.005L373.992 295.677V291.646L378.607 288.975V293.005Z",
    fill: "#E6E6E6"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 300.447L373.992 303.106V299.076L378.607 296.404V300.447Z",
    fill: "#E6E6E6"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 307.876L373.992 310.548V306.517L378.607 303.846V307.876Z",
    fill: "#E6E6E6"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 255.31L373.992 257.981V253.951L378.607 251.279V255.31Z",
    fill: "#E6E6E6"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 240.439L373.992 243.11V239.068L378.607 236.408V240.439Z",
    fill: "#E6E6E6"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 270.181L373.992 272.852V268.822L378.607 266.15V270.181Z",
    fill: "#E6E6E6"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 247.869L373.992 250.54V246.509L378.607 243.838V247.869Z",
    fill: "#E6E6E6"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M378.607 262.752L373.992 265.411V261.38L378.607 258.709V262.752Z",
    fill: "#E6E6E6"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M529 121.03L561.664 102.164L578.001 111.597L545.338 130.451L529 121.03Z",
    fill: "#FAFAFA"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M431.008 45.6258L458.257 29.9082L490.909 48.7741L463.671 64.4798L431.008 45.6258Z",
    fill: "#FAFAFA"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M490.898 75.6055V94.4475L507.236 85.0265L490.898 75.6055Z",
    fill: "#FAFAFA"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M322.156 18.854L354.82 0L392.921 22.0023L360.258 40.8563L322.156 18.854Z",
    fill: "#FAFAFA"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M109.859 40.7127L158.849 12.4258L180.613 25.007L131.623 53.282L109.859 40.7127Z",
    fill: "#FAFAFA"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00391 121.459L44.5195 96.3086L77.2189 115.186L33.7032 140.337L1.00391 121.459Z",
    fill: "#FAFAFA"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M245.941 69.1416L267.717 56.5723L294.943 72.2899L273.167 84.8711L245.941 69.1416Z",
    fill: "#FAFAFA"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M180.609 54.3664L202.397 41.7852L224.173 54.3664L202.397 66.9357L180.609 54.3664Z",
    fill: "#FAFAFA"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M392.918 103.596V122.438L409.256 113.029L392.918 103.596Z",
    fill: "#FAFAFA"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M109.857 155.233V136.391L93.5195 145.812L109.857 155.233Z",
    fill: "#FAFAFA"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M289.5 559.503C449.386 559.503 579 484.669 579 392.357C579 300.045 449.386 225.211 289.5 225.211C129.614 225.211 0 300.045 0 392.357C0 484.669 129.614 559.503 289.5 559.503Z",
    fill: "#F5F5F5"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7893 274.177C-28.2631 339.444 -28.2631 445.27 84.7893 510.549C106.502 522.875 129.526 532.731 153.432 539.934L383.591 406.882L121.841 256.074C109.101 261.275 96.7223 267.323 84.7893 274.177Z",
    fill: "#EBEBEB"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M249.29 430.578L204.344 456.707L255.074 485.983L300.009 459.855L249.29 430.578Z",
    fill: "#FAFAFA"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M163.51 542.88L383.605 415.588V406.883L153.445 539.934C156.776 540.96 160.131 541.941 163.51 542.88Z",
    fill: "#E0E0E0"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6197 57.4777L87.0677 58.4556V52.8746C87.0677 48.4145 83.4901 47.3412 79.6382 49.5712C77.6017 50.9018 75.9068 52.693 74.6907 54.7999C73.4746 56.9068 72.7715 59.2703 72.638 61.6993V62.5222C72.0932 62.3511 71.5164 62.3072 70.952 62.3941C70.3875 62.4809 69.8506 62.6961 69.3824 63.023C67.9168 63.9776 66.6972 65.2646 65.8227 66.7794C64.9483 68.2942 64.4436 69.9939 64.3499 71.7405V72.1221L60.7723 74.1732C59.8068 74.8033 59.0034 75.6522 58.4274 76.6509C57.8514 77.6496 57.5189 78.77 57.457 79.9213C57.457 82.0321 58.9358 82.8907 60.7723 81.8413L89.6078 65.1458C90.5748 64.5163 91.38 63.6679 91.9581 62.6692C92.5361 61.6706 92.8708 60.5498 92.935 59.3977C92.9469 57.275 91.4562 56.4522 89.6197 57.4777Z",
    fill: "#F0F0F0"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2995 32.2904L58.5922 37.8954C58.6433 37.4679 58.6711 37.0379 58.6757 36.6074V33.793C58.6757 28.7963 55.0981 26.7571 50.8288 29.2614C48.9614 30.4164 47.3666 31.9624 46.1541 33.793C45.4386 27.5084 40.5015 25.1591 34.503 28.6174C27.9679 32.3262 22.7565 41.4372 22.7565 48.9263V53.136C22.7114 54.8172 23.0541 56.4861 23.7583 58.0134L15.6848 62.6643C14.4201 63.4924 13.3675 64.6057 12.6115 65.9147C11.8555 67.2237 11.4172 68.6919 11.332 70.2012C11.332 72.9798 13.2878 74.1127 15.6848 72.7174L68.2995 42.3435C69.5668 41.5183 70.6214 40.4056 71.3778 39.096C72.1341 37.7864 72.5708 36.3168 72.6522 34.8067C72.6522 32.0281 70.7084 30.8952 68.2995 32.2904Z",
    fill: "#F0F0F0"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M506.079 63.7517L508.702 64.7535V58.9816C508.702 54.4023 512.352 53.3051 516.323 55.5948C518.408 56.9612 520.142 58.7991 521.385 60.9599C522.628 63.1207 523.345 65.5437 523.478 68.0329V68.8677C524.035 68.6966 524.624 68.6539 525.2 68.7427C525.777 68.8315 526.325 69.0496 526.805 69.3805C528.308 70.3611 529.558 71.6819 530.455 73.2357C531.352 74.7896 531.871 76.5329 531.969 78.3245V78.7061L535.63 80.8169C536.619 81.4631 537.442 82.3331 538.033 83.3566C538.623 84.3801 538.964 85.5282 539.029 86.7081C539.029 88.8785 537.502 89.7609 535.63 88.6757L506.055 71.6106C505.066 70.9644 504.243 70.0944 503.652 69.0709C503.062 68.0474 502.72 66.8993 502.656 65.7194C502.68 63.6086 504.207 62.6665 506.079 63.7517Z",
    fill: "#F0F0F0"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M520.996 31.0041L529.559 35.9412C529.511 35.5654 529.487 35.187 529.487 34.8083V32.3278C529.487 27.9154 532.576 26.1266 536.404 28.3328C538.049 29.3444 539.456 30.6989 540.53 32.304C541.15 26.7587 545.515 24.6837 550.798 27.7365C556.522 31.0399 561.149 39.0776 561.149 45.6246V49.3334C561.189 50.8159 560.892 52.2881 560.278 53.6384L567.434 57.7407C568.551 58.4707 569.481 59.4534 570.148 60.6095C570.815 61.7655 571.201 63.0624 571.274 64.3951C571.274 66.7802 569.556 67.8296 567.434 66.6132L521.044 39.8169C519.926 39.091 518.995 38.1108 518.327 36.9564C517.66 35.8019 517.275 34.5061 517.204 33.1745C517.156 30.7775 518.874 29.7758 520.996 31.0041Z",
    fill: "#F0F0F0"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M453.687 530.632C506.956 530.632 550.139 505.612 550.139 474.749C550.139 443.887 506.956 418.867 453.687 418.867C400.418 418.867 357.234 443.887 357.234 474.749C357.234 505.612 400.418 530.632 453.687 530.632Z",
    fill: "#E0E0E0"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7641 389.947C25.3506 389.882 25.9431 389.99 26.4694 390.257C27.4523 390.818 28.3788 391.473 29.2361 392.212C30.0975 392.958 31.1676 393.42 32.3009 393.536C32.8655 393.577 33.4272 393.423 33.8919 393.1C34.3565 392.776 34.6958 392.303 34.8529 391.759C34.8679 391.56 34.9205 391.366 35.008 391.187C35.1193 391.045 35.2741 390.944 35.4486 390.898C35.6232 390.853 35.8077 390.867 35.9739 390.936C36.2992 391.087 36.6105 391.267 36.9041 391.473C38.1258 392.017 39.4951 392.135 40.7917 391.807C41.8889 391.652 43.2722 391.163 43.2722 390.066C43.2722 389.338 42.6402 388.802 42.0797 388.277C41.5192 387.752 41.1853 386.918 41.6385 386.357C41.8069 386.17 42.0268 386.038 42.2705 385.975C43.6419 385.522 45.3115 386.118 46.4682 385.26C46.8813 384.916 47.1661 384.443 47.2765 383.917C47.3869 383.391 47.3164 382.843 47.0764 382.362C46.8312 381.894 46.488 381.485 46.0703 381.162C45.6525 380.839 45.17 380.609 44.6556 380.49C43.7373 380.251 42.5686 380.144 42.2705 379.297C41.9724 378.45 42.5806 377.687 43.2603 377.21C43.9991 376.833 44.6652 376.329 45.228 375.72C45.4618 375.355 45.5919 374.934 45.6045 374.501C45.6171 374.068 45.5117 373.64 45.2995 373.263C45.0785 372.893 44.7794 372.575 44.4231 372.332C44.0668 372.089 43.6619 371.926 43.2365 371.856C42.8088 371.82 42.3878 371.727 41.9843 371.581C41.7864 371.497 41.6281 371.34 41.5417 371.143C41.4553 370.946 41.4473 370.723 41.5192 370.52C41.6504 370.294 41.9008 370.174 42.0558 369.972C42.1676 369.748 42.1916 369.49 42.1232 369.25C42.0548 369.009 41.8989 368.803 41.6862 368.672C41.2522 368.421 40.7813 368.239 40.2909 368.135C39.3011 367.801 38.7883 367.276 39.0983 366.275C39.4084 365.273 40.8037 365.309 41.233 364.295C41.6623 363.281 40.5771 361.528 39.7781 360.98C38.9318 360.515 38.0507 360.116 37.1426 359.787C36.69 359.619 36.288 359.338 35.9748 358.971C35.6617 358.603 35.4479 358.162 35.3538 357.688C35.4511 356.696 35.9043 355.773 36.6298 355.089C37.2261 354.302 37.7389 353.216 37.2141 352.37C36.6894 351.523 35.5923 351.523 34.686 351.237C34.1336 351.061 33.6252 350.769 33.1953 350.38C32.7653 349.991 32.4237 349.515 32.1936 348.983C31.9431 348.434 31.8358 347.79 31.5496 347.29C31.0182 346.505 30.2768 345.885 29.4102 345.501C28.5436 345.118 27.5866 344.985 26.6483 345.119C26.2946 345.137 25.9524 345.251 25.6584 345.449C25.3643 345.646 25.1294 345.92 24.9787 346.24C24.6818 346.582 24.473 346.992 24.3705 347.433C24.2394 348.244 24.6567 349.257 23.9054 349.818C22.7129 350.748 21.0076 349.496 21.0672 351.571C21.0678 352.447 21.1963 353.319 21.4488 354.159C21.7589 355.029 22.3909 355.411 21.8662 356.389C21.1984 357.653 20.7571 357.641 19.4096 357.641C18.9651 357.563 18.5089 357.585 18.0738 357.704C17.6387 357.824 17.2356 358.038 16.8933 358.332C15.6292 359.632 16.3805 360.813 17.5015 361.815C18.6225 362.816 18.0978 363.46 17.9308 364.939C17.8593 365.655 18.0143 365.869 17.3823 366.346C16.1897 367.241 15.4981 366.943 15.8439 368.731C16.1897 370.52 15.6769 369.781 14.2817 370.377C12.8864 370.973 12.2424 372.225 11.2526 373.048C10.6087 373.585 9.63079 373.99 9.57116 374.921C9.46384 376.709 11.682 376.316 12.7314 376.745C14.4486 377.437 13.9239 379.703 12.6002 380.549C11.2765 381.396 9.09415 381.742 9.0226 383.817C8.9272 385.379 9.8216 385.725 11.038 386.202C12.0039 386.619 11.8847 386.739 11.8847 387.895C11.8847 390.28 12.6598 390.901 14.9614 390.519C15.6616 390.338 16.389 390.285 17.108 390.364C17.9905 390.638 17.6923 390.853 17.7162 391.556C17.7758 393.441 19.9701 392.904 20.9003 392.093C21.9496 391.014 23.2934 390.267 24.7641 389.947Z",
    fill: "#BA68C8"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M42.3307 385.976C43.3802 385.63 44.6085 385.892 45.646 385.654C45.034 385.509 44.4122 385.409 43.7856 385.355C43.0428 385.324 42.3018 385.45 41.6112 385.726C40.9206 386.001 40.2961 386.42 39.7787 386.954C40.325 387.626 40.6089 388.473 40.5777 389.339C37.978 390.042 35.4021 386.548 32.9216 387.609C33.0647 388.873 32.9216 390.567 31.7291 390.853C31.3591 390.89 30.9861 390.824 30.6515 390.661C30.3168 390.499 30.0336 390.248 29.833 389.935C29.3917 389.351 29.1174 388.635 28.6404 388.051C28.0096 387.286 27.1172 386.783 26.1364 386.64C25.1557 386.497 24.1568 386.723 23.3336 387.275C22.6539 387.764 21.8191 388.468 21.1394 388.015C20.4596 387.562 20.8651 386.071 20.0661 385.63C19.5295 385.367 18.7901 385.785 18.3488 385.391C18.1799 385.21 18.0715 384.981 18.0388 384.735C17.7287 383.412 17.4544 381.861 18.2892 380.788C19.124 379.715 20.6147 379.226 20.4477 378.021C20.2808 376.817 18.9928 376.674 17.9553 376.555C16.9178 376.435 15.5702 375.946 15.6537 374.909C15.7372 373.871 17.0967 373.394 17.2994 372.393C17.3829 371.963 17.2398 371.486 17.4306 371.093C17.7287 370.508 18.6231 370.485 19.0644 370.043C19.9468 369.256 19.2671 367.801 19.5175 366.645C19.6964 365.822 20.3523 365.178 20.5789 364.379C21.0082 362.757 19.5414 361.23 18.003 360.575C17.3981 360.36 16.8151 360.089 16.2619 359.764H16.2023C16.3486 360.573 16.8014 361.295 17.4664 361.779C18.7424 362.972 18.0626 363.425 17.8957 364.903C17.8241 365.619 17.9792 365.834 17.3471 366.311C16.1546 367.205 15.4629 366.907 15.8087 368.696C16.1546 370.485 15.6418 369.745 14.2465 370.341C12.8513 370.938 12.2073 372.19 11.2175 373.013C10.5735 373.549 9.59564 373.955 9.53601 374.885C9.42868 376.674 11.6468 376.28 12.6962 376.71C14.4135 377.401 13.8888 379.667 12.565 380.514C11.2413 381.36 9.05899 381.706 8.98744 383.781C8.89204 385.344 9.78644 385.689 11.0028 386.166C11.9688 386.584 11.8495 386.703 11.8495 387.86C11.8495 390.245 12.6247 390.865 14.9263 390.483C15.6402 390.31 16.38 390.269 17.1086 390.364C17.9911 390.638 17.693 390.853 17.7168 391.557C17.7764 393.441 19.9707 392.904 20.9009 392.093C21.9502 391.014 23.294 390.268 24.7647 389.947C25.3512 389.882 25.9437 389.99 26.47 390.257C27.4529 390.818 28.3795 391.473 29.2367 392.213C30.0981 392.958 31.1682 393.42 32.3015 393.536C32.8662 393.578 33.4279 393.424 33.8925 393.1C34.3571 392.777 34.6964 392.303 34.8535 391.759C34.8685 391.561 34.9211 391.366 35.0086 391.187C35.1199 391.045 35.2747 390.944 35.4493 390.899C35.6238 390.853 35.8083 390.867 35.9745 390.937C36.2999 391.088 36.6111 391.267 36.9047 391.473C38.1265 392.017 39.4957 392.135 40.7924 391.807C41.8895 391.652 43.2728 391.163 43.2728 390.066C43.2728 389.339 42.6408 388.802 42.0803 388.277C41.5198 387.752 41.1859 386.918 41.6391 386.357C41.8235 386.16 42.0656 386.026 42.3307 385.976Z",
    fill: "black"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1758 370.71L27.4604 383.208V377.472L28.1044 353.061L29.0346 377.472V381.324L35.9394 369.255L29.0346 384.043V421.882C29.025 421.951 28.9982 422.017 28.9565 422.073C28.9148 422.13 28.8597 422.174 28.7961 422.204C28.6229 422.286 28.4334 422.329 28.2416 422.329C28.0497 422.329 27.8602 422.286 27.687 422.204C27.6263 422.172 27.5741 422.126 27.5346 422.07C27.4952 422.014 27.4698 421.95 27.4604 421.882V386.344L21.1758 370.71Z",
    fill: "#263238"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1903 400.822C47.7147 400.769 48.2435 400.864 48.7167 401.096C49.6077 401.605 50.4465 402.2 51.2211 402.873C52.0023 403.54 52.9665 403.955 53.9877 404.065C54.4998 404.104 55.0096 403.966 55.4311 403.672C55.8526 403.379 56.16 402.949 56.3013 402.456C56.3195 402.279 56.3637 402.106 56.4324 401.943C56.5368 401.817 56.6784 401.727 56.8369 401.686C56.9954 401.645 57.1627 401.656 57.3149 401.716C57.6086 401.851 57.8882 402.015 58.1497 402.205C59.2552 402.698 60.495 402.803 61.6677 402.503C62.6575 402.36 63.9096 401.919 63.9096 400.929C63.9096 400.273 63.3372 399.737 62.8841 399.319C62.4309 398.902 62.0731 398.127 62.4786 397.578C62.6288 397.406 62.8289 397.285 63.051 397.232C64.2436 396.827 65.8058 397.363 66.8552 396.588C67.2237 396.273 67.4774 395.845 67.5766 395.37C67.6759 394.895 67.6151 394.401 67.4038 393.965C67.1755 393.539 66.8582 393.167 66.4734 392.875C66.0886 392.583 65.6453 392.377 65.1737 392.271C64.339 392.057 63.2895 391.961 62.9795 391.162C62.6694 390.363 63.2537 389.707 63.8619 389.278C64.5277 388.949 65.1326 388.51 65.6507 387.978C65.8527 387.643 65.9595 387.26 65.9595 386.869C65.9595 386.478 65.8527 386.095 65.6507 385.76C65.4667 385.417 65.2104 385.117 64.8995 384.883C64.5886 384.648 64.2306 384.484 63.85 384.401C63.4421 384.378 63.0399 384.294 62.6575 384.15C62.3116 383.971 62.0493 383.53 62.2401 383.196C62.4309 382.862 62.5859 382.886 62.7171 382.695C62.8231 382.491 62.8476 382.254 62.7856 382.033C62.7236 381.812 62.5798 381.622 62.3832 381.503C61.9875 381.283 61.5616 381.122 61.1191 381.026C60.2247 380.728 59.7596 380.251 60.0339 379.344C60.3082 378.438 61.5842 378.462 61.9658 377.555C62.3474 376.649 61.3695 375.051 60.654 374.562C59.8872 374.148 59.0899 373.793 58.2689 373.501C57.8593 373.351 57.4955 373.098 57.2133 372.766C56.9311 372.433 56.7401 372.033 56.659 371.605C56.7437 370.688 57.1693 369.837 57.8516 369.22C58.3882 368.516 58.8533 367.526 58.3763 366.763C57.8993 366 56.9095 366 56.0866 365.737C55.5897 365.577 55.1322 365.313 54.7438 364.964C54.3555 364.614 54.0451 364.187 53.8327 363.71C53.6181 363.209 53.5107 362.649 53.2484 362.172C52.7705 361.461 52.1019 360.899 51.3193 360.551C50.5367 360.203 49.6719 360.083 48.8241 360.204C48.5051 360.226 48.1978 360.333 47.9337 360.513C47.6697 360.693 47.4583 360.941 47.3215 361.23C47.0568 361.521 46.8683 361.873 46.7729 362.255C46.6537 362.983 47.0353 363.901 46.3555 364.461C45.318 365.296 43.72 364.163 43.7796 366.047C43.7771 366.855 43.8936 367.659 44.1255 368.432C44.4117 369.22 44.9841 369.553 44.5071 370.436C43.8989 371.628 43.5054 371.628 42.277 371.628C41.8771 371.551 41.4648 371.567 41.072 371.675C40.6791 371.782 40.3162 371.979 40.0112 372.249C38.8187 373.441 39.5461 374.491 40.5598 375.397C41.5735 376.303 41.0964 376.888 40.9533 378.223C40.8818 378.867 41.0249 379.07 40.4525 379.487C39.3553 380.298 38.7471 380.024 39.0572 381.61C39.3673 383.196 38.9022 382.564 37.65 383.101C36.3978 383.637 35.8135 384.77 34.9072 385.486C34.3348 385.963 33.4523 386.332 33.3927 387.179C33.2973 388.789 35.3007 388.372 36.2428 388.825C37.805 389.445 37.3399 391.496 36.1236 392.259C34.9072 393.023 32.9633 393.368 32.856 395.205C32.7845 396.624 33.5835 396.934 34.6806 397.411C35.5631 397.793 35.4438 397.9 35.4438 398.949C35.4438 401.06 36.1593 401.657 38.2344 401.335C38.889 401.149 39.5735 401.092 40.2497 401.168C41.0368 401.406 40.7745 401.609 40.7983 402.277C40.7983 403.97 42.8375 403.469 43.6723 402.766C44.6245 401.781 45.8498 401.104 47.1903 400.822Z",
    fill: "#BA68C8"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M47.1903 400.822C47.7147 400.769 48.2435 400.864 48.7167 401.096C49.6077 401.605 50.4465 402.2 51.2211 402.873C52.0023 403.54 52.9665 403.955 53.9877 404.065C54.4998 404.104 55.0096 403.966 55.4311 403.672C55.8526 403.379 56.16 402.949 56.3013 402.456C56.3195 402.279 56.3637 402.106 56.4324 401.943C56.5368 401.817 56.6784 401.727 56.8369 401.686C56.9954 401.645 57.1627 401.656 57.3149 401.716C57.6086 401.851 57.8882 402.015 58.1497 402.205C59.2552 402.698 60.495 402.803 61.6677 402.503C62.6575 402.36 63.9096 401.919 63.9096 400.929C63.9096 400.273 63.3372 399.737 62.8841 399.319C62.4309 398.902 62.0731 398.127 62.4786 397.578C62.6288 397.406 62.8289 397.285 63.051 397.232C64.2436 396.827 65.8058 397.363 66.8552 396.588C67.2237 396.273 67.4774 395.845 67.5766 395.37C67.6759 394.895 67.6151 394.401 67.4038 393.965C67.1755 393.539 66.8582 393.167 66.4734 392.875C66.0886 392.583 65.6453 392.377 65.1737 392.271C64.339 392.057 63.2895 391.961 62.9795 391.162C62.6694 390.363 63.2537 389.707 63.8619 389.278C64.5277 388.949 65.1326 388.51 65.6507 387.978C65.8527 387.643 65.9595 387.26 65.9595 386.869C65.9595 386.478 65.8527 386.095 65.6507 385.76C65.4667 385.417 65.2104 385.117 64.8995 384.883C64.5886 384.648 64.2306 384.484 63.85 384.401C63.4421 384.378 63.0399 384.294 62.6575 384.15C62.3116 383.971 62.0493 383.53 62.2401 383.196C62.4309 382.862 62.5859 382.886 62.7171 382.695C62.8231 382.491 62.8476 382.254 62.7856 382.033C62.7236 381.812 62.5798 381.622 62.3832 381.503C61.9875 381.283 61.5616 381.122 61.1191 381.026C60.2247 380.728 59.7596 380.251 60.0339 379.344C60.3082 378.438 61.5842 378.462 61.9658 377.555C62.3474 376.649 61.3695 375.051 60.654 374.562C59.8872 374.148 59.0899 373.793 58.2689 373.501C57.8593 373.351 57.4955 373.098 57.2133 372.766C56.9311 372.433 56.7401 372.033 56.659 371.605C56.7437 370.688 57.1693 369.837 57.8516 369.22C58.3882 368.516 58.8533 367.526 58.3763 366.763C57.8993 366 56.9095 366 56.0866 365.737C55.5897 365.577 55.1322 365.313 54.7438 364.964C54.3555 364.614 54.0451 364.187 53.8327 363.71C53.6181 363.209 53.5107 362.649 53.2484 362.172C52.7705 361.461 52.1019 360.899 51.3193 360.551C50.5367 360.203 49.6719 360.083 48.8241 360.204C48.5051 360.226 48.1978 360.333 47.9337 360.513C47.6697 360.693 47.4583 360.941 47.3215 361.23C47.0568 361.521 46.8683 361.873 46.7729 362.255C46.6537 362.983 47.0353 363.901 46.3555 364.461C45.318 365.296 43.72 364.163 43.7796 366.047C43.7771 366.855 43.8936 367.659 44.1255 368.432C44.4117 369.22 44.9841 369.553 44.5071 370.436C43.8989 371.628 43.5054 371.628 42.277 371.628C41.8771 371.551 41.4648 371.567 41.072 371.675C40.6791 371.782 40.3162 371.979 40.0112 372.249C38.8187 373.441 39.5461 374.491 40.5598 375.397C41.5735 376.303 41.0964 376.888 40.9533 378.223C40.8818 378.867 41.0249 379.07 40.4525 379.487C39.3553 380.298 38.7471 380.024 39.0572 381.61C39.3673 383.196 38.9022 382.564 37.65 383.101C36.3978 383.637 35.8135 384.77 34.9072 385.486C34.3348 385.963 33.4523 386.332 33.3927 387.179C33.2973 388.789 35.3007 388.372 36.2428 388.825C37.805 389.445 37.3399 391.496 36.1236 392.259C34.9072 393.023 32.9633 393.368 32.856 395.205C32.7845 396.624 33.5835 396.934 34.6806 397.411C35.5631 397.793 35.4438 397.9 35.4438 398.949C35.4438 401.06 36.1593 401.657 38.2344 401.335C38.889 401.149 39.5735 401.092 40.2497 401.168C41.0368 401.406 40.7745 401.609 40.7983 402.277C40.7983 403.97 42.8375 403.469 43.6723 402.766C44.6245 401.781 45.8498 401.104 47.1903 400.822Z",
    fill: "black"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.0487 397.232C64.0028 396.922 65.1118 397.16 66.0539 396.934C65.4993 396.812 64.9377 396.725 64.3725 396.671C63.7085 396.65 63.0474 396.767 62.4313 397.015C61.8152 397.264 61.2578 397.638 60.7949 398.114C61.2855 398.73 61.5431 399.498 61.5223 400.285C59.1372 400.929 56.8476 397.769 54.5937 398.735C54.7368 399.927 54.5937 401.406 53.4846 401.656C53.152 401.691 52.8163 401.632 52.5151 401.487C52.2139 401.342 51.9591 401.115 51.7793 400.833C51.3738 400.297 51.1234 399.641 50.7179 399.128C50.1537 398.437 49.3516 397.982 48.4692 397.852C47.5867 397.722 46.6875 397.926 45.9478 398.425C45.3396 398.866 44.5764 399.534 43.9682 399.092C43.36 398.651 43.7058 397.339 42.9903 396.982C42.5133 396.743 41.7978 397.125 41.44 396.767C41.2881 396.607 41.1919 396.402 41.1657 396.183C40.9401 395.606 40.8424 394.988 40.8794 394.37C40.9165 393.752 41.0874 393.15 41.3804 392.605C42.0601 391.734 43.4912 391.198 43.3361 390.101C43.1811 389.003 42.0124 388.908 41.0822 388.777C40.1521 388.646 38.9595 388.228 39.0072 387.286C39.0549 386.344 40.3071 385.915 40.486 385.02C40.5694 384.627 40.486 384.198 40.6172 383.828C40.7483 383.458 41.6427 383.279 42.084 382.886C42.883 382.182 42.2629 380.847 42.4894 379.809C42.6564 379.07 43.2527 378.485 43.4554 377.758C43.8489 376.303 42.5252 374.92 41.0703 374.323C40.521 374.133 39.9934 373.885 39.4962 373.584C39.5636 373.952 39.7039 374.303 39.9086 374.616C40.1134 374.93 40.3786 375.199 40.6887 375.409C41.8812 376.446 41.2253 376.899 41.0822 378.235C41.0107 378.879 41.1538 379.082 40.5814 379.499C39.4842 380.31 38.876 380.036 39.1861 381.622C39.4962 383.208 39.0311 382.576 37.7789 383.112C36.5268 383.649 35.9424 384.782 35.0361 385.497C34.4637 385.974 33.5812 386.344 33.5216 387.191C33.4262 388.801 35.4296 388.383 36.3717 388.837C37.9339 389.457 37.4689 391.508 36.2525 392.271C35.0361 393.034 33.0922 393.38 32.9849 395.217C32.9134 396.636 33.7124 396.946 34.8095 397.423C35.692 397.804 35.5727 397.912 35.5727 398.961C35.5727 401.072 36.2882 401.668 38.3633 401.346C39.0179 401.161 39.7024 401.104 40.3786 401.179C41.1657 401.418 40.9034 401.621 40.9272 402.288C40.9272 403.982 42.9664 403.481 43.8012 402.777C44.7502 401.795 45.9711 401.118 47.3073 400.833C47.8317 400.781 48.3604 400.876 48.8337 401.108C49.7247 401.617 50.5635 402.212 51.338 402.885C52.1193 403.551 53.0835 403.967 54.1047 404.077C54.6168 404.116 55.1266 403.977 55.5481 403.684C55.9696 403.391 56.2769 402.961 56.4183 402.467C56.4365 402.291 56.4807 402.118 56.5494 401.954C56.6538 401.828 56.7953 401.738 56.9539 401.698C57.1124 401.657 57.2797 401.668 57.4319 401.728C57.7255 401.863 58.0051 402.027 58.2667 402.217C59.3722 402.71 60.6119 402.815 61.7847 402.515C62.7745 402.372 64.0266 401.931 64.0266 400.941C64.0266 400.285 63.4542 399.748 63.0011 399.331C62.5479 398.913 62.1901 398.138 62.5956 397.59C62.712 397.432 62.8685 397.309 63.0487 397.232Z",
    fill: "black"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9336 383.435L49.622 394.693V389.517L50.1944 367.443L51.0292 389.517V392.999L57.2781 382.088L51.0292 395.48V429.718C51.0267 429.78 51.0062 429.84 50.9702 429.891C50.9342 429.941 50.8843 429.981 50.8264 430.004C50.6724 430.086 50.5003 430.129 50.3256 430.129C50.1508 430.129 49.9788 430.086 49.8247 430.004C49.7669 429.981 49.7169 429.941 49.681 429.891C49.645 429.84 49.6245 429.78 49.622 429.718V397.519L43.9336 383.435Z",
    fill: "#263238"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M348.534 403.413C347.611 402.942 346.589 402.697 345.553 402.697C344.517 402.697 343.495 402.942 342.571 403.413C342.239 403.569 341.954 403.81 341.745 404.111C341.535 404.413 341.409 404.764 341.379 405.13C341.408 405.495 341.533 405.845 341.743 406.145C341.953 406.445 342.239 406.683 342.571 406.835C343.493 407.311 344.515 407.559 345.553 407.559C346.59 407.559 347.612 407.311 348.534 406.835C348.867 406.683 349.153 406.445 349.363 406.145C349.572 405.845 349.698 405.495 349.727 405.13C349.696 404.764 349.57 404.413 349.361 404.111C349.152 403.81 348.866 403.569 348.534 403.413Z",
    fill: "#455A64"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M349.762 405.13C349.732 404.764 349.605 404.413 349.396 404.111C349.187 403.81 348.902 403.569 348.569 403.413C347.646 402.942 346.624 402.697 345.588 402.697C344.552 402.697 343.53 402.942 342.607 403.413C342.274 403.569 341.989 403.81 341.78 404.111C341.57 404.413 341.444 404.764 341.414 405.13V406.132C341.444 406.497 341.57 406.849 341.78 407.15C341.989 407.452 342.274 407.693 342.607 407.849C343.528 408.325 344.551 408.573 345.588 408.573C346.625 408.573 347.648 408.325 348.569 407.849C348.902 407.693 349.187 407.452 349.396 407.15C349.605 406.849 349.732 406.497 349.762 406.132V405.13Z",
    fill: "#263238"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M348.534 403.413C347.611 402.942 346.589 402.697 345.553 402.697C344.517 402.697 343.495 402.942 342.571 403.413C342.239 403.569 341.954 403.81 341.745 404.111C341.535 404.413 341.409 404.764 341.379 405.13C341.408 405.495 341.533 405.845 341.743 406.145C341.953 406.445 342.239 406.683 342.571 406.835C343.493 407.311 344.515 407.559 345.553 407.559C346.59 407.559 347.612 407.311 348.534 406.835C348.867 406.683 349.153 406.445 349.363 406.145C349.572 405.845 349.698 405.495 349.727 405.13C349.696 404.764 349.57 404.413 349.361 404.111C349.152 403.81 348.866 403.569 348.534 403.413Z",
    fill: "#455A64"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M342.465 372.131C342.489 371.859 342.585 371.598 342.745 371.375C342.904 371.153 343.121 370.977 343.371 370.867C344.053 370.521 344.807 370.34 345.571 370.34C346.336 370.34 347.09 370.521 347.772 370.867C348.022 370.977 348.238 371.153 348.398 371.375C348.557 371.598 348.654 371.859 348.678 372.131V404.831C348.654 405.105 348.557 405.367 348.398 405.591C348.238 405.816 348.022 405.993 347.772 406.107C347.088 406.448 346.335 406.625 345.571 406.625C344.808 406.625 344.054 406.448 343.371 406.107C343.121 405.993 342.904 405.816 342.745 405.591C342.586 405.367 342.489 405.105 342.465 404.831V372.131Z",
    fill: "#37474F"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M347.772 370.867C347.09 370.521 346.336 370.34 345.571 370.34C344.807 370.34 344.053 370.521 343.371 370.867C343.121 370.977 342.904 371.153 342.745 371.375C342.585 371.598 342.489 371.859 342.465 372.131C342.489 372.405 342.586 372.668 342.745 372.892C342.904 373.116 343.121 373.294 343.371 373.407C344.053 373.754 344.807 373.935 345.571 373.935C346.336 373.935 347.09 373.754 347.772 373.407C348.022 373.294 348.238 373.116 348.398 372.892C348.557 372.668 348.654 372.405 348.678 372.131C348.654 371.859 348.557 371.598 348.398 371.375C348.238 371.153 348.022 370.977 347.772 370.867Z",
    fill: "#455A64"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M346.078 295.606V372.131C346.076 372.177 346.062 372.221 346.036 372.259C346.011 372.296 345.976 372.327 345.935 372.346C345.821 372.399 345.697 372.427 345.571 372.427C345.446 372.427 345.322 372.399 345.208 372.346C345.167 372.327 345.132 372.296 345.106 372.259C345.081 372.221 345.067 372.177 345.065 372.131V295.606C345.053 295.533 345.058 295.459 345.078 295.388C345.099 295.317 345.134 295.251 345.182 295.195C345.23 295.138 345.29 295.093 345.357 295.062C345.424 295.032 345.497 295.016 345.571 295.016C345.645 295.016 345.718 295.032 345.786 295.062C345.853 295.093 345.912 295.138 345.961 295.195C346.009 295.251 346.044 295.317 346.064 295.388C346.085 295.459 346.089 295.533 346.078 295.606Z",
    fill: "#263238"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M346.028 311.656H345.109C345.151 309.667 345.711 307.723 346.733 306.017C347.756 304.31 349.206 302.9 350.941 301.925C352.893 300.8 355.111 300.22 357.364 300.245C359.617 300.27 361.822 300.9 363.749 302.068L363.296 302.867C361.504 301.774 359.451 301.183 357.353 301.158C355.254 301.133 353.187 301.674 351.37 302.724C349.781 303.621 348.452 304.916 347.515 306.482C346.578 308.048 346.066 309.832 346.028 311.656Z",
    fill: "#263238"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M346.027 311.656H345.108C345.067 309.828 344.549 308.043 343.605 306.476C342.662 304.91 341.326 303.616 339.73 302.724C337.913 301.674 335.846 301.133 333.748 301.158C331.649 301.183 329.596 301.774 327.805 302.867L327.352 302.068C329.278 300.9 331.483 300.27 333.736 300.245C335.989 300.22 338.207 300.8 340.159 301.925C341.901 302.895 343.358 304.304 344.387 306.011C345.416 307.717 345.981 309.664 346.027 311.656Z",
    fill: "#263238"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M363.178 305.623L365.468 307.21C366.434 307.84 367.547 308.209 368.698 308.283C369.85 308.356 371 308.13 372.039 307.627C372.376 307.481 372.67 307.249 372.89 306.954C373.109 306.659 373.248 306.311 373.291 305.945C373.291 305.719 373.291 304.872 373.291 304.658C373.291 303.966 372.754 303.286 371.681 302.785L368.103 301.128C366.088 300.209 363.44 300.03 362.2 300.758C361.987 300.856 361.808 301.015 361.685 301.214C361.562 301.414 361.501 301.645 361.508 301.879C361.508 302.094 361.508 302.94 361.508 303.143C361.579 303.656 361.766 304.147 362.056 304.577C362.345 305.007 362.729 305.365 363.178 305.623Z",
    fill: "#263238"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M362.141 300.758C360.889 301.473 361.354 303.083 363.178 304.335L365.468 305.921C366.434 306.552 367.547 306.921 368.698 306.994C369.85 307.068 371 306.842 372.039 306.339C373.851 305.289 373.673 303.691 371.657 302.761L368.08 301.104C366.028 300.209 363.381 300.03 362.141 300.758Z",
    fill: "#37474F"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M361.984 301.856C361.994 301.724 362.038 301.596 362.111 301.486C362.184 301.375 362.284 301.285 362.402 301.224C362.99 300.95 363.637 300.823 364.286 300.854C365.519 300.865 366.737 301.129 367.864 301.63L371.441 303.287C372.252 303.669 372.729 304.158 372.753 304.635C372.777 305.112 372.431 305.505 371.775 305.887C370.992 306.297 370.119 306.502 369.235 306.483C368.015 306.502 366.817 306.162 365.789 305.505L363.511 303.907C363.121 303.699 362.782 303.408 362.518 303.053C362.254 302.698 362.072 302.29 361.984 301.856Z",
    fill: "#455A64"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M327.151 305.623L324.909 307.21C323.943 307.84 322.83 308.209 321.678 308.283C320.527 308.356 319.376 308.13 318.338 307.627C318 307.481 317.707 307.249 317.487 306.954C317.267 306.659 317.129 306.311 317.086 305.945C317.086 305.719 317.086 304.872 317.086 304.658C317.086 303.966 317.634 303.286 318.708 302.785L322.285 301.128C324.301 300.209 326.948 300.03 328.188 300.758C328.401 300.856 328.58 301.015 328.703 301.214C328.826 301.414 328.888 301.645 328.88 301.879C328.88 302.094 328.88 302.94 328.88 303.143C328.804 303.662 328.608 304.156 328.308 304.587C328.008 305.017 327.612 305.372 327.151 305.623Z",
    fill: "#263238"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M328.189 300.758C329.441 301.473 328.964 303.083 327.151 304.336L324.909 305.945C323.943 306.576 322.83 306.945 321.679 307.018C320.527 307.092 319.377 306.866 318.338 306.363C316.526 305.313 316.705 303.715 318.72 302.785L322.298 301.128C324.301 300.209 326.948 300.03 328.189 300.758Z",
    fill: "#37474F"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M328.343 301.856C328.333 301.724 328.29 301.596 328.217 301.486C328.144 301.375 328.043 301.285 327.926 301.224C327.337 300.95 326.69 300.823 326.041 300.854C324.808 300.865 323.591 301.129 322.464 301.63L318.946 303.311C318.135 303.693 317.658 304.182 317.634 304.659C317.61 305.136 317.956 305.529 318.6 305.911C319.387 306.32 320.265 306.525 321.152 306.507C322.368 306.528 323.563 306.187 324.586 305.529L326.876 303.931C327.258 303.714 327.587 303.416 327.841 303.057C328.094 302.698 328.266 302.288 328.343 301.856Z",
    fill: "#455A64"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M301.976 148.568L256.898 174.601V434.968L301.988 408.935L301.976 148.568Z",
    fill: "#BA68C8"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M301.976 148.568L256.898 174.601V434.968L301.988 408.935L301.976 148.568Z",
    fill: "white"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M211.797 200.635L166.707 226.668V487.046L211.797 461.001V200.635Z",
    fill: "#BA68C8"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M211.797 200.635L166.707 226.668V487.046L211.797 461.001V200.635Z",
    fill: "white"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M196.78 225.545V244.494L181.719 253.188V234.239L196.78 225.545Z",
    fill: "#37474F"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M194.968 243.289L181.719 250.946V234.238L194.968 226.582V243.289Z",
    fill: "#BA68C8"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M194.968 243.289L181.719 250.946V234.238L194.968 226.582V243.289Z",
    fill: "white"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M196.781 225.545L194.969 226.582V243.29L196.781 244.494V225.545Z",
    fill: "#455A64"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M180.051 254.155L198.452 243.529L199.274 244.006L180.874 254.632L180.051 254.155Z",
    fill: "#BA68C8"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M180.871 254.631V256.563L199.272 245.938V244.006L180.871 254.631Z",
    fill: "#BA68C8"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M180.871 254.631V256.563L199.272 245.938V244.006L180.871 254.631Z",
    fill: "black"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M180.051 254.152V256.084L180.874 256.561V254.629L180.051 254.152Z",
    fill: "#BA68C8"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M180.051 254.152V256.084L180.874 256.561V254.629L180.051 254.152Z",
    fill: "black"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M188.41 247.082V230.375L189.388 229.814V246.522L188.41 247.082Z",
    fill: "#455A64"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M196.78 253.119V272.069L181.719 280.762V261.813L196.78 253.119Z",
    fill: "#37474F"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M194.968 270.875L181.719 278.531V261.812L194.968 254.168V270.875Z",
    fill: "#BA68C8"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M194.968 270.875L181.719 278.531V261.812L194.968 254.168V270.875Z",
    fill: "white"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M196.781 253.119L194.969 254.169V270.876L196.781 272.069V253.119Z",
    fill: "#455A64"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M180.051 281.729L198.452 271.104L199.274 271.592L180.874 282.218L180.051 281.729Z",
    fill: "#BA68C8"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M180.871 282.217V284.149L199.272 273.512V271.592L180.871 282.217Z",
    fill: "#BA68C8"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M180.871 282.217V284.149L199.272 273.512V271.592L180.871 282.217Z",
    fill: "black"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M180.051 281.727V283.658L180.874 284.147V282.216L180.051 281.727Z",
    fill: "#BA68C8"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M180.051 281.727V283.658L180.874 284.147V282.216L180.051 281.727Z",
    fill: "black"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M188.41 274.656V257.961L189.388 257.4V274.096L188.41 274.656Z",
    fill: "#455A64"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M196.78 284.684V303.633L181.719 312.327V293.377L196.78 284.684Z",
    fill: "#37474F"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M194.968 302.428L181.719 310.084V293.377L194.968 285.721V302.428Z",
    fill: "#BA68C8"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M194.968 302.428L181.719 310.084V293.377L194.968 285.721V302.428Z",
    fill: "white"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M196.781 284.684L194.969 285.721V302.429L196.781 303.633V284.684Z",
    fill: "#455A64"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M180.051 313.293L198.452 302.668L199.274 303.145L180.874 313.77L180.051 313.293Z",
    fill: "#BA68C8"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M180.871 313.77V315.702L199.272 305.076V303.145L180.871 313.77Z",
    fill: "#BA68C8"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M180.871 313.77V315.702L199.272 305.076V303.145L180.871 313.77Z",
    fill: "black"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M180.051 313.291V315.223L180.874 315.7V313.768L180.051 313.291Z",
    fill: "#BA68C8"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M180.051 313.291V315.223L180.874 315.7V313.768L180.051 313.291Z",
    fill: "black"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M188.41 306.221V289.514L189.388 288.953V305.661L188.41 306.221Z",
    fill: "#455A64"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M196.78 312.256V331.205L181.719 339.911V320.961L196.78 312.256Z",
    fill: "#37474F"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M194.968 330.012L181.719 337.668V320.961L194.968 313.305V330.012Z",
    fill: "#BA68C8"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M194.968 330.012L181.719 337.668V320.961L194.968 313.305V330.012Z",
    fill: "white"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M196.781 312.256L194.969 313.305V330.013L196.781 331.205V312.256Z",
    fill: "#455A64"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M180.051 340.878L198.452 330.24L199.274 330.729L180.874 341.343L180.051 340.878Z",
    fill: "#BA68C8"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M180.871 341.342V343.274L199.272 332.66V330.729L180.871 341.342Z",
    fill: "#BA68C8"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M180.871 341.342V343.274L199.272 332.66V330.729L180.871 341.342Z",
    fill: "black"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M180.051 340.877V342.809L180.874 343.274V341.342L180.051 340.877Z",
    fill: "#BA68C8"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M180.051 340.877V342.809L180.874 343.274V341.342L180.051 340.877Z",
    fill: "black"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M188.41 333.805V317.098L189.388 316.525V333.245L188.41 333.805Z",
    fill: "#455A64"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M196.78 343.82V362.77L181.719 371.463V352.514L196.78 343.82Z",
    fill: "#37474F"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M194.968 361.565L181.719 369.221V352.514L194.968 344.857V361.565Z",
    fill: "#BA68C8"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M194.968 361.565L181.719 369.221V352.514L194.968 344.857V361.565Z",
    fill: "white"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M196.781 343.82L194.969 344.858V361.565L196.781 362.77V343.82Z",
    fill: "#455A64"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M180.051 372.43L198.452 361.805L199.274 362.282L180.874 372.907L180.051 372.43Z",
    fill: "#BA68C8"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M180.871 372.907V374.839L199.272 364.213V362.281L180.871 372.907Z",
    fill: "#BA68C8"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M180.871 372.907V374.839L199.272 364.213V362.281L180.871 372.907Z",
    fill: "black"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M180.051 372.428V374.36L180.874 374.837V372.905L180.051 372.428Z",
    fill: "#BA68C8"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M180.051 372.428V374.36L180.874 374.837V372.905L180.051 372.428Z",
    fill: "black"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M188.41 365.358V348.65L189.388 348.09V364.797L188.41 365.358Z",
    fill: "#455A64"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M196.78 371.406V390.356L181.719 399.037V380.088L196.78 371.406Z",
    fill: "#37474F"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M194.968 389.151L181.719 396.807V380.088L194.968 372.443V389.151Z",
    fill: "#BA68C8"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M194.968 389.151L181.719 396.807V380.088L194.968 372.443V389.151Z",
    fill: "white"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M196.781 371.406L194.969 372.444V389.151L196.781 390.356V371.406Z",
    fill: "#455A64"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M180.051 400.004L198.452 389.391L199.274 389.856L180.874 400.493L180.051 400.004Z",
    fill: "#BA68C8"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M180.871 400.493V402.425L199.272 391.799V389.855L180.871 400.493Z",
    fill: "#BA68C8"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M180.871 400.493V402.425L199.272 391.799V389.855L180.871 400.493Z",
    fill: "black"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M180.051 400.004V401.936L180.874 402.425V400.493L180.051 400.004Z",
    fill: "#BA68C8"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M180.051 400.004V401.936L180.874 402.425V400.493L180.051 400.004Z",
    fill: "black"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M188.41 392.944V376.236L189.388 375.676V392.383L188.41 392.944Z",
    fill: "#455A64"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M196.78 402.959V421.908L181.719 430.602V411.653L196.78 402.959Z",
    fill: "#37474F"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M194.968 420.704L181.719 428.36V411.652L194.968 403.996V420.704Z",
    fill: "#BA68C8"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M194.968 420.704L181.719 428.36V411.652L194.968 403.996V420.704Z",
    fill: "white"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M196.781 402.959L194.969 403.996V420.704L196.781 421.908V402.959Z",
    fill: "#455A64"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M180.051 431.569L198.452 420.943L199.274 421.42L180.874 432.046L180.051 431.569Z",
    fill: "#BA68C8"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M180.871 432.045V433.977L199.272 423.352V421.42L180.871 432.045Z",
    fill: "#BA68C8"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M180.871 432.045V433.977L199.272 423.352V421.42L180.871 432.045Z",
    fill: "black"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M180.051 431.566V433.498L180.874 433.975V432.043L180.051 431.566Z",
    fill: "#BA68C8"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M180.051 431.566V433.498L180.874 433.975V432.043L180.051 431.566Z",
    fill: "black"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M188.41 424.496V407.789L189.388 407.229V423.936L188.41 424.496Z",
    fill: "#455A64"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M196.78 430.545V449.482L181.719 458.188V439.239L196.78 430.545Z",
    fill: "#37474F"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M194.968 448.289L181.719 455.946V439.238L194.968 431.582V448.289Z",
    fill: "#BA68C8"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M194.968 448.289L181.719 455.946V439.238L194.968 431.582V448.289Z",
    fill: "white"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M196.781 430.545L194.969 431.582V448.29L196.781 449.482V430.545Z",
    fill: "#455A64"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M180.051 459.155L198.452 448.518L199.274 449.007L180.874 459.632L180.051 459.155Z",
    fill: "#BA68C8"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M180.871 459.631V461.563L199.272 450.938V449.006L180.871 459.631Z",
    fill: "#BA68C8"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M180.871 459.631V461.563L199.272 450.938V449.006L180.871 459.631Z",
    fill: "black"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M180.051 459.152V461.084L180.874 461.561V459.629L180.051 459.152Z",
    fill: "#BA68C8"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M180.051 459.152V461.084L180.874 461.561V459.629L180.051 459.152Z",
    fill: "black"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M188.41 452.082V435.375L189.388 434.814V451.522L188.41 452.082Z",
    fill: "#455A64"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M286.984 173.373V192.322L271.922 201.016V182.067L286.984 173.373Z",
    fill: "#37474F"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M285.171 191.118L271.922 198.774V182.066L285.171 174.41V191.118Z",
    fill: "#BA68C8"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M285.171 191.118L271.922 198.774V182.066L285.171 174.41V191.118Z",
    fill: "white"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M286.985 173.373L285.172 174.411V191.118L286.985 192.322V173.373Z",
    fill: "#455A64"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M270.254 201.983L288.655 191.357L289.478 191.834L271.077 202.46L270.254 201.983Z",
    fill: "#BA68C8"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M271.074 202.459V204.391L289.475 193.766V191.834L271.074 202.459Z",
    fill: "#BA68C8"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M271.074 202.459V204.391L289.475 193.766V191.834L271.074 202.459Z",
    fill: "black"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M270.254 201.98V203.912L271.077 204.389V202.457L270.254 201.98Z",
    fill: "#BA68C8"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M270.254 201.98V203.912L271.077 204.389V202.457L270.254 201.98Z",
    fill: "black"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M278.613 194.911V178.203L279.591 177.643V194.35L278.613 194.911Z",
    fill: "#455A64"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M286.984 200.943V219.905L271.922 228.586V209.649L286.984 200.943Z",
    fill: "#37474F"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M285.171 218.7L271.922 226.356V209.648L285.171 201.992V218.7Z",
    fill: "#BA68C8"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M285.171 218.7L271.922 226.356V209.648L285.171 201.992V218.7Z",
    fill: "white"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M286.985 200.943L285.172 201.993V218.7L286.985 219.905V200.943Z",
    fill: "#455A64"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M270.254 229.565L288.655 218.939L289.478 219.416L271.077 230.042L270.254 229.565Z",
    fill: "#BA68C8"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M271.074 230.042V231.973L289.475 221.348V219.416L271.074 230.042Z",
    fill: "#BA68C8"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M271.074 230.042V231.973L289.475 221.348V219.416L271.074 230.042Z",
    fill: "black"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M270.254 229.564V231.496L271.077 231.973V230.041L270.254 229.564Z",
    fill: "#BA68C8"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M270.254 229.564V231.496L271.077 231.973V230.041L270.254 229.564Z",
    fill: "black"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M278.613 222.493V205.785L279.591 205.225V221.932L278.613 222.493Z",
    fill: "#455A64"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M286.984 232.512V251.461L271.922 260.155V241.205L286.984 232.512Z",
    fill: "#37474F"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M285.171 250.256L271.922 257.912V241.205L285.171 233.549V250.256Z",
    fill: "#BA68C8"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M285.171 250.256L271.922 257.912V241.205L285.171 233.549V250.256Z",
    fill: "white"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M286.985 232.512L285.172 233.549V250.257L286.985 251.461V232.512Z",
    fill: "#455A64"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M270.254 261.122L288.655 250.496L289.478 250.973L271.077 261.599L270.254 261.122Z",
    fill: "#BA68C8"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M271.074 261.598V263.53L289.475 252.905V250.973L271.074 261.598Z",
    fill: "#BA68C8"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M271.074 261.598V263.53L289.475 252.905V250.973L271.074 261.598Z",
    fill: "black"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M270.254 261.119V263.051L271.077 263.528V261.596L270.254 261.119Z",
    fill: "#BA68C8"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M270.254 261.119V263.051L271.077 263.528V261.596L270.254 261.119Z",
    fill: "black"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M278.613 254.049V237.342L279.591 236.781V253.489L278.613 254.049Z",
    fill: "#455A64"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M286.984 260.082V279.043L271.922 287.737V268.776L286.984 260.082Z",
    fill: "#37474F"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M285.171 277.838L271.922 285.494V268.775L285.171 261.131V277.838Z",
    fill: "#BA68C8"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M285.171 277.838L271.922 285.494V268.775L285.171 261.131V277.838Z",
    fill: "white"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M286.985 260.082L285.172 261.131V277.839L286.985 279.043V260.082Z",
    fill: "#455A64"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M270.254 288.704L288.655 278.078L289.478 278.555L271.077 289.181L270.254 288.704Z",
    fill: "#BA68C8"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M271.074 289.18V291.112L289.475 280.487V278.555L271.074 289.18Z",
    fill: "#BA68C8"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M271.074 289.18V291.112L289.475 280.487V278.555L271.074 289.18Z",
    fill: "black"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M270.254 288.703V290.635L271.077 291.112V289.18L270.254 288.703Z",
    fill: "#BA68C8"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M270.254 288.703V290.635L271.077 291.112V289.18L270.254 288.703Z",
    fill: "black"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M278.613 281.631V264.924L279.591 264.363V281.071L278.613 281.631Z",
    fill: "#455A64"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M286.984 291.65V310.6L271.922 319.293V300.344L286.984 291.65Z",
    fill: "#37474F"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M285.171 309.395L271.922 317.051V300.344L285.171 292.688V309.395Z",
    fill: "#BA68C8"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M285.171 309.395L271.922 317.051V300.344L285.171 292.688V309.395Z",
    fill: "white"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M286.985 291.65L285.172 292.688V309.395L286.985 310.6V291.65Z",
    fill: "#455A64"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M270.254 320.26L288.655 309.635L289.478 310.112L271.077 320.737L270.254 320.26Z",
    fill: "#BA68C8"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M271.074 320.737V322.669L289.475 312.043V310.111L271.074 320.737Z",
    fill: "#BA68C8"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M271.074 320.737V322.669L289.475 312.043V310.111L271.074 320.737Z",
    fill: "black"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M270.254 320.258V322.19L271.077 322.667V320.735L270.254 320.258Z",
    fill: "#BA68C8"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M270.254 320.258V322.19L271.077 322.667V320.735L270.254 320.258Z",
    fill: "black"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M278.613 313.188V296.48L279.591 295.92V312.627L278.613 313.188Z",
    fill: "#455A64"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M286.984 319.232V338.182L271.922 346.875V327.926L286.984 319.232Z",
    fill: "#37474F"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M285.171 336.977L271.922 344.633V327.926L285.171 320.27V336.977Z",
    fill: "#BA68C8"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M285.171 336.977L271.922 344.633V327.926L285.171 320.27V336.977Z",
    fill: "white"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M286.985 319.232L285.172 320.27V336.977L286.985 338.182V319.232Z",
    fill: "#455A64"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M270.254 347.842L288.655 337.217L289.478 337.694L271.077 348.319L270.254 347.842Z",
    fill: "#BA68C8"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M271.074 348.319V350.251L289.475 339.625V337.693L271.074 348.319Z",
    fill: "#BA68C8"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M271.074 348.319V350.251L289.475 339.625V337.693L271.074 348.319Z",
    fill: "black"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M270.254 347.84V349.772L271.077 350.249V348.317L270.254 347.84Z",
    fill: "#BA68C8"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M270.254 347.84V349.772L271.077 350.249V348.317L270.254 347.84Z",
    fill: "black"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M278.613 340.77V324.062L279.591 323.502V340.209L278.613 340.77Z",
    fill: "#455A64"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M286.984 350.785V369.735L271.922 378.428V359.479L286.984 350.785Z",
    fill: "#37474F"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M285.171 368.53L271.922 376.186V359.478L285.171 351.822V368.53Z",
    fill: "#BA68C8"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M285.171 368.53L271.922 376.186V359.478L285.171 351.822V368.53Z",
    fill: "white"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M286.985 350.785L285.172 351.823V368.53L286.985 369.735V350.785Z",
    fill: "#455A64"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M270.254 379.395L288.655 368.77L289.478 369.247L271.077 379.872L270.254 379.395Z",
    fill: "#BA68C8"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M271.074 379.872V381.803L289.475 371.178V369.246L271.074 379.872Z",
    fill: "#BA68C8"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M271.074 379.872V381.803L289.475 371.178V369.246L271.074 379.872Z",
    fill: "black"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M270.254 379.393V381.325L271.077 381.802V379.87L270.254 379.393Z",
    fill: "#BA68C8"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M270.254 379.393V381.325L271.077 381.802V379.87L270.254 379.393Z",
    fill: "black"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M278.613 372.323V355.615L279.591 355.055V371.762L278.613 372.323Z",
    fill: "#455A64"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M286.984 378.369V397.319L271.922 406.012V387.063L286.984 378.369Z",
    fill: "#37474F"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M285.171 396.114L271.922 403.77V387.062L285.171 379.406V396.114Z",
    fill: "#BA68C8"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M285.171 396.114L271.922 403.77V387.062L285.171 379.406V396.114Z",
    fill: "white"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M286.985 378.369L285.172 379.407V396.114L286.985 397.319V378.369Z",
    fill: "#455A64"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M270.254 406.979L288.655 396.354L289.478 396.831L271.077 407.456L270.254 406.979Z",
    fill: "#BA68C8"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M271.074 407.456V409.387L289.475 398.762V396.83L271.074 407.456Z",
    fill: "#BA68C8"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M271.074 407.456V409.387L289.475 398.762V396.83L271.074 407.456Z",
    fill: "black"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M270.254 406.977V408.908L271.077 409.386V407.454L270.254 406.977Z",
    fill: "#BA68C8"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M270.254 406.977V408.908L271.077 409.386V407.454L270.254 406.977Z",
    fill: "black"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M278.613 399.907V383.199L279.591 382.639V399.346L278.613 399.907Z",
    fill: "#455A64"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M166.706 226.668L61.4766 165.92V426.286L166.706 487.046V226.668Z",
    fill: "#BA68C8"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.706 226.668L61.4766 165.92V426.286L166.706 487.046V226.668Z",
    fill: "white"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M256.897 174.601V434.968L249.289 430.579V170.213L256.897 174.601Z",
    fill: "#BA68C8"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M256.897 174.601V434.968L249.289 430.579V170.213L256.897 174.601Z",
    fill: "white"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4766 165.92L196.758 87.8086L301.975 148.568L256.897 174.601L249.289 170.213L204.175 196.234L211.796 200.634L166.706 226.667L61.4766 165.92Z",
    fill: "#BA68C8"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M61.4766 165.92L196.758 87.8086L301.975 148.568L256.897 174.601L249.289 170.213L204.175 196.234L211.796 200.634L166.706 226.667L61.4766 165.92Z",
    fill: "white"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M196.998 200.635L189.377 196.234L249.29 161.663L256.887 166.051L287.177 148.557L196.759 96.3594L76.2773 165.92L166.707 218.117L196.998 200.635Z",
    fill: "#BA68C8"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M196.998 200.635L189.377 196.234L249.29 161.663L256.887 166.051L287.177 148.557L196.759 96.3594L76.2773 165.92L166.707 218.117L196.998 200.635Z",
    fill: "black"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M196.759 96.3594V105.172L83.9096 170.32L76.2773 165.92L196.759 96.3594Z",
    fill: "#BA68C8"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M196.759 96.3594V105.172L83.9096 170.32L76.2773 165.92L196.759 96.3594Z",
    fill: "white"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M287.176 148.557L279.436 153.029L196.758 105.172V96.3594L287.176 148.557Z",
    fill: "#BA68C8"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M287.176 148.557L279.436 153.029L196.758 105.172V96.3594L287.176 148.557Z",
    fill: "white"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M196.759 96.3457L205.608 110.108L93.1875 175.661L76.2773 165.918L196.759 96.3457Z",
    fill: "#BA68C8"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M249.289 170.213V430.579L211.796 452.319V200.634L204.176 196.234L249.289 170.213Z",
    fill: "#BA68C8"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M249.289 170.213V430.579L211.796 452.319V200.634L204.176 196.234L249.289 170.213Z",
    fill: "black"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M219.309 405.154L224.747 402.006V197.486L219.309 200.622V405.154ZM234.346 191.964V396.496L239.784 393.36V188.828L234.346 191.964Z",
    fill: "#BA68C8"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M219.309 405.154L224.747 402.006V197.486L219.309 200.622V405.154ZM234.346 191.964V396.496L239.784 393.36V188.828L234.346 191.964Z",
    fill: "white"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M214.75 451.448V413.979L245.816 396.043L245.827 433.512L242.906 435.194V401.099L217.672 415.66V449.755L214.75 451.448Z",
    fill: "#BA68C8"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M214.75 451.448V413.979L245.816 396.043L245.827 433.512L242.906 435.194V401.099L217.672 415.66V449.755L214.75 451.448Z",
    fill: "white"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M214.751 451.447L214.035 451.03V413.561L214.751 413.978V451.447Z",
    fill: "#BA68C8"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M214.751 451.447L214.035 451.03V413.561L214.751 413.978V451.447Z",
    fill: "white"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M214.035 413.561L245.089 395.625L245.816 396.042L214.751 413.978L214.035 413.561Z",
    fill: "#BA68C8"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M214.035 413.561L245.089 395.625L245.816 396.042L214.751 413.978L214.035 413.561Z",
    fill: "white"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M242.907 435.194L242.18 434.777V401.517L242.907 401.1V435.194Z",
    fill: "#BA68C8"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M242.907 435.194L242.18 434.777V401.517L242.907 401.1V435.194Z",
    fill: "white"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M242.266 434.812L217.676 449.003V415.672L242.266 401.469V434.812Z",
    fill: "#BA68C8"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M242.266 434.812L217.676 449.003V415.672L242.266 401.469V434.812Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.902 441.622L237.21 404.391L234.991 405.667L217.676 439.058V441.502L217.902 441.622Z",
    fill: "#BA68C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.676 420.836V423.829L223.722 412.178L221.504 413.454L217.676 420.836Z",
    fill: "#BA68C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.163 407.885L226.667 410.473L217.676 427.812V433.882L231.163 407.885Z",
    fill: "#BA68C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.267 428.921V422.863L233.418 439.917L237.914 437.329L242.267 428.921Z",
    fill: "#BA68C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.266 408.29V401.469L241.55 401.886L217.676 447.918V449.003L222.637 446.141L242.266 408.29Z",
    fill: "#BA68C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.267 417.892V414.898L227.527 443.328L229.745 442.041L242.267 417.892Z",
    fill: "#BA68C8"
  }))), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M229.039 409.112L229.695 408.73V442.825L229.039 442.443V409.112Z",
    fill: "#BA68C8"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M229.039 409.112L229.695 408.73V442.825L229.039 442.443V409.112Z",
    fill: "white"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M230.9 408.027L229.695 408.731V442.826L230.9 442.122V408.027Z",
    fill: "#BA68C8"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M230.9 408.027L229.695 408.731V442.826L230.9 442.122V408.027Z",
    fill: "white"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4883 190.367V209.329L91.5381 218.01V199.073L76.4883 190.367Z",
    fill: "#37474F"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2891 208.123L91.5381 215.768V199.072L78.2891 191.416V208.123Z",
    fill: "#BA68C8"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M78.2891 208.123L91.5381 215.768V199.072L78.2891 191.416V208.123Z",
    fill: "white"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4883 190.367L78.289 191.417V208.124L76.4883 209.329V190.367Z",
    fill: "#455A64"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M93.22 218.977L74.8072 208.352L73.9844 208.841L92.3852 219.466L93.22 218.977Z",
    fill: "#BA68C8"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3852 219.465V221.397L73.9844 210.772V208.84L92.3852 219.465Z",
    fill: "#BA68C8"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M92.3852 219.465V221.397L73.9844 210.772V208.84L92.3852 219.465Z",
    fill: "black"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2176 218.975V220.918L92.3828 221.395V219.464L93.2176 218.975Z",
    fill: "#BA68C8"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M93.2176 218.975V220.918L92.3828 221.395V219.464L93.2176 218.975Z",
    fill: "black"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8488 211.916V195.197L83.8828 194.648V211.356L84.8488 211.916Z",
    fill: "#455A64"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M106.516 207.625V226.574L121.577 235.268V216.319L106.516 207.625Z",
    fill: "#37474F"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M108.316 225.37L121.577 233.026V216.318L108.316 208.662V225.37Z",
    fill: "#BA68C8"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M108.316 225.37L121.577 233.026V216.318L108.316 208.662V225.37Z",
    fill: "white"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M106.516 207.625L108.316 208.663V225.37L106.516 226.574V207.625Z",
    fill: "#455A64"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M123.247 236.235L104.846 225.609L104.012 226.086L122.424 236.712L123.247 236.235Z",
    fill: "#BA68C8"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M122.424 236.711V238.643L104.012 228.018V226.086L122.424 236.711Z",
    fill: "#BA68C8"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.424 236.711V238.643L104.012 228.018V226.086L122.424 236.711Z",
    fill: "black"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M123.249 236.232V238.164L122.426 238.641V236.709L123.249 236.232Z",
    fill: "#BA68C8"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M123.249 236.232V238.164L122.426 238.641V236.709L123.249 236.232Z",
    fill: "black"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M114.876 229.162V212.455L113.91 211.895V228.602L114.876 229.162Z",
    fill: "#455A64"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M136.547 224.865V243.815L151.609 252.508V233.559L136.547 224.865Z",
    fill: "#37474F"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M138.359 242.61L151.608 250.266V233.558L138.359 225.902V242.61Z",
    fill: "#BA68C8"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M138.359 242.61L151.608 250.266V233.558L138.359 225.902V242.61Z",
    fill: "white"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M136.547 224.865L138.36 225.903V242.61L136.547 243.815V224.865Z",
    fill: "#455A64"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M153.279 253.475L134.878 242.85L134.043 243.327L152.456 253.952L153.279 253.475Z",
    fill: "#BA68C8"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M152.456 253.952V255.884L134.043 245.258V243.326L152.456 253.952Z",
    fill: "#BA68C8"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.456 253.952V255.884L134.043 245.258V243.326L152.456 253.952Z",
    fill: "black"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M153.28 253.475V255.407L152.457 255.884V253.952L153.28 253.475Z",
    fill: "#BA68C8"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M153.28 253.475V255.407L152.457 255.884V253.952L153.28 253.475Z",
    fill: "black"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M144.919 246.403V229.695L143.941 229.135V245.842L144.919 246.403Z",
    fill: "#455A64"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4883 217.949V236.899L91.5381 245.592V226.643L76.4883 217.949Z",
    fill: "#37474F"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2891 235.705L91.5381 243.35V226.642L78.2891 218.998V235.705Z",
    fill: "#BA68C8"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M78.2891 235.705L91.5381 243.35V226.642L78.2891 218.998V235.705Z",
    fill: "white"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4883 217.949L78.289 218.999V235.706L76.4883 236.899V217.949Z",
    fill: "#455A64"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M93.22 246.559L74.8072 235.934L73.9844 236.411L92.3852 247.036L93.22 246.559Z",
    fill: "#BA68C8"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3852 247.036V248.968L73.9844 238.342V236.41L92.3852 247.036Z",
    fill: "#BA68C8"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M92.3852 247.036V248.968L73.9844 238.342V236.41L92.3852 247.036Z",
    fill: "black"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2176 246.557V248.489L92.3828 248.966V247.034L93.2176 246.557Z",
    fill: "#BA68C8"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M93.2176 246.557V248.489L92.3828 248.966V247.034L93.2176 246.557Z",
    fill: "black"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8488 239.487V222.779L83.8828 222.219V238.926L84.8488 239.487Z",
    fill: "#455A64"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M106.516 235.193V254.155L121.577 262.836V243.899L106.516 235.193Z",
    fill: "#37474F"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M108.316 252.95L121.577 260.606V243.898L108.316 236.242V252.95Z",
    fill: "#BA68C8"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M108.316 252.95L121.577 260.606V243.898L108.316 236.242V252.95Z",
    fill: "white"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M106.516 235.193L108.316 236.243V252.95L106.516 254.155V235.193Z",
    fill: "#455A64"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M123.247 263.815L104.846 253.189L104.012 253.666L122.424 264.292L123.247 263.815Z",
    fill: "#BA68C8"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M122.424 264.292V266.223L104.012 255.598V253.666L122.424 264.292Z",
    fill: "#BA68C8"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.424 264.292V266.223L104.012 255.598V253.666L122.424 264.292Z",
    fill: "black"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M123.249 263.814V265.746L122.426 266.223V264.291L123.249 263.814Z",
    fill: "#BA68C8"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M123.249 263.814V265.746L122.426 266.223V264.291L123.249 263.814Z",
    fill: "black"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M114.876 256.743V240.035L113.91 239.475V256.182L114.876 256.743Z",
    fill: "#455A64"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M136.547 252.451V271.401L151.609 280.094V261.145L136.547 252.451Z",
    fill: "#37474F"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M138.359 270.196L151.608 277.852V261.144L138.359 253.488V270.196Z",
    fill: "#BA68C8"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M138.359 270.196L151.608 277.852V261.144L138.359 253.488V270.196Z",
    fill: "white"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M136.547 252.451L138.36 253.489V270.196L136.547 271.401V252.451Z",
    fill: "#455A64"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M153.279 281.061L134.878 270.436L134.043 270.913L152.456 281.538L153.279 281.061Z",
    fill: "#BA68C8"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M152.456 281.538V283.469L134.043 272.844V270.912L152.456 281.538Z",
    fill: "#BA68C8"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.456 281.538V283.469L134.043 272.844V270.912L152.456 281.538Z",
    fill: "black"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M153.28 281.059V282.99L152.457 283.468V281.536L153.28 281.059Z",
    fill: "#BA68C8"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M153.28 281.059V282.99L152.457 283.468V281.536L153.28 281.059Z",
    fill: "black"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M144.919 273.989V257.281L143.941 256.721V273.428L144.919 273.989Z",
    fill: "#455A64"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4883 249.504V268.465L91.5381 277.147V258.209L76.4883 249.504Z",
    fill: "#37474F"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2891 267.26L91.5381 274.916V258.209L78.2891 250.553V267.26Z",
    fill: "#BA68C8"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M78.2891 267.26L91.5381 274.916V258.209L78.2891 250.553V267.26Z",
    fill: "white"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4883 249.504L78.289 250.553V267.261L76.4883 268.465V249.504Z",
    fill: "#455A64"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M93.22 278.125L74.8072 267.5L73.9844 267.977L92.3852 278.603L93.22 278.125Z",
    fill: "#BA68C8"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3852 278.602V280.534L73.9844 269.908V267.977L92.3852 278.602Z",
    fill: "#BA68C8"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M92.3852 278.602V280.534L73.9844 269.908V267.977L92.3852 278.602Z",
    fill: "black"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2176 278.125V280.057L92.3828 280.534V278.602L93.2176 278.125Z",
    fill: "#BA68C8"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M93.2176 278.125V280.057L92.3828 280.534V278.602L93.2176 278.125Z",
    fill: "black"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8488 271.053V254.346L83.8828 253.785V270.493L84.8488 271.053Z",
    fill: "#455A64"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M106.516 266.76V285.709L121.577 294.403V275.453L106.516 266.76Z",
    fill: "#37474F"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M108.316 284.504L121.577 292.16V275.453L108.316 267.797V284.504Z",
    fill: "#BA68C8"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M108.316 284.504L121.577 292.16V275.453L108.316 267.797V284.504Z",
    fill: "white"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M106.516 266.76L108.316 267.797V284.505L106.516 285.709V266.76Z",
    fill: "#455A64"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M123.247 295.37L104.846 284.744L104.012 285.221L122.424 295.847L123.247 295.37Z",
    fill: "#BA68C8"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M122.424 295.846V297.778L104.012 287.153V285.221L122.424 295.846Z",
    fill: "#BA68C8"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.424 295.846V297.778L104.012 287.153V285.221L122.424 295.846Z",
    fill: "black"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M123.249 295.367V297.299L122.426 297.776V295.844L123.249 295.367Z",
    fill: "#BA68C8"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M123.249 295.367V297.299L122.426 297.776V295.844L123.249 295.367Z",
    fill: "black"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M114.876 288.297V271.59L113.91 271.029V287.737L114.876 288.297Z",
    fill: "#455A64"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M136.547 284.004V302.953L151.609 311.647V292.698L136.547 284.004Z",
    fill: "#37474F"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M138.359 301.748L151.608 309.404V292.697L138.359 285.053V301.748Z",
    fill: "#BA68C8"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M138.359 301.748L151.608 309.404V292.697L138.359 285.053V301.748Z",
    fill: "white"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M136.547 284.004L138.36 285.053V301.749L136.547 302.953V284.004Z",
    fill: "#455A64"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M153.279 312.614L134.878 301.988L134.043 302.465L152.456 313.091L153.279 312.614Z",
    fill: "#BA68C8"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M152.456 313.09V315.022L134.043 304.397V302.465L152.456 313.09Z",
    fill: "#BA68C8"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.456 313.09V315.022L134.043 304.397V302.465L152.456 313.09Z",
    fill: "black"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M153.28 312.611V314.543L152.457 315.02V313.088L153.28 312.611Z",
    fill: "#BA68C8"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M153.28 312.611V314.543L152.457 315.02V313.088L153.28 312.611Z",
    fill: "black"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M144.919 305.541V288.834L143.941 288.273V304.981L144.919 305.541Z",
    fill: "#455A64"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4883 277.088V296.037L91.5381 304.731V285.781L76.4883 277.088Z",
    fill: "#37474F"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2891 294.844L91.5381 302.488V285.781L78.2891 278.137V294.844Z",
    fill: "#BA68C8"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M78.2891 294.844L91.5381 302.488V285.781L78.2891 278.137V294.844Z",
    fill: "white"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4883 277.088L78.289 278.137V294.845L76.4883 296.037V277.088Z",
    fill: "#455A64"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M93.22 305.698L74.8072 295.072L73.9844 295.549L92.3852 306.175L93.22 305.698Z",
    fill: "#BA68C8"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3852 306.174V308.106L73.9844 297.481V295.549L92.3852 306.174Z",
    fill: "#BA68C8"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M92.3852 306.174V308.106L73.9844 297.481V295.549L92.3852 306.174Z",
    fill: "black"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2176 305.695V307.627L92.3828 308.104V306.172L93.2176 305.695Z",
    fill: "#BA68C8"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M93.2176 305.695V307.627L92.3828 308.104V306.172L93.2176 305.695Z",
    fill: "black"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8488 298.625V281.918L83.8828 281.357V298.065L84.8488 298.625Z",
    fill: "#455A64"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M106.516 294.344V313.293L121.577 321.987V303.037L106.516 294.344Z",
    fill: "#37474F"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M108.316 312.088L121.577 319.744V303.037L108.316 295.381V312.088Z",
    fill: "#BA68C8"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M108.316 312.088L121.577 319.744V303.037L108.316 295.381V312.088Z",
    fill: "white"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M106.516 294.344L108.316 295.381V312.089L106.516 313.293V294.344Z",
    fill: "#455A64"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M123.247 322.954L104.846 312.328L104.012 312.805L122.424 323.431L123.247 322.954Z",
    fill: "#BA68C8"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M122.424 323.43V325.362L104.012 314.737V312.805L122.424 323.43Z",
    fill: "#BA68C8"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.424 323.43V325.362L104.012 314.737V312.805L122.424 323.43Z",
    fill: "black"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M123.249 322.951V324.883L122.426 325.36V323.428L123.249 322.951Z",
    fill: "#BA68C8"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M123.249 322.951V324.883L122.426 325.36V323.428L123.249 322.951Z",
    fill: "black"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M114.876 315.881V299.174L113.91 298.613V315.321L114.876 315.881Z",
    fill: "#455A64"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M136.547 311.59V330.539L151.609 339.233V320.283L136.547 311.59Z",
    fill: "#37474F"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M138.359 329.334L151.608 336.99V320.283L138.359 312.627V329.334Z",
    fill: "#BA68C8"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M138.359 329.334L151.608 336.99V320.283L138.359 312.627V329.334Z",
    fill: "white"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M136.547 311.59L138.36 312.627V329.335L136.547 330.539V311.59Z",
    fill: "#455A64"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M153.279 340.2L134.878 329.574L134.043 330.051L152.456 340.677L153.279 340.2Z",
    fill: "#BA68C8"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M152.456 340.676V342.608L134.043 331.983V330.051L152.456 340.676Z",
    fill: "#BA68C8"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.456 340.676V342.608L134.043 331.983V330.051L152.456 340.676Z",
    fill: "black"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M153.28 340.197V342.129L152.457 342.606V340.674L153.28 340.197Z",
    fill: "#BA68C8"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M153.28 340.197V342.129L152.457 342.606V340.674L153.28 340.197Z",
    fill: "black"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M144.919 333.127V316.42L143.941 315.859V332.567L144.919 333.127Z",
    fill: "#455A64"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4883 308.656V327.606L91.5381 336.299V317.35L76.4883 308.656Z",
    fill: "#37474F"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2891 326.401L91.5381 334.057V317.349L78.2891 309.693V326.401Z",
    fill: "#BA68C8"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M78.2891 326.401L91.5381 334.057V317.349L78.2891 309.693V326.401Z",
    fill: "white"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4883 308.656L78.289 309.694V326.401L76.4883 327.606V308.656Z",
    fill: "#455A64"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M93.22 337.266L74.8072 326.641L73.9844 327.118L92.3852 337.743L93.22 337.266Z",
    fill: "#BA68C8"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3852 337.743V339.675L73.9844 329.049V327.117L92.3852 337.743Z",
    fill: "#BA68C8"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M92.3852 337.743V339.675L73.9844 329.049V327.117L92.3852 337.743Z",
    fill: "black"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2176 337.264V339.196L92.3828 339.673V337.741L93.2176 337.264Z",
    fill: "#BA68C8"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M93.2176 337.264V339.196L92.3828 339.673V337.741L93.2176 337.264Z",
    fill: "black"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8488 330.194V313.486L83.8828 312.926V329.633L84.8488 330.194Z",
    fill: "#455A64"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M106.516 325.896V344.846L121.577 353.539V334.59L106.516 325.896Z",
    fill: "#37474F"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M108.316 343.641L121.577 351.297V334.59L108.316 326.934V343.641Z",
    fill: "#BA68C8"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M108.316 343.641L121.577 351.297V334.59L108.316 326.934V343.641Z",
    fill: "white"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M106.516 325.896L108.316 326.934V343.641L106.516 344.846V325.896Z",
    fill: "#455A64"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M123.247 354.506L104.846 343.881L104.012 344.358L122.424 354.983L123.247 354.506Z",
    fill: "#BA68C8"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M122.424 354.983V356.915L104.012 346.289V344.357L122.424 354.983Z",
    fill: "#BA68C8"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.424 354.983V356.915L104.012 346.289V344.357L122.424 354.983Z",
    fill: "black"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M123.249 354.504V356.436L122.426 356.913V354.981L123.249 354.504Z",
    fill: "#BA68C8"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M123.249 354.504V356.436L122.426 356.913V354.981L123.249 354.504Z",
    fill: "black"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M114.876 347.434V330.727L113.91 330.166V346.873L114.876 347.434Z",
    fill: "#455A64"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M136.547 343.143V362.092L151.609 370.786V351.836L136.547 343.143Z",
    fill: "#37474F"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M138.359 360.899L151.608 368.543V351.836L138.359 344.18V360.899Z",
    fill: "#BA68C8"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M138.359 360.899L151.608 368.543V351.836L138.359 344.18V360.899Z",
    fill: "white"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M136.547 343.143L138.36 344.18V360.899L136.547 362.092V343.143Z",
    fill: "#455A64"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M153.279 371.752L134.878 361.127L134.043 361.604L152.456 372.229L153.279 371.752Z",
    fill: "#BA68C8"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M152.456 372.229V374.161L134.043 363.535V361.604L152.456 372.229Z",
    fill: "#BA68C8"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.456 372.229V374.161L134.043 363.535V361.604L152.456 372.229Z",
    fill: "black"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M153.28 371.752V373.684L152.457 374.161V372.229L153.28 371.752Z",
    fill: "#BA68C8"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M153.28 371.752V373.684L152.457 374.161V372.229L153.28 371.752Z",
    fill: "black"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M144.919 364.68V347.973L143.941 347.412V364.12L144.919 364.68Z",
    fill: "#455A64"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4883 336.225V355.174L91.5381 363.868V344.918L76.4883 336.225Z",
    fill: "#37474F"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2891 353.981L91.5381 361.625V344.918L78.2891 337.273V353.981Z",
    fill: "#BA68C8"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M78.2891 353.981L91.5381 361.625V344.918L78.2891 337.273V353.981Z",
    fill: "white"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4883 336.225L78.289 337.274V353.981L76.4883 355.174V336.225Z",
    fill: "#455A64"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M93.22 364.834L74.8072 354.209L73.9844 354.686L92.3852 365.311L93.22 364.834Z",
    fill: "#BA68C8"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3852 365.311V367.243L73.9844 356.617V354.686L92.3852 365.311Z",
    fill: "#BA68C8"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M92.3852 365.311V367.243L73.9844 356.617V354.686L92.3852 365.311Z",
    fill: "black"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2176 364.832V366.764L92.3828 367.241V365.309L93.2176 364.832Z",
    fill: "#BA68C8"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M93.2176 364.832V366.764L92.3828 367.241V365.309L93.2176 364.832Z",
    fill: "black"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8488 357.762V341.055L83.8828 340.494V357.202L84.8488 357.762Z",
    fill: "#455A64"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M106.516 353.482V372.432L121.577 381.125V362.176L106.516 353.482Z",
    fill: "#37474F"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M108.316 371.227L121.577 378.883V362.176L108.316 354.52V371.227Z",
    fill: "#BA68C8"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M108.316 371.227L121.577 378.883V362.176L108.316 354.52V371.227Z",
    fill: "white"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M106.516 353.482L108.316 354.52V371.227L106.516 372.432V353.482Z",
    fill: "#455A64"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M123.247 382.092L104.846 371.467L104.012 371.944L122.424 382.569L123.247 382.092Z",
    fill: "#BA68C8"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M122.424 382.569V384.501L104.012 373.875V371.943L122.424 382.569Z",
    fill: "#BA68C8"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.424 382.569V384.501L104.012 373.875V371.943L122.424 382.569Z",
    fill: "black"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M123.249 382.09V384.022L122.426 384.499V382.567L123.249 382.09Z",
    fill: "#BA68C8"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M123.249 382.09V384.022L122.426 384.499V382.567L123.249 382.09Z",
    fill: "black"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M114.876 375.02V358.312L113.91 357.752V374.459L114.876 375.02Z",
    fill: "#455A64"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M136.547 370.725V389.674L151.609 398.368V379.418L136.547 370.725Z",
    fill: "#37474F"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M138.359 388.469L151.608 396.125V379.418L138.359 371.762V388.469Z",
    fill: "#BA68C8"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M138.359 388.469L151.608 396.125V379.418L138.359 371.762V388.469Z",
    fill: "white"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M136.547 370.725L138.36 371.762V388.47L136.547 389.674V370.725Z",
    fill: "#455A64"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M153.279 399.334L134.878 388.709L134.043 389.186L152.456 399.812L153.279 399.334Z",
    fill: "#BA68C8"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M152.456 399.811V401.743L134.043 391.117V389.186L152.456 399.811Z",
    fill: "#BA68C8"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.456 399.811V401.743L134.043 391.117V389.186L152.456 399.811Z",
    fill: "black"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M153.28 399.332V401.264L152.457 401.741V399.809L153.28 399.332Z",
    fill: "#BA68C8"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M153.28 399.332V401.264L152.457 401.741V399.809L153.28 399.332Z",
    fill: "black"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M144.919 392.262V375.555L143.941 374.994V391.702L144.919 392.262Z",
    fill: "#455A64"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4883 367.791V386.74L91.5381 395.434V376.485L76.4883 367.791Z",
    fill: "#37474F"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2891 385.536L91.5381 393.192V376.484L78.2891 368.828V385.536Z",
    fill: "#BA68C8"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M78.2891 385.536L91.5381 393.192V376.484L78.2891 368.828V385.536Z",
    fill: "white"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4883 367.791L78.289 368.829V385.536L76.4883 386.74V367.791Z",
    fill: "#455A64"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M93.22 396.401L74.8072 385.775L73.9844 386.252L92.3852 396.878L93.22 396.401Z",
    fill: "#BA68C8"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3852 396.877V398.809L73.9844 388.184V386.252L92.3852 396.877Z",
    fill: "#BA68C8"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M92.3852 396.877V398.809L73.9844 388.184V386.252L92.3852 396.877Z",
    fill: "black"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2176 396.398V398.33L92.3828 398.807V396.875L93.2176 396.398Z",
    fill: "#BA68C8"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M93.2176 396.398V398.33L92.3828 398.807V396.875L93.2176 396.398Z",
    fill: "black"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8488 389.328V372.621L83.8828 372.061V388.768L84.8488 389.328Z",
    fill: "#455A64"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M106.516 385.035V403.985L121.577 412.678V393.729L106.516 385.035Z",
    fill: "#37474F"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M108.316 402.78L121.577 410.436V393.728L108.316 386.072V402.78Z",
    fill: "#BA68C8"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M108.316 402.78L121.577 410.436V393.728L108.316 386.072V402.78Z",
    fill: "white"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M106.516 385.035L108.316 386.073V402.78L106.516 403.985V385.035Z",
    fill: "#455A64"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M123.247 413.645L104.846 403.02L104.012 403.497L122.424 414.122L123.247 413.645Z",
    fill: "#BA68C8"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M122.424 414.122V416.053L104.012 405.428V403.496L122.424 414.122Z",
    fill: "#BA68C8"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.424 414.122V416.053L104.012 405.428V403.496L122.424 414.122Z",
    fill: "black"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M123.249 413.643V415.575L122.426 416.052V414.12L123.249 413.643Z",
    fill: "#BA68C8"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M123.249 413.643V415.575L122.426 416.052V414.12L123.249 413.643Z",
    fill: "black"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M114.876 406.573V389.865L113.91 389.305V406.012L114.876 406.573Z",
    fill: "#455A64"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M136.547 402.281V421.231L151.609 429.924V410.975L136.547 402.281Z",
    fill: "#37474F"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M138.359 420.038L151.608 427.682V410.974L138.359 403.33V420.038Z",
    fill: "#BA68C8"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M138.359 420.038L151.608 427.682V410.974L138.359 403.33V420.038Z",
    fill: "white"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M136.547 402.281L138.36 403.331V420.038L136.547 421.231V402.281Z",
    fill: "#455A64"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M153.279 430.891L134.878 420.266L134.043 420.743L152.456 431.368L153.279 430.891Z",
    fill: "#BA68C8"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M152.456 431.368V433.3L134.043 422.674V420.742L152.456 431.368Z",
    fill: "#BA68C8"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.456 431.368V433.3L134.043 422.674V420.742L152.456 431.368Z",
    fill: "black"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M153.28 430.889V432.821L152.457 433.298V431.366L153.28 430.889Z",
    fill: "#BA68C8"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M153.28 430.889V432.821L152.457 433.298V431.366L153.28 430.889Z",
    fill: "black"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M144.919 423.819V407.111L143.941 406.551V423.258L144.919 423.819Z",
    fill: "#455A64"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4883 395.363V414.313L91.5381 423.006V404.057L76.4883 395.363Z",
    fill: "#37474F"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2891 413.12L91.5381 420.764V404.056L78.2891 396.412V413.12Z",
    fill: "#BA68C8"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M78.2891 413.12L91.5381 420.764V404.056L78.2891 396.412V413.12Z",
    fill: "white"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4883 395.363L78.289 396.413V413.12L76.4883 414.313V395.363Z",
    fill: "#455A64"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M93.22 423.973L74.8072 413.348L73.9844 413.825L92.3852 424.45L93.22 423.973Z",
    fill: "#BA68C8"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3852 424.45V426.382L73.9844 415.756V413.824L92.3852 424.45Z",
    fill: "#BA68C8"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M92.3852 424.45V426.382L73.9844 415.756V413.824L92.3852 424.45Z",
    fill: "black"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2176 423.971V425.903L92.3828 426.38V424.448L93.2176 423.971Z",
    fill: "#BA68C8"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M93.2176 423.971V425.903L92.3828 426.38V424.448L93.2176 423.971Z",
    fill: "black"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8488 416.901V400.193L83.8828 399.633V416.352L84.8488 416.901Z",
    fill: "#455A64"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M106.516 412.621V431.57L121.577 440.264V421.315L106.516 412.621Z",
    fill: "#37474F"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M108.316 430.366L121.577 438.022V421.314L108.316 413.658V430.366Z",
    fill: "#BA68C8"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M108.316 430.366L121.577 438.022V421.314L108.316 413.658V430.366Z",
    fill: "white"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M106.516 412.621L108.316 413.659V430.366L106.516 431.57V412.621Z",
    fill: "#455A64"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M123.247 441.231L104.846 430.605L104.012 431.083L122.424 441.708L123.247 441.231Z",
    fill: "#BA68C8"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M122.424 441.707V443.639L104.012 433.014V431.082L122.424 441.707Z",
    fill: "#BA68C8"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.424 441.707V443.639L104.012 433.014V431.082L122.424 441.707Z",
    fill: "black"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M123.249 441.229V443.16L122.426 443.637V441.706L123.249 441.229Z",
    fill: "#BA68C8"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M123.249 441.229V443.16L122.426 443.637V441.706L123.249 441.229Z",
    fill: "black"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M114.876 434.159V417.451L113.91 416.891V433.598L114.876 434.159Z",
    fill: "#455A64"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M136.547 429.863V448.813L151.609 457.506V438.557L136.547 429.863Z",
    fill: "#37474F"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M138.359 447.608L151.608 455.264V438.556L138.359 430.9V447.608Z",
    fill: "#BA68C8"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M138.359 447.608L151.608 455.264V438.556L138.359 430.9V447.608Z",
    fill: "white"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M136.547 429.863L138.36 430.901V447.608L136.547 448.813V429.863Z",
    fill: "#455A64"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M153.279 458.473L134.878 447.848L134.043 448.325L152.456 458.95L153.279 458.473Z",
    fill: "#BA68C8"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M152.456 458.95V460.882L134.043 450.256V448.324L152.456 458.95Z",
    fill: "#BA68C8"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.456 458.95V460.882L134.043 450.256V448.324L152.456 458.95Z",
    fill: "black"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M153.28 458.471V460.403L152.457 460.88V458.948L153.28 458.471Z",
    fill: "#BA68C8"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M153.28 458.471V460.403L152.457 460.88V458.948L153.28 458.471Z",
    fill: "black"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M144.919 451.401V434.693L143.941 434.133V450.84L144.919 451.401Z",
    fill: "#455A64"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M175.84 51.0196C174.882 50.4768 173.969 49.8587 173.109 49.1711C173.408 48.4318 173.658 47.7401 173.885 47.0723C175.601 49.8419 177.951 52.1636 180.742 53.8459C179.418 53.0826 176.663 51.4608 175.84 51.0196Z",
    fill: "#BA68C8"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M175.84 51.0196C174.882 50.4768 173.969 49.8587 173.109 49.1711C173.408 48.4318 173.658 47.7401 173.885 47.0723C175.601 49.8419 177.951 52.1636 180.742 53.8459C179.418 53.0826 176.663 51.4608 175.84 51.0196Z",
    fill: "black"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M210.078 57.8981C210.209 87.1987 210.448 126.719 177.188 158.644L176.473 159.335L175.483 159.526C173.483 159.921 171.451 160.125 169.413 160.134C164.292 160.228 159.298 158.542 155.281 155.364C158.034 156.428 160.964 156.962 163.915 156.938C165.954 156.93 167.987 156.723 169.985 156.318L170.963 156.127L171.679 155.436C204.95 123.523 204.712 84.0027 204.569 54.7021C204.569 53.128 204.569 51.6254 204.569 50.1824L210.054 45.8535V52.8776C210.054 54.4517 210.066 56.1451 210.078 57.8981Z",
    fill: "#BA68C8"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M210.078 57.8981C210.209 87.1987 210.448 126.719 177.188 158.644L176.473 159.335L175.483 159.526C173.483 159.921 171.451 160.125 169.413 160.134C164.292 160.228 159.298 158.542 155.281 155.364C158.034 156.428 160.964 156.962 163.915 156.938C165.954 156.93 167.987 156.723 169.985 156.318L170.963 156.127L171.679 155.436C204.95 123.523 204.712 84.0027 204.569 54.7021C204.569 53.128 204.569 51.6254 204.569 50.1824L210.054 45.8535V52.8776C210.054 54.4517 210.066 56.1451 210.078 57.8981Z",
    fill: "black"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M176.47 159.337L177.186 158.645C210.446 126.721 210.207 87.2005 210.076 57.8999C210.076 56.1468 210.076 54.4534 210.076 52.8554V45.8672L207.178 48.1092L204.567 50.1722C204.567 51.6033 204.567 53.082 204.567 54.6443C204.71 83.9449 204.948 123.465 171.676 155.378L170.961 156.069L176.459 159.253L176.47 159.337Z",
    fill: "black"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M188.744 53.0456C186.788 53.0456 184.105 52.2585 180.98 49.468C181.713 49.6837 182.471 49.7961 183.234 49.8019C187.647 49.8019 192.393 47.8938 196.972 44.2924L207.944 35.6465L213.441 38.8186L202.47 47.4645C197.903 51.1375 193.156 53.0456 188.744 53.0456Z",
    fill: "#BA68C8"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M188.744 53.0456C186.788 53.0456 184.105 52.2585 180.98 49.468C181.713 49.6837 182.471 49.7961 183.234 49.8019C187.647 49.8019 192.393 47.8938 196.972 44.2924L207.944 35.6465L213.441 38.8186L202.47 47.4645C197.903 51.1375 193.156 53.0456 188.744 53.0456Z",
    fill: "white"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M206.667 52.8774L201.157 49.6934C191.915 56.9798 182.959 57.8145 176.543 55.5487C175.927 54.9963 175.356 54.394 174.838 53.748L169.329 50.5758C164.165 63.1094 151.142 81.4506 137.5 86.4473C137.5 109.022 135.914 140.565 154.088 151.095L159.598 154.267C163.628 156.652 168.625 157.427 174.838 156.223C209.04 123.368 206.667 80.425 206.667 52.8774Z",
    fill: "#263238"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M170.247 90.0137L174.838 53.7249L169.329 50.5527C164.165 63.0863 151.143 81.4275 137.5 86.4242L143.01 89.6083L170.247 90.0137Z",
    fill: "#37474F"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M169.413 155.437C167.014 155.5 164.628 155.065 162.405 154.16C160.182 153.255 158.171 151.899 156.498 150.178C144.096 137.716 144.251 115.654 144.346 94.7371C144.346 93.2941 144.346 91.8989 144.346 90.5751C158.168 84.9583 170.105 67.428 175.221 56.2182C178.932 59.54 183.765 61.33 188.744 61.2268C194.714 61.0616 200.494 59.0908 205.321 55.5742C205.321 56.3613 205.321 57.1603 205.321 57.9593C205.452 86.4132 205.678 124.455 174.183 154.972C172.611 155.272 171.014 155.428 169.413 155.437Z",
    fill: "#FAFAFA"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M172.716 126.423L155.293 115.082L160.504 107.092L169.258 112.792L187.587 79.0078L195.97 83.5514L172.716 126.423Z",
    fill: "#BA68C8"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M203.973 58.0068C204.105 86.1626 204.307 123.596 173.54 153.684C172.177 153.916 170.797 154.036 169.414 154.042C167.198 154.101 164.995 153.7 162.942 152.865C160.89 152.03 159.033 150.778 157.488 149.188C145.48 137.12 145.635 115.392 145.73 94.6892C145.73 93.5682 145.73 92.483 145.73 91.4336C158.848 85.6021 170.272 69.5506 175.734 58.3526C179.504 61.1264 184.077 62.5921 188.757 62.5265C194.148 62.4249 199.411 60.8629 203.985 58.0068M206.669 52.8789C200.312 57.8876 194.099 59.8433 188.781 59.8433C186.154 59.9339 183.541 59.4333 181.135 58.3785C178.728 57.3238 176.589 55.7418 174.876 53.7495C169.712 66.2949 156.689 84.6361 143.047 89.6329C143.047 115.654 140.936 156.773 169.45 156.773C171.272 156.763 173.089 156.579 174.876 156.224C209.042 123.37 206.669 80.4265 206.669 52.8789Z",
    fill: "#455A64"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M167.492 35.8496C164.153 51.0664 147.04 75.7161 135.175 80.0688L130.727 81.6907L136.236 84.8748L140.672 83.241C152.598 78.8882 169.663 54.2504 173.002 39.0337L167.492 35.8496Z",
    fill: "#BA68C8"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M167.492 35.8496C164.153 51.0664 147.04 75.7161 135.175 80.0688L130.727 81.6907L136.236 84.8748L140.672 83.241C152.598 78.8882 169.663 54.2504 173.002 39.0337L167.492 35.8496Z",
    fill: "white"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M150.726 155.879C135.95 141.02 136.105 116.918 136.212 94.618C136.212 92.8411 136.212 91.1596 136.212 89.5616V84.7915L130.703 81.6074V86.3776C130.703 87.9756 130.703 89.669 130.703 91.4339C130.596 113.699 130.44 137.8 145.216 152.647C146.837 154.294 148.669 155.717 150.666 156.88L155.77 159.838C153.937 158.723 152.244 157.394 150.726 155.879Z",
    fill: "#BA68C8"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M150.726 155.879C135.95 141.02 136.105 116.918 136.212 94.618C136.212 92.8411 136.212 91.1596 136.212 89.5616V84.7915L130.703 81.6074V86.3776C130.703 87.9756 130.703 89.669 130.703 91.4339C130.596 113.699 130.44 137.8 145.216 152.647C146.837 154.294 148.669 155.717 150.666 156.88L155.77 159.838C153.937 158.723 152.244 157.394 150.726 155.879Z",
    fill: "white"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M213.466 57.886C213.466 56.121 213.466 54.4515 213.466 52.8535V38.877L202.495 47.5228C197.927 51.1004 193.181 53.0443 188.769 53.0443C185.287 53.0443 179.443 50.54 173.027 39.0201C169.676 54.2487 152.575 78.8865 140.698 83.2393L136.261 84.8731V89.6432C136.261 91.2412 136.261 92.9227 136.261 94.6876C136.154 116.952 135.999 141.053 150.787 155.912C153.211 158.396 156.119 160.357 159.331 161.674C162.543 162.991 165.991 163.636 169.462 163.569C171.72 163.553 173.972 163.325 176.188 162.889L178.143 162.507L179.574 161.124C213.848 128.162 213.609 87.7351 213.466 57.886ZM177.189 158.643L176.462 159.335L175.484 159.526C173.485 159.921 171.452 160.125 169.414 160.134C166.398 160.189 163.402 159.628 160.611 158.483C157.82 157.339 155.293 155.636 153.184 153.48C139.398 139.634 139.553 116.38 139.648 94.6757C139.648 92.8988 139.648 91.2054 139.648 89.6074V87.2224L141.866 86.4114C154.746 81.6413 170.177 58.4822 173.946 47.0577C177.428 52.8773 184.07 56.4549 188.745 56.4549C193.921 56.4549 199.394 54.2964 204.57 50.218L210.056 45.8891V52.8773C210.056 54.4753 210.056 56.1568 210.056 57.9218C210.211 87.2104 210.425 126.719 177.189 158.643Z",
    fill: "#BA68C8"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M213.466 57.886C213.466 56.121 213.466 54.4515 213.466 52.8535V38.877L202.495 47.5228C197.927 51.1004 193.181 53.0443 188.769 53.0443C185.287 53.0443 179.443 50.54 173.027 39.0201C169.676 54.2487 152.575 78.8865 140.698 83.2393L136.261 84.8731V89.6432C136.261 91.2412 136.261 92.9227 136.261 94.6876C136.154 116.952 135.999 141.053 150.787 155.912C153.211 158.396 156.119 160.357 159.331 161.674C162.543 162.991 165.991 163.636 169.462 163.569C171.72 163.553 173.972 163.325 176.188 162.889L178.143 162.507L179.574 161.124C213.848 128.162 213.609 87.7351 213.466 57.886ZM177.189 158.643L176.462 159.335L175.484 159.526C173.485 159.921 171.452 160.125 169.414 160.134C166.398 160.189 163.402 159.628 160.611 158.483C157.82 157.339 155.293 155.636 153.184 153.48C139.398 139.634 139.553 116.38 139.648 94.6757C139.648 92.8988 139.648 91.2054 139.648 89.6074V87.2224L141.866 86.4114C154.746 81.6413 170.177 58.4822 173.946 47.0577C177.428 52.8773 184.07 56.4549 188.745 56.4549C193.921 56.4549 199.394 54.2964 204.57 50.218L210.056 45.8891V52.8773C210.056 54.4753 210.056 56.1568 210.056 57.9218C210.211 87.2104 210.425 126.719 177.189 158.643Z",
    fill: "white"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M438.611 436.707L441.413 411.759L413.007 409.207C413.007 409.207 414.2 428.431 414.033 437.255C413.949 441.406 411.016 449.181 411.016 449.181C411.016 449.181 422.941 455.358 429.083 452.83C435.224 450.302 439.338 440.571 439.183 438.794C439.028 437.017 438.611 436.707 438.611 436.707Z",
    fill: "#FFBDA7"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M378.078 475.965C377.696 475.965 377.398 479.543 379.556 481.355C382.061 483.406 389.991 487.318 399.508 485.935C409.024 484.551 414.128 481.57 417.885 478.35C421.641 475.13 426.912 470.611 431.205 469.597C435.069 468.486 438.678 466.63 441.831 464.135C443.023 462.883 442.809 457.469 442.809 457.469L378.078 475.965Z",
    fill: "#263238"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M438.606 436.67C438.949 436.673 439.282 436.793 439.548 437.009C439.815 437.226 440 437.527 440.073 437.862C440.395 439.353 440.8 443.694 441.48 446.127C442.41 449.525 443.126 456.502 442.672 459.245C442.219 461.987 434.647 465.505 430.497 467.139C425.632 469.334 421.126 472.249 417.128 475.785C412.716 479.494 403.366 483.441 397.153 483.513C389.795 483.584 381.471 481.378 379.504 478.051C377.119 473.937 375.282 469.143 386.099 463.979C388.138 463.001 395.317 458.648 397.75 457.074C404.368 452.817 408.995 448.929 411.941 441.571C412.172 440.662 412.712 439.861 413.467 439.305C414.132 439.018 414.868 438.939 415.578 439.079C417.403 439.294 424.665 440.152 426.311 440.903C427.79 441.571 429.888 442.334 429.888 444.171C429.868 444.815 429.743 445.451 429.519 446.055C429.388 446.437 429.304 446.938 429.638 447.164C429.972 447.391 430.377 447.164 430.652 446.866C431.702 445.751 432.663 444.555 433.526 443.289C434.366 442.162 435.287 441.098 436.28 440.104C436.914 439.741 437.527 439.343 438.117 438.912C438.773 438.339 438.594 437.529 438.606 436.67Z",
    fill: "#455A64"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M417.118 475.88C418.997 474.291 420.955 472.799 422.986 471.408C422.986 471.408 410.309 479.303 405.098 475.904C401.723 473.722 403.261 470.967 403.321 470.097C403.38 469.226 391.479 463.275 388.235 462.941C387.341 463.454 386.601 463.884 386.124 464.134C377.669 467.64 376.584 471.981 378.134 477.383C380.09 480.71 387.544 484.049 397.048 483.894C403.225 483.727 412.706 479.589 417.118 475.88Z",
    fill: "#37474F"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M404.132 467.52C397.406 470.311 400.316 471.503 402.224 471.742C404.132 471.98 415.414 465.218 422.271 459.673C429.426 453.889 434.947 446.197 437.607 444.075C438.596 443.288 439.658 442.31 440.612 441.415C440.397 439.949 440.23 438.613 440.087 437.909C440.01 437.574 439.822 437.274 439.554 437.058C439.286 436.841 438.953 436.721 438.608 436.717C438.608 437.575 438.775 438.386 438.119 439.042C437.53 439.474 436.917 439.872 436.283 440.235C435.29 441.229 434.369 442.293 433.528 443.419C432.665 444.685 431.704 445.881 430.654 446.996C424.87 454.438 410.87 464.741 404.132 467.52Z",
    fill: "#37474F"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M402.688 470.754C402.841 470.754 402.989 470.699 403.105 470.599C403.172 470.543 403.228 470.475 403.268 470.399C403.309 470.322 403.334 470.238 403.341 470.151C403.349 470.065 403.34 469.977 403.313 469.894C403.287 469.812 403.245 469.735 403.189 469.669C401.221 467.391 392.05 462.072 387.077 462.704C386.989 462.712 386.903 462.737 386.825 462.778C386.747 462.82 386.678 462.877 386.622 462.946C386.567 463.014 386.525 463.094 386.501 463.179C386.477 463.264 386.471 463.353 386.482 463.441C386.493 463.529 386.522 463.614 386.567 463.69C386.612 463.766 386.672 463.833 386.743 463.885C386.814 463.938 386.895 463.976 386.981 463.996C387.068 464.016 387.157 464.019 387.244 464.004C391.895 463.432 400.613 468.714 402.163 470.515C402.226 470.593 402.306 470.655 402.397 470.696C402.488 470.738 402.588 470.757 402.688 470.754Z",
    fill: "#263238"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M408.531 467.068C408.684 467.066 408.831 467.011 408.949 466.913C409.016 466.858 409.071 466.79 409.112 466.713C409.152 466.636 409.177 466.552 409.185 466.466C409.193 466.379 409.183 466.292 409.157 466.209C409.131 466.126 409.088 466.049 409.032 465.983C407.077 463.705 397.906 458.387 392.921 459.019C392.833 459.026 392.747 459.051 392.669 459.093C392.591 459.134 392.522 459.191 392.466 459.26C392.41 459.329 392.369 459.408 392.345 459.494C392.321 459.579 392.314 459.668 392.326 459.756C392.337 459.844 392.366 459.928 392.411 460.004C392.456 460.081 392.515 460.147 392.587 460.2C392.658 460.252 392.739 460.29 392.825 460.31C392.911 460.331 393.001 460.334 393.088 460.318C397.739 459.758 406.456 465.029 408.007 466.83C408.07 466.907 408.151 466.968 408.241 467.01C408.332 467.051 408.432 467.071 408.531 467.068Z",
    fill: "#263238"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M414.352 463.572C414.504 463.568 414.651 463.513 414.769 463.417C414.837 463.362 414.892 463.294 414.933 463.217C414.973 463.14 414.998 463.056 415.006 462.97C415.014 462.883 415.004 462.796 414.978 462.713C414.952 462.63 414.909 462.553 414.853 462.487C412.897 460.209 403.727 454.879 398.742 455.511C398.656 455.522 398.573 455.549 398.497 455.593C398.422 455.636 398.356 455.693 398.302 455.762C398.249 455.83 398.21 455.909 398.187 455.993C398.164 456.076 398.158 456.164 398.169 456.25C398.18 456.336 398.208 456.419 398.251 456.495C398.294 456.57 398.352 456.636 398.421 456.689C398.489 456.743 398.568 456.782 398.651 456.804C398.735 456.827 398.823 456.833 398.909 456.822C403.56 456.25 412.277 461.533 413.827 463.334C413.893 463.408 413.974 463.468 414.064 463.509C414.155 463.55 414.253 463.572 414.352 463.572Z",
    fill: "#263238"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M419.789 459.602C419.945 459.594 420.094 459.54 420.219 459.447C420.285 459.39 420.34 459.32 420.38 459.242C420.419 459.163 420.443 459.078 420.45 458.99C420.456 458.903 420.446 458.815 420.418 458.732C420.391 458.648 420.347 458.571 420.29 458.505C418.334 456.239 409.152 450.92 404.191 451.54C404.105 451.551 404.022 451.579 403.946 451.622C403.871 451.665 403.805 451.723 403.752 451.791C403.699 451.86 403.659 451.938 403.637 452.022C403.614 452.106 403.608 452.193 403.619 452.28C403.63 452.366 403.657 452.449 403.7 452.524C403.744 452.6 403.801 452.666 403.87 452.719C403.938 452.772 404.017 452.811 404.101 452.834C404.184 452.857 404.272 452.863 404.358 452.852C408.997 452.291 417.726 457.622 419.277 459.363C419.34 459.437 419.418 459.497 419.507 459.538C419.595 459.579 419.692 459.601 419.789 459.602Z",
    fill: "#263238"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M425.083 455.631C425.231 455.627 425.374 455.572 425.488 455.476C425.557 455.422 425.615 455.355 425.658 455.279C425.7 455.203 425.727 455.118 425.736 455.031C425.745 454.944 425.736 454.856 425.71 454.773C425.683 454.689 425.641 454.612 425.583 454.546C422.888 451.326 413.312 446.913 408.339 447.533C408.253 447.544 408.17 447.572 408.095 447.615C408.019 447.658 407.953 447.716 407.9 447.785C407.847 447.853 407.808 447.932 407.785 448.015C407.762 448.099 407.756 448.187 407.767 448.273C407.778 448.359 407.806 448.442 407.849 448.517C407.892 448.593 407.949 448.659 408.018 448.712C408.087 448.765 408.165 448.804 408.249 448.827C408.333 448.85 408.42 448.856 408.506 448.845C412.978 448.285 422.161 452.53 424.546 455.38C424.611 455.459 424.693 455.523 424.786 455.566C424.879 455.609 424.98 455.631 425.083 455.631Z",
    fill: "#263238"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M485.691 448.415L478.941 418.459L508.492 413.844L508.969 443.419C508.969 443.419 511.223 451.373 509.554 454.151C507.884 456.93 490.139 459.756 488.506 457.944C486.872 456.131 485.691 448.415 485.691 448.415Z",
    fill: "#FFBDA7"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M488.645 495.629C489.42 502.343 490.827 506.696 493.737 510.333C496.646 513.97 501.822 514.59 506.95 512.801C512.078 511.013 518.565 507.077 519.77 501.055C520.974 495.033 520.473 491.061 518.983 484.92L488.645 495.629Z",
    fill: "#263238"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M508.966 443.42C511.101 443.312 510.529 448.607 511.542 457.658C512.628 467.461 517.052 475.141 518.626 483C520.415 491.98 520.081 496.118 516.73 502.08C513.379 508.043 500.845 515.043 494.143 507.9C488.681 502.08 488.121 494.949 488.181 485.755C488.181 476.214 488.3 469.572 487.513 462.452C486.761 455.667 483.935 449.335 485.724 448.392C485.927 449.382 487.739 456.263 488.944 456.156C488.992 455.292 488.956 454.425 488.836 453.568C488.756 453.176 488.757 452.772 488.839 452.38C488.921 451.988 489.083 451.617 489.313 451.29C490.338 450.488 491.508 449.892 492.76 449.537C494.847 448.917 498.568 448.13 500.69 447.701C501.752 447.486 502.825 447.307 503.886 447.188C504.792 447.057 505.712 447.057 506.617 447.188C506.862 447.222 507.096 447.31 507.303 447.446C507.509 447.583 507.682 447.763 507.81 447.975C507.937 448.305 507.994 448.659 507.977 449.013C508.01 449.638 508.131 450.256 508.334 450.849C508.43 451.111 508.656 451.421 508.955 451.314C509.065 451.262 509.155 451.176 509.213 451.069C509.271 450.962 509.293 450.839 509.277 450.718C509.193 449.645 509.038 444.028 508.966 443.42Z",
    fill: "#455A64"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M518.006 480.461C518.28 481.761 519.974 490.335 517.362 492.243C514.536 494.294 512.592 487.628 512.592 487.628C512.592 487.628 505.687 486.614 495.956 491.671C496.54 493.03 495.24 497.884 492.462 497.24C489.683 496.596 488.157 486.698 488.133 486.567C488.133 495.38 488.836 502.272 494.095 507.925C500.798 515.08 513.343 508.08 516.682 502.105C520.021 496.131 520.367 491.981 518.578 483.025C518.447 482.107 518.232 481.272 518.006 480.461Z",
    fill: "#37474F"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M511.867 488.306C512.069 491.61 515.695 490.047 515.623 485.361C515.552 480.674 513.095 469.285 512.165 461.617C511.545 450.598 511.103 443.312 508.969 443.419C508.969 443.538 508.969 443.646 508.969 443.765C508.969 443.884 509.195 450.038 509.219 450.753C509.601 457.491 509.696 470.573 510.65 476.655C511.288 480.511 511.694 484.402 511.867 488.306Z",
    fill: "#37474F"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M497.117 491.443C496.017 487.716 495.149 483.925 494.517 480.09C493.479 474.068 489.878 462.023 488.089 455.536C487.517 454.475 485.704 448.381 485.704 448.381C484.225 448.798 485.704 454.582 486.408 457.277C487.111 459.972 487.946 462.882 488.793 466.758C491.011 474.402 491.178 485.838 492.645 490.263C494.111 494.687 497.975 494.604 497.117 491.443Z",
    fill: "#37474F"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M495.779 491.968C495.878 491.943 495.974 491.907 496.065 491.861C501.058 489.099 506.749 487.856 512.439 488.283C512.644 488.308 512.851 488.26 513.024 488.146C513.197 488.033 513.323 487.861 513.381 487.663C513.402 487.571 513.403 487.476 513.383 487.384C513.363 487.292 513.324 487.205 513.267 487.13C513.21 487.055 513.137 486.993 513.054 486.95C512.971 486.906 512.879 486.88 512.785 486.876C506.699 486.363 500.599 487.679 495.266 490.656C495.179 490.698 495.101 490.759 495.038 490.833C494.976 490.907 494.929 490.994 494.902 491.087C494.875 491.181 494.868 491.279 494.882 491.375C494.895 491.471 494.929 491.564 494.98 491.646C495.068 491.772 495.19 491.869 495.332 491.926C495.474 491.983 495.629 491.998 495.779 491.968Z",
    fill: "#263238"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M493.642 485.016L493.893 484.921C499.558 482.032 505.882 480.679 512.234 480.997C512.44 481.016 512.646 480.962 512.816 480.844C512.986 480.726 513.109 480.553 513.164 480.353C513.182 480.26 513.179 480.165 513.155 480.073C513.131 479.981 513.088 479.896 513.027 479.823C512.967 479.75 512.891 479.692 512.806 479.651C512.72 479.611 512.627 479.59 512.532 479.59C505.817 479.22 499.125 480.658 493.153 483.752C493.064 483.793 492.984 483.851 492.919 483.924C492.853 483.996 492.803 484.082 492.772 484.175C492.741 484.267 492.729 484.366 492.737 484.463C492.745 484.561 492.773 484.656 492.82 484.742C492.917 484.861 493.046 484.95 493.191 484.998C493.337 485.047 493.493 485.053 493.642 485.016Z",
    fill: "#263238"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M511.385 474.222C511.531 474.195 511.667 474.13 511.78 474.034C511.893 473.937 511.979 473.813 512.029 473.673C512.058 473.583 512.066 473.487 512.054 473.393C512.041 473.299 512.008 473.209 511.957 473.13C511.906 473.05 511.838 472.982 511.757 472.932C511.677 472.882 511.586 472.85 511.492 472.838C501.773 471.133 492.531 476.607 492.138 476.845C492.05 476.888 491.972 476.948 491.909 477.022C491.847 477.096 491.8 477.183 491.773 477.276C491.746 477.37 491.739 477.468 491.753 477.564C491.766 477.66 491.8 477.753 491.851 477.835C491.982 477.99 492.164 478.091 492.364 478.12C492.564 478.148 492.768 478.102 492.937 477.99C493.02 477.99 502.012 472.636 511.051 474.234C511.162 474.248 511.275 474.244 511.385 474.222Z",
    fill: "#263238"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M510.519 467.88C510.665 467.852 510.801 467.786 510.913 467.69C511.026 467.594 511.112 467.471 511.163 467.331C511.194 467.243 511.205 467.148 511.195 467.055C511.185 466.962 511.154 466.872 511.105 466.792C511.056 466.712 510.99 466.644 510.911 466.593C510.832 466.542 510.743 466.509 510.65 466.496C499.918 464.445 491.26 470.253 490.89 470.491C490.808 470.541 490.737 470.607 490.681 470.685C490.626 470.763 490.587 470.852 490.566 470.946C490.546 471.04 490.546 471.137 490.564 471.231C490.583 471.325 490.621 471.414 490.675 471.493C490.816 471.64 491.004 471.73 491.206 471.747C491.408 471.765 491.609 471.709 491.773 471.589C491.856 471.589 500.216 465.972 510.173 467.88C510.287 467.904 510.405 467.904 510.519 467.88Z",
    fill: "#263238"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M509.516 460.725C509.66 460.697 509.794 460.633 509.907 460.539C510.019 460.446 510.106 460.325 510.16 460.188C510.19 460.099 510.201 460.004 510.191 459.91C510.181 459.816 510.151 459.726 510.102 459.645C510.053 459.564 509.987 459.495 509.908 459.443C509.829 459.39 509.74 459.356 509.647 459.342C499.618 457.279 490.161 463.301 489.767 463.563C489.682 463.608 489.608 463.671 489.549 463.747C489.49 463.823 489.448 463.911 489.425 464.005C489.403 464.098 489.4 464.195 489.418 464.29C489.436 464.385 489.474 464.474 489.529 464.553C489.661 464.707 489.846 464.805 490.048 464.827C490.249 464.849 490.452 464.794 490.614 464.672C490.709 464.672 499.844 458.805 509.158 460.725C509.276 460.749 509.398 460.749 509.516 460.725Z",
    fill: "#263238"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M497.615 217.446C501.681 270.609 503.47 349.925 503.47 349.925C503.84 353.968 506.141 359.62 508.014 379.524C509.981 400.536 509.91 430.528 509.91 430.528C509.91 430.528 492.153 438.065 481.134 434.142C481.134 434.142 469.28 389.159 463.544 364.414C458.106 341.005 454.111 304.382 454.111 304.382L447.659 339.657C447.659 339.657 448.47 354.814 448.089 365.416C447.647 377.759 440.993 424.983 440.993 424.983C440.993 424.983 424.488 434.869 413.004 425.448C413.004 425.448 407.423 356.126 407.042 341.291C406.302 312.181 405.467 254.939 408.914 217.398L497.615 217.446Z",
    fill: "#37474F"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M454.089 304.381L448.281 266.566C448.281 266.566 434.913 264.527 428.008 257.92C428.008 257.92 432.456 266.685 445.073 270.06L450.869 304.5L447.637 339.668L454.089 304.381Z",
    fill: "#263238"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M510.222 431.507C505.261 435.395 490.819 438.662 480.933 435.085L478.941 426.737C486.395 429.241 501.778 427.655 510.043 422.539L510.222 431.507Z",
    fill: "#455A64"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M440.97 425.96C437.619 429.347 422.116 432.161 412.945 426.795L412.266 418.447C419.218 422.323 435.174 421.655 441.984 417.684L440.97 425.96Z",
    fill: "#455A64"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M502.325 300.447C502.325 300.447 503.864 337.857 503.756 340.576C503.649 343.295 483.316 348.685 482.78 346.956C481.909 344.07 482.124 337.642 480.395 306.648C497.233 304.502 502.325 300.447 502.325 300.447Z",
    fill: "#455A64"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M483.517 317.32C484.145 317.169 484.793 317.113 485.437 317.154C486.177 317.154 486.928 317.154 487.668 317.046C489.244 316.911 490.81 316.668 492.354 316.319C494.099 315.927 495.813 315.409 497.482 314.768C498.853 314.244 500.141 313.576 501.501 313.027C501.632 313.027 501.656 313.23 501.573 313.29C500.235 314.188 498.793 314.921 497.279 315.472C495.897 316.024 494.478 316.482 493.034 316.843C491.496 317.224 489.934 317.499 488.359 317.666C487.564 317.746 486.769 317.805 485.974 317.845C485.149 317.964 484.307 317.887 483.517 317.619C483.422 317.619 483.41 317.356 483.517 317.32Z",
    fill: "#37474F"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M492.164 313.052C492.15 313.214 492.175 313.376 492.237 313.526C492.3 313.675 492.397 313.807 492.522 313.911C492.742 314.042 492.993 314.112 493.249 314.112C493.505 314.112 493.757 314.042 493.977 313.911C494.223 313.774 494.423 313.567 494.553 313.317C494.682 313.067 494.735 312.784 494.704 312.504C494.691 312.339 494.645 312.178 494.567 312.033C494.489 311.887 494.381 311.759 494.251 311.657C493.953 311.446 493.588 311.353 493.225 311.395C492.796 311.395 492.641 311.681 492.45 312.074C492.274 312.371 492.175 312.707 492.164 313.052ZM492.999 312.206C493.164 312.085 493.368 312.029 493.571 312.051C494.203 312.122 494.311 313.124 493.798 313.422C493.632 313.516 493.438 313.548 493.25 313.513C493.063 313.478 492.893 313.379 492.772 313.231C492.693 313.054 492.678 312.854 492.731 312.667C492.783 312.48 492.899 312.316 493.058 312.206H492.999Z",
    fill: "#37474F"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M338.52 153.182C341.513 156.294 344.482 160.885 349.503 166.371C354.523 171.857 362.12 181.29 369.776 187.36C377.432 193.43 381.26 196.017 393.102 186.716C408.14 174.898 423.702 157.57 423.702 157.57L434.829 119.659C423.631 119.874 418.467 123.237 410.024 131.728L379.948 162.173C379.948 162.173 357.469 144.393 354.595 141.662C352.424 139.631 351.007 136.923 350.576 133.982C350.22 131.524 349.714 129.091 349.062 126.695C348.406 124.143 348.155 123.118 347.44 119.993C346.724 116.869 346.569 111.646 346.367 110.453C345.842 109.082 343.981 108.915 341.883 111.789C340.619 113.566 340.452 116.13 340.297 117.751C340.13 119.612 340.368 121.949 339.76 122.164C339.152 122.378 336.719 120.661 334.155 119.647C331.591 118.634 329.385 117.167 326.356 117.62C325.865 117.672 325.391 117.827 324.964 118.076C324.537 118.324 324.167 118.659 323.879 119.06C323.591 119.461 323.391 119.918 323.291 120.401C323.192 120.885 323.196 121.384 323.303 121.866C323.552 122.639 324.005 123.331 324.615 123.869C324.116 123.74 323.596 123.714 323.088 123.794C322.579 123.874 322.092 124.058 321.657 124.334C320.951 124.965 320.486 125.82 320.34 126.755C320.195 127.69 320.378 128.647 320.858 129.462C320.302 129.4 319.741 129.535 319.274 129.845C318.808 130.155 318.465 130.619 318.306 131.155C317.746 132.849 317.686 134.59 319.332 135.532C319.332 135.532 317.841 135.651 317.638 136.486C317.412 137.167 317.365 137.895 317.503 138.599C317.641 139.303 317.959 139.96 318.425 140.505C319.725 141.697 323.196 142.389 323.196 142.389C323.196 142.389 323.363 143.057 324.889 144.154C326.495 145.539 328.201 146.802 329.993 147.934C332.068 149.163 336.135 150.665 338.52 153.182Z",
    fill: "#FFBDA7"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M328.489 139.063C328.493 139.289 328.447 139.513 328.355 139.719C328.262 139.925 328.124 140.108 327.952 140.255C327.499 140.636 327.021 140.987 326.521 141.304C326.285 141.475 326.038 141.63 325.782 141.77C325.534 141.9 325.269 141.992 324.995 142.044L323.194 142.414C323.809 142.541 324.439 142.585 325.066 142.545C325.405 142.534 325.738 142.452 326.044 142.306C326.335 142.172 326.617 142.02 326.891 141.853C327.417 141.491 327.897 141.066 328.322 140.589C328.538 140.316 328.678 139.991 328.727 139.647C328.744 139.433 328.703 139.219 328.608 139.027C329.106 138.964 329.597 138.857 330.075 138.705C330.867 138.543 331.603 138.178 332.209 137.643C332.458 137.315 332.651 136.949 332.782 136.558C332.799 136.428 332.799 136.295 332.782 136.165L333.438 135.461C333.687 137.101 334.329 138.656 335.31 139.993C336.452 141.661 337.988 143.021 339.782 143.952C338.117 142.744 336.827 141.091 336.061 139.182C334.63 136.105 335.584 132.11 336.658 130.154C336.658 130.154 336.741 130.154 336.789 130.154C337.059 130.021 337.286 129.814 337.445 129.558C337.743 129.074 337.849 128.495 337.743 127.936C337.651 127.425 337.474 126.933 337.218 126.481C336.153 124.798 334.54 123.535 332.651 122.904C332.523 122.479 332.33 122.076 332.078 121.711C331.824 121.34 331.533 120.996 331.208 120.686C331.485 121.033 331.733 121.404 331.947 121.795C332.171 122.162 332.329 122.565 332.412 122.987V123.059H332.484C334.239 123.791 335.714 125.066 336.693 126.696C336.932 127.041 337.077 127.441 337.117 127.859C337.157 128.276 337.089 128.697 336.92 129.081C336.634 129.475 336.467 129.57 336.014 129.439C335.56 129.308 335.119 129.141 334.642 129.009C333.688 128.723 332.722 128.568 331.816 128.318C330.904 128.06 330.027 127.691 329.204 127.221C328.369 126.744 327.594 126.171 326.819 125.611C326.017 125.076 325.255 124.482 324.541 123.834C325.858 125.272 327.348 126.542 328.978 127.614C329.804 128.172 330.714 128.594 331.673 128.866C332.627 129.153 333.581 129.32 334.487 129.606L335.036 129.797C335.325 130.127 335.486 130.55 335.489 130.989C335.47 131.374 335.341 131.745 335.117 132.058C334.892 132.371 334.583 132.612 334.225 132.754C333.499 133.119 332.74 133.414 331.959 133.636C331.182 133.842 330.375 133.911 329.574 133.839C328.016 133.353 326.535 132.651 325.173 131.752C323.719 130.941 322.252 130.142 320.749 129.367C322.109 130.333 323.504 131.239 324.911 132.146C325.615 132.599 326.33 133.028 327.058 133.458C327.791 133.914 328.598 134.241 329.443 134.424C329.98 134.46 330.52 134.436 331.053 134.352C331.553 134.546 331.973 134.903 332.245 135.366C332.326 135.507 332.375 135.666 332.388 135.829C332.4 135.992 332.376 136.155 332.317 136.308C332.184 136.627 331.998 136.921 331.768 137.178C331.198 137.595 330.542 137.88 329.848 138.013C329.179 138.247 328.466 138.328 327.761 138.252C327.07 138.028 326.409 137.72 325.794 137.333C325.098 137.006 324.376 136.739 323.635 136.534C322.168 136.105 320.701 135.735 319.223 135.437C320.63 135.986 322.061 136.487 323.468 137.011C324.172 137.286 324.875 137.524 325.531 137.858C326.175 138.303 326.883 138.649 327.63 138.884C327.908 138.978 328.196 139.038 328.489 139.063ZM335.382 130.011C335.382 130.011 335.417 129.999 335.417 130.011H335.382Z",
    fill: "#F0997A"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M433.779 119.051C424.048 119.516 420.16 121.627 410.548 130.284C400.936 138.942 380.139 161.505 380.139 161.505L359.985 146.205C359.985 146.205 361.404 149.329 356.574 156.031C355.322 157.931 353.614 159.488 351.606 160.559C349.598 161.629 347.354 162.18 345.078 162.161C345.078 162.161 357.612 176.722 363.36 182.255C369.108 187.789 375.822 193.31 379.411 193.656C383.001 194.002 385.839 192.857 393.722 187.097C401.604 181.337 433.767 152.287 433.767 152.287L433.779 119.051Z",
    fill: "#37474F"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M496.031 152.968C501.671 150.201 506.978 150.451 508.779 143.427C510.198 137.918 506.859 132.194 506.31 126.994C505.702 121.175 508.803 114.496 505.237 109.857C502.852 106.709 498.177 105.982 495.697 102.929C492.202 98.7311 494.075 92.196 491.702 87.2709C490.699 85.3186 489.081 83.7512 487.097 82.8113C485.114 81.8713 482.876 81.6113 480.73 82.0714C475.781 83.2639 471.405 83.0254 466.766 85.1124C462.127 87.1993 458.072 91.3016 457.44 96.3461C456.736 101.963 460.29 107.46 459.563 113.042C459.122 116.44 457.178 119.422 455.759 122.582C454.339 125.742 453.612 129.582 455.484 132.468C457.357 135.354 461.173 136.224 463.701 138.562C467.744 142.33 467.565 148.806 470.343 153.588C472.192 156.488 475.056 158.594 478.375 159.494C481.695 160.394 485.231 160.023 488.291 158.453C491.022 156.891 493.18 154.375 496.031 152.968Z",
    fill: "#263238"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M447.634 118.717C447.634 118.717 478.425 120.422 486.093 123.916C489.599 125.514 497.291 134.649 495.633 156.616C495.001 165.44 491.436 183.483 491.364 190.102C491.257 199.463 499.533 229.873 499.533 229.873C470.638 247.642 419.562 242.18 409.21 232.676C409.21 232.676 412.728 193.322 413.825 173.168C413.825 173.168 408.28 163.842 408.733 157.57C409.401 148.363 411.321 145.096 419.752 134.792C424.227 129.258 429.038 124.005 434.158 119.063L447.634 118.717Z",
    fill: "#455A64"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M475.306 55.2622C485.239 56.3594 487.648 72.5898 485.287 81.7484C480.744 99.4218 468.818 101.485 468.353 109.022L450.465 98.5513C445.83 95.8402 441.199 93.1252 436.572 90.4062C432.577 88.0212 428.892 85.8388 425.839 82.2135C424.931 81.1645 424.151 80.0116 423.514 78.779C422.27 76.1359 421.747 73.2105 421.999 70.3001C422.596 61.1176 428.284 53.0799 435.463 47.6419C441.08 43.3726 449.618 39.2942 456.929 40.9041C464.788 42.6213 472.944 47.1053 475.306 55.2622Z",
    fill: "#263238"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M467.934 116.081L468.924 99.7072C470.371 100.463 472.033 100.701 473.633 100.382C475.234 100.063 476.678 99.2064 477.725 97.9542C482.614 92.874 483.103 87.3406 480.432 83.7868C477.474 79.8634 470.892 81.4018 468.125 86.1719C463.868 87.1856 462.162 81.1036 465.37 74.8667C465.37 74.8667 444.751 76.2739 435.175 60.5563C432.587 58.1712 428.258 58.6124 426.827 61.8561C425.826 64.2412 424.442 68.0812 425.444 75.9519C425.802 78.8736 424.395 82.3677 424.502 86.315C424.943 101.89 428.485 106.91 432.754 109.534C435.414 111.167 439.838 112.145 444.393 112.157L444.048 116.355C443.964 118.633 443.416 118.74 441.448 118.812L438.49 118.991L444.596 138.572C451.167 130.129 464.321 128.173 477.749 121.745C477.749 121.745 476.437 121.519 472.823 120.994C469.21 120.469 468.232 119.181 467.934 116.081Z",
    fill: "#FFBDA7"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M449.151 94.0684L440.684 96.7993C440.838 97.3662 441.105 97.8961 441.469 98.3573C441.833 98.8184 442.287 99.2013 442.802 99.4831C443.318 99.7648 443.885 99.9395 444.47 99.9968C445.054 100.054 445.645 99.9927 446.205 99.8164C447.345 99.4263 448.289 98.6092 448.838 97.5371C449.388 96.4649 449.5 95.2214 449.151 94.0684Z",
    fill: "#B16668"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M448.624 96.0243C447.492 96.003 446.388 96.3738 445.499 97.0737C444.61 97.7736 443.991 98.7596 443.746 99.8643C444.547 100.108 445.402 100.108 446.203 99.8643C447.01 99.5943 447.726 99.104 448.27 98.4487C448.814 97.7933 449.163 96.999 449.279 96.1555C449.063 96.1007 448.844 96.0569 448.624 96.0243Z",
    fill: "#F28F8F"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M428.329 72.8537L433.934 70.3613C433.789 69.9878 433.57 69.6477 433.29 69.3618C433.009 69.0759 432.674 68.8501 432.303 68.6983C431.933 68.5466 431.535 68.4719 431.135 68.479C430.734 68.486 430.339 68.5747 429.974 68.7395C429.224 69.0819 428.634 69.7005 428.327 70.4668C428.021 71.233 428.021 72.0879 428.329 72.8537Z",
    fill: "#263238"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M434.505 77.6119C434.548 78.2971 434.324 78.9724 433.879 79.4953C433.434 80.0182 432.803 80.3477 432.119 80.4144C431.79 80.4523 431.456 80.4236 431.137 80.3301C430.819 80.2366 430.522 80.0801 430.265 79.8699C430.009 79.6597 429.797 79.4001 429.642 79.1065C429.487 78.8129 429.393 78.4912 429.365 78.1605C429.321 77.4753 429.546 76.8 429.991 76.2771C430.436 75.7542 431.066 75.4247 431.75 75.358C432.079 75.3201 432.413 75.3488 432.732 75.4423C433.05 75.5358 433.347 75.6923 433.604 75.9025C433.861 76.1127 434.073 76.3723 434.227 76.6659C434.382 76.9595 434.476 77.2812 434.505 77.6119Z",
    fill: "#263238"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M455.149 75.1177L449.688 72.1482C449.863 71.7824 450.111 71.4562 450.417 71.1896C450.722 70.9229 451.079 70.7215 451.465 70.5976C451.852 70.4737 452.259 70.4299 452.663 70.4689C453.067 70.5079 453.458 70.6289 453.814 70.8245C454.543 71.2332 455.089 71.9062 455.337 72.7049C455.586 73.5035 455.518 74.3671 455.149 75.1177Z",
    fill: "#263238"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M453.873 78.1594C453.923 78.846 453.7 79.5247 453.254 80.0489C452.808 80.5732 452.174 80.9011 451.488 80.9619C451.159 80.9998 450.825 80.971 450.508 80.8774C450.19 80.7837 449.894 80.6271 449.638 80.4167C449.382 80.2064 449.171 79.9467 449.018 79.6532C448.865 79.3596 448.772 79.0382 448.745 78.708C448.695 78.0214 448.918 77.3427 449.364 76.8185C449.81 76.2942 450.444 75.9663 451.13 75.9055C451.459 75.8693 451.792 75.8993 452.109 75.9936C452.426 76.0879 452.721 76.2447 452.976 76.4547C453.232 76.6647 453.443 76.9237 453.597 77.2165C453.751 77.5092 453.845 77.8298 453.873 78.1594Z",
    fill: "#263238"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M444.132 72.9961L442.308 90.5025L433.781 85.9828L444.132 72.9961Z",
    fill: "#F0997A"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M444.416 112.184C455.697 112.363 462.852 108.237 465.881 101.451C465.881 101.451 464.903 107.831 460.324 111.278C455.196 115.13 444.105 115.285 444.105 115.285L444.416 112.184Z",
    fill: "#F0997A"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M441.469 118.836C427.677 132.702 418.992 150.833 416.831 170.27C415.185 187.204 414.732 257.265 414.732 257.265C414.732 257.265 404.942 257.265 400.422 253.986C403.081 215.145 405.788 177.091 407.696 157.629C408.481 151.33 410.763 145.311 414.351 140.075C419.511 131.954 426.096 124.831 433.789 119.051L441.469 118.836Z",
    fill: "#BA68C8"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M403.441 210.448C407.344 211.504 411.301 212.348 415.295 212.976C415.295 210.973 415.367 208.969 415.414 207.014C411.527 206.359 407.677 205.495 403.883 204.426C403.74 206.382 403.62 208.409 403.441 210.448Z",
    fill: "#FAFAFA"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M415.058 227.942C410.794 227.207 406.577 226.219 402.429 224.984C402.298 227 402.155 229.027 402.012 231.054C406.28 232.272 410.616 233.236 414.998 233.94C414.998 232.008 415.022 229.993 415.058 227.942Z",
    fill: "#FAFAFA"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M468.577 118.693C467.659 133.278 463.294 151.798 463.104 167.587C462.758 196.208 471.618 259.484 471.618 259.484C471.618 259.484 492.166 259.174 505.009 250.147C505.081 243.289 499.261 219.141 496.375 209.147C493.489 199.154 492.38 186.489 496.113 170.557C499.846 154.624 497.174 134.9 489.781 123.797L468.577 118.693Z",
    fill: "#BA68C8"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M468.828 237.888C485.667 236.576 496.316 232.164 501.504 229.373C501.086 227.525 500.693 225.724 500.216 223.852C493.466 227.322 479.525 231.078 468.137 232.092C468.375 234.143 468.602 236.027 468.828 237.888Z",
    fill: "#FAFAFA"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M496.4 209.1C495.97 207.609 495.589 206.059 495.207 204.461C485.649 207.562 475.709 209.331 465.668 209.72C465.859 211.7 466.062 213.679 466.264 215.683C476.613 215.265 486.858 213.452 496.722 210.292C496.638 209.863 496.507 209.47 496.4 209.1Z",
    fill: "#FAFAFA"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M476.749 120.638C475.507 120.004 474.311 119.283 473.171 118.479C470.977 116.977 470.321 115.271 467.984 115.271C466.66 121.377 459.004 127.304 453.113 129.725C447.448 132.05 444.622 138.597 444.622 138.597C444.622 138.597 451.491 132.229 456.023 134.161C460.554 136.093 469.212 141.126 469.212 141.126C469.212 141.126 473.827 134.281 475.354 129.2C476.323 126.452 476.795 123.552 476.749 120.638ZM441.855 127.59C441.319 125.67 443.048 118.646 443.048 118.646C443.048 118.646 444.002 118.646 444.085 116.75C444.085 116.631 444.085 115.76 444.085 115.629C443.859 115.629 443.31 116.082 442.428 116.691C440.921 117.614 439.322 118.377 437.658 118.968C437.658 118.968 429.942 126.481 427.664 134.161C431.933 131.085 436.012 130.488 439.434 132.599C443.763 135.27 444.634 138.562 444.634 138.562C444.932 134.924 442.392 129.51 441.855 127.59Z",
    fill: "#E0E0E0"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M366.727 172.465L433.58 181.635L462.499 259.711L398.722 249.324L366.727 172.465Z",
    fill: "#EBEBEB"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M368.62 173.932L432.707 182.721L460.672 258.208L399.566 248.25L368.56 173.932M366.664 172.465L398.66 249.324L462.437 259.711L433.577 181.671L366.724 172.501L366.664 172.465Z",
    fill: "#E0E0E0"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M425.289 228.752C425.838 230.863 428.867 237.982 436.594 239.556C442.73 240.61 448.989 240.734 455.162 239.926L451.859 230.982L425.289 228.752Z",
    fill: "black"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M387.104 181.79L386.269 179.405C385.804 178.069 389.608 177.556 394.748 178.212L404.586 179.524C409.738 180.215 414.282 181.849 414.735 183.173L415.57 185.558L387.104 181.79Z",
    fill: "black"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M381.473 173.026C381.187 172.191 382.665 171.833 384.86 172.108L388.759 172.692C388.759 172.692 386.982 167.481 395.604 168.327C404.226 169.174 406.79 175.018 406.79 175.018L410.964 175.673C413.266 176.031 415.436 176.985 415.806 177.808L416.462 179.287L382.021 174.517C382.021 174.517 381.771 173.849 381.473 173.026Z",
    fill: "#BA68C8"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M381.473 173.026C381.187 172.191 382.665 171.833 384.86 172.108L388.759 172.692C388.759 172.692 386.982 167.481 395.604 168.327C404.226 169.174 406.79 175.018 406.79 175.018L410.964 175.673C413.266 176.031 415.436 176.985 415.806 177.808L416.462 179.287L382.021 174.517C382.021 174.517 381.771 173.849 381.473 173.026Z",
    fill: "black"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M414.355 183.473C413.973 182.364 410.777 181.088 406.735 180.253L406.603 179.859C406.234 178.667 406.603 177.927 409.072 178.261L409.155 177.295L385.305 174.23L386.402 175.137C389.55 175.495 390.874 175.745 391.577 177.796C391.637 177.963 391.685 178.106 391.732 178.261C388.012 178.047 385.519 178.583 385.901 179.668C386.354 181.004 386.736 182.054 386.736 182.054L415.202 185.846L414.355 183.473Z",
    fill: "#BA68C8"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M414.355 183.473C413.973 182.364 410.777 181.088 406.735 180.253L406.603 179.859C406.234 178.667 406.603 177.927 409.072 178.261L409.155 177.295L385.305 174.23L386.402 175.137C389.55 175.495 390.874 175.745 391.577 177.796C391.637 177.963 391.685 178.106 391.732 178.261C388.012 178.047 385.519 178.583 385.901 179.668C386.354 181.004 386.736 182.054 386.736 182.054L415.202 185.846L414.355 183.473Z",
    fill: "black"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M533.321 201.385C532.428 195.202 530.926 189.122 528.837 183.234L501.79 195.16C501.79 195.16 496.042 198.165 482.876 204.462C475.721 207.872 469.329 210.424 463.092 209.148C461.244 208.767 454.959 207.896 453.087 207.729C451.215 207.562 449.008 207.729 446.969 207.729C445.657 207.729 443.081 207.288 443.081 207.288L445.717 214.443L446.254 214.658C447.923 215.326 446.79 216.53 445.622 217.043C442.205 218.375 438.553 218.996 434.889 218.867C431.268 218.714 427.669 218.239 424.132 217.448C423.515 217.301 422.882 217.237 422.248 217.257C421.931 217.274 421.622 217.36 421.342 217.508C421.062 217.656 420.818 217.864 420.626 218.116C420.416 218.482 420.313 218.9 420.33 219.322C420.347 219.744 420.482 220.153 420.721 220.501C421.208 221.186 421.795 221.793 422.462 222.302C423.132 222.811 423.658 223.485 423.989 224.258C424.382 225.45 423.989 226.774 424.526 227.835C425.181 229.111 426.827 229.445 427.936 230.328C428.81 231.218 429.578 232.207 430.226 233.273C431.479 234.79 433.131 235.925 434.996 236.553C440.172 238.461 445.407 237.924 450.749 237.22C461.924 235.778 470.367 231.472 475.733 229.815C481.099 228.157 487.897 226.953 503.925 222.54C516.983 218.963 520.525 217.639 525.295 215.743C530.983 213.513 534.442 210.376 533.321 201.385Z",
    fill: "#FFBDA7"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M532.214 192.191C529.042 181.912 524.725 168.77 519.907 155.998C517.707 149.568 515.114 143.279 512.144 137.168C507.982 128.546 498.728 126.518 488.889 123.549C486.073 129.038 484.366 135.028 483.867 141.177C483.368 147.326 484.086 153.513 485.979 159.385C489.414 170.225 500.898 194.6 500.898 194.6L479.277 205.786C482.206 208.316 484.578 211.427 486.242 214.921C489.199 220.943 485.538 228.158 485.538 228.158C485.538 228.158 507.302 222.064 515.554 220.108C523.807 218.153 531.367 213.693 533.514 210.401C535.66 207.11 535.398 202.471 532.214 192.191Z",
    fill: "#37474F"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M486.942 77.4928C486.391 80.6083 485.395 83.6285 483.985 86.4606C483.344 85.5236 482.655 84.62 481.922 83.7536C477.655 78.8087 472.543 74.6617 466.824 71.5062C453.635 64.0052 437.011 60.5111 423.309 63.1585C424.024 60.5402 425.07 58.0236 426.421 55.6694C430.22 48.9772 436.263 43.8434 443.481 41.1749C450.699 38.5064 458.628 38.475 465.867 41.0863C473.105 43.6976 479.188 48.7835 483.041 55.4453C486.893 62.1072 488.266 69.9163 486.918 77.4928H486.942Z",
    fill: "#BA68C8"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M475.484 44.0174C473.922 43.0872 465.944 39.9866 465.276 39.7362C461.138 38.1024 454.305 37.6373 446.84 42.8487C441 46.9765 436.653 52.8838 434.449 59.6873L442.976 63.1099L445.731 63.5988C447.269 57.2903 456.821 44.1605 468.723 44.5898C469.282 44.6052 469.84 44.661 470.392 44.7568C471.957 44.9511 473.483 45.3897 474.912 46.0566C476.436 47.3105 477.874 48.6651 479.217 50.1113C479.168 48.861 478.8 47.6441 478.146 46.5771C477.493 45.5102 476.576 44.6288 475.484 44.0174Z",
    fill: "#BA68C8"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M475.484 44.0174C473.922 43.0872 465.944 39.9866 465.276 39.7362C461.138 38.1024 454.305 37.6373 446.84 42.8487C441 46.9765 436.653 52.8838 434.449 59.6873L442.976 63.1099L445.731 63.5988C447.269 57.2903 456.821 44.1605 468.723 44.5898C469.282 44.6052 469.84 44.661 470.392 44.7568C471.957 44.9511 473.483 45.3897 474.912 46.0566C476.436 47.3105 477.874 48.6651 479.217 50.1113C479.168 48.861 478.8 47.6441 478.146 46.5771C477.493 45.5102 476.576 44.6288 475.484 44.0174Z",
    fill: "white"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M445.692 63.6112C447.492 56.2652 460.264 39.522 474.861 46.0452C476.39 47.2982 477.832 48.6528 479.178 50.0998C479.129 48.854 478.763 47.6413 478.117 46.5754C477.47 45.5094 476.563 44.6253 475.481 44.0059C471.713 41.8236 463.961 40.2733 455.315 46.2837C449.494 50.4202 445.165 56.3262 442.973 63.1223L445.692 63.6112Z",
    fill: "#BA68C8"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M445.692 63.6112C447.492 56.2652 460.264 39.522 474.861 46.0452C476.39 47.2982 477.832 48.6528 479.178 50.0998C479.129 48.854 478.763 47.6413 478.117 46.5754C477.47 45.5094 476.563 44.6253 475.481 44.0059C471.713 41.8236 463.961 40.2733 455.315 46.2837C449.494 50.4202 445.165 56.3262 442.973 63.1223L445.692 63.6112Z",
    fill: "black"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M467.29 68.9637C466.706 68.3555 464.201 61.5819 453.838 54.9395C447.446 50.8491 433.78 49.5731 427.602 49.1796C416.869 48.4998 414.091 50.5748 413.829 52.149C413.829 52.5187 413.483 54.2479 413.399 54.6414C413.327 54.9934 413.378 55.3595 413.542 55.6789C414.961 58.2428 423.297 63.1561 423.297 63.1561C437.023 60.5087 453.623 64.0028 466.813 71.5038L467.29 68.9637Z",
    fill: "#BA68C8"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M467.29 68.9637C466.706 68.3555 464.201 61.5819 453.838 54.9395C447.446 50.8491 433.78 49.5731 427.602 49.1796C416.869 48.4998 414.091 50.5748 413.829 52.149C413.829 52.5187 413.483 54.2479 413.399 54.6414C413.327 54.9934 413.378 55.3595 413.542 55.6789C414.961 58.2428 423.297 63.1561 423.297 63.1561C437.023 60.5087 453.623 64.0028 466.813 71.5038L467.29 68.9637Z",
    fill: "black"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M466.823 71.5047C453.634 64.0037 437.01 60.5095 423.307 63.157C423.307 63.157 414.96 58.2437 413.552 55.6798C412.801 54.2606 413.851 50.9096 427.159 51.7205C433.313 52.1141 446.979 53.3782 453.395 57.4805C463.746 64.1229 466.251 70.8965 466.823 71.5047Z",
    fill: "#BA68C8"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M466.823 71.5047C453.634 64.0037 437.01 60.5095 423.307 63.157C423.307 63.157 414.96 58.2437 413.552 55.6798C412.801 54.2606 413.851 50.9096 427.159 51.7205C433.313 52.1141 446.979 53.3782 453.395 57.4805C463.746 64.1229 466.251 70.8965 466.823 71.5047Z",
    fill: "black"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M385.124 52.5902C391.145 55.6874 395.759 60.9626 398.028 67.3419L398.886 70.2755C400.398 76.7975 399.401 83.6493 396.096 89.4709C392.79 95.2925 387.416 99.6584 381.041 101.702C374.665 103.745 367.755 103.317 361.681 100.502C355.607 97.6871 350.813 92.6912 348.251 86.5059L347.249 83.62C345.828 78.6169 345.901 73.3076 347.458 68.3452C349.015 63.3827 351.988 58.9836 356.013 55.6891C360.037 52.3946 364.937 50.3482 370.109 49.8019C375.281 49.2556 380.5 50.233 385.124 52.6141V52.5902Z",
    fill: "white"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M347.154 63.0719C343.877 69.5206 343.132 76.9624 345.066 83.9326C347 90.9029 351.474 96.8966 357.605 100.734C363.737 104.572 371.083 105.975 378.198 104.668C385.313 103.361 391.68 99.4387 396.048 93.6724L404.992 94.6145C405.33 94.6526 405.672 94.5872 405.973 94.4267C406.273 94.2663 406.518 94.0184 406.674 93.7159C406.83 93.4134 406.891 93.0706 406.849 92.7328C406.806 92.3949 406.662 92.078 406.435 91.8239L400.472 85.098C402.679 78.1771 402.204 70.6794 399.142 64.0923C396.079 57.5052 390.652 52.3101 383.937 49.5376C377.223 46.765 369.711 46.6176 362.893 49.1247C356.075 51.6317 350.449 56.61 347.13 63.0719H347.154ZM385.124 52.5895C391.145 55.6867 395.759 60.9618 398.027 67.3412L398.886 70.2748C400.397 76.7967 399.401 83.6485 396.096 89.4702C392.79 95.2918 387.416 99.6577 381.041 101.701C374.665 103.745 367.755 103.316 361.681 100.501C355.606 97.6864 350.813 92.6905 348.251 86.5052L347.249 83.6193C345.828 78.6162 345.901 73.3069 347.458 68.3444C349.015 63.382 351.988 58.9829 356.013 55.6884C360.037 52.3938 364.937 50.3475 370.109 49.8012C375.281 49.2548 380.5 50.2323 385.124 52.6134V52.5895Z",
    fill: "#E0E0E0"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M347.154 63.0719C343.877 69.5206 343.132 76.9624 345.066 83.9326C347 90.9029 351.474 96.8966 357.605 100.734C363.737 104.572 371.083 105.975 378.198 104.668C385.313 103.361 391.68 99.4387 396.048 93.6724L404.992 94.6145C405.33 94.6526 405.672 94.5872 405.973 94.4267C406.273 94.2663 406.518 94.0184 406.674 93.7159C406.83 93.4134 406.891 93.0706 406.849 92.7328C406.806 92.3949 406.662 92.078 406.435 91.8239L400.472 85.098C402.679 78.1771 402.204 70.6794 399.142 64.0923C396.079 57.5052 390.652 52.3101 383.937 49.5376C377.223 46.765 369.711 46.6176 362.893 49.1247C356.075 51.6317 350.449 56.61 347.13 63.0719H347.154ZM385.124 52.5895C391.145 55.6867 395.759 60.9618 398.027 67.3412L398.886 70.2748C400.397 76.7967 399.401 83.6485 396.096 89.4702C392.79 95.2918 387.416 99.6577 381.041 101.701C374.665 103.745 367.755 103.316 361.681 100.501C355.606 97.6864 350.813 92.6905 348.251 86.5052L347.249 83.6193C345.828 78.6162 345.901 73.3069 347.458 68.3444C349.015 63.382 351.988 58.9829 356.013 55.6884C360.037 52.3938 364.937 50.3475 370.109 49.8012C375.281 49.2548 380.5 50.2323 385.124 52.6134V52.5895Z",
    fill: "black"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M385.124 52.5902C391.145 55.6874 395.759 60.9626 398.028 67.3419L398.886 70.2755C400.398 76.7975 399.401 83.6493 396.096 89.4709C392.79 95.2925 387.416 99.6584 381.041 101.702C374.665 103.745 367.755 103.317 361.681 100.502C355.607 97.6871 350.813 92.6912 348.251 86.5059L347.249 83.62C345.828 78.6169 345.901 73.3076 347.458 68.3452C349.015 63.3827 351.988 58.9836 356.013 55.6891C360.037 52.3946 364.937 50.3482 370.109 49.8019C375.281 49.2556 380.5 50.233 385.124 52.6141V52.5902Z",
    fill: "white"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M369.177 90.4295C368.652 90.4319 368.131 90.3274 367.647 90.1224C367.164 89.9174 366.726 89.6162 366.363 89.237L357.633 79.9114C357.278 79.5444 356.998 79.1103 356.812 78.6344C356.626 78.1584 356.536 77.6501 356.548 77.1392C356.56 76.6282 356.674 76.1247 356.882 75.6581C357.091 75.1915 357.39 74.771 357.763 74.4213C358.136 74.0715 358.574 73.7994 359.053 73.6208C359.532 73.4423 360.042 73.3608 360.552 73.3812C361.063 73.4016 361.565 73.5234 362.028 73.7396C362.491 73.9558 362.907 74.262 363.25 74.6403L368.927 80.6984L382.343 63.7048C382.985 62.932 383.903 62.4407 384.903 62.3356C385.902 62.2305 386.902 62.52 387.691 63.1423C388.48 63.7646 388.994 64.6705 389.125 65.6667C389.255 66.6629 388.991 67.6707 388.389 68.4749L372.194 88.9866C371.851 89.4228 371.418 89.7798 370.924 90.033C370.43 90.2861 369.887 90.4295 369.332 90.4534L369.177 90.4295Z",
    fill: "#455A64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e9a93c2cbd3fc7bf356e98c273402505.svg";
export { ForwardRef as ReactComponent };